export const pt = {
  Enums: {
    ProcessType: {
      MassCommand: 'Comando em Massa',
      MassMeterRegistration: 'Importação em Massa de Medidores',
      MassMeterEdit: 'Edição em Massa de Medidores',
      ExportBillings: 'Faturamento de Leituras',
      ScheduleRecoverMassMemorySmc: 'Agendamento de Recuperação de Memória de Massa SMC',
      ScheduledCommand: 'Comando Agendado',
    },
    AccountStatus: {
      DISABLED: 'Desconectado',
      ACTIVATED: 'Conectado',
      NO_RELE: 'Sem Relé',
      NO_INFORMATION: 'Sem Informação',
      ALL: 'Todos',
    },
    TicketStatus: {
      Cancelled: 'Cancelado',
      CommandTimeOutReached: 'Excedeu Tempo de Execução',
      Executing: 'Executando',
      Failed: 'Falhou',
      FailedToContinue: 'Erro durante o processamento',
      FailedToStart: 'Falha ao inicializar',
      Finished: 'Finalizado',
      Success: 'Sucesso',
      Interupted: 'Interrompido',
      MiddleWareOffline: 'MiddleWare Offline ou Indisponível',
      MiddlewareNotResponding: 'Sem resposta do MiddleWare',
      PartiallyFinished: 'Finalizado Parcialmente',
      Waiting: 'Aguardando',
      WaitingScheduleDateTime: 'Aguardando data e hora programada',
      SystemTimeout: 'Atingiu Tempo Máximo do Sistema',
      Timeout: 'Excedeu Tempo de Requisição',
      OutsideAllowedTime: 'Fora de Horário Permitido',
    },
    StatusCommand: {
      DATA_BLOCK_UNAVAILABLE: 'Bloco de dados não disponivel',
      DAT_BLOCK_NUMBER_INVALID: 'Número de bloco Invalido',
      HARDWARE_FAULT: 'Falha de Hardware',
      INCOMPLETE: 'Incompleto',
      INCORRECT_KEYS: 'Chaves Incorretas',
      INTERRUPTED_BY_COMMISSIONING: 'Interrompido por causa do comissionamento',
      INVALID_ITEM: 'Item inválido',
      LONG_GET_ABORTED: 'Requisão DLMS Longa Interrompida',
      LONG_SET_ABORTED: 'Definição DLMS Longa Interrompida',
      METERS_NOT_MATCH_WITH_RECEIVED: 'Lista de medidores inválida',
      NO_LONG_GET_IN_PROGRESS: 'Nenhuma Requisição DLMS Longa em progresso',
      NO_LONG_SET_IN_PROGRESS: 'Nenhum Definição DLMS Longa em progresso',
      OBJECT_CLASS_INCONSISTENT: 'Classe do Objeto Inconsistente',
      OBJECT_UNAVAILABLE: 'Objeto não disponível',
      OBJECT_UNDEFINED: 'Objeto Indefinido',
      OPEN_DOOR: 'Porta Aberta',
      OTHER_REASON: 'Outros Motivos',
      READ_WRITE_DENIED: 'Leitura ou Escrita Negado',
      SCOPE_OF_ACCESS_VIOLATED: 'Violação do Escopo de Acesso',
      SET_INTERVAL_OF_LONG_OUT_VOLTAGE: 'Configuração do Intervalo de Captura de Interrupção Longa',
      SET_INTERVAL_OF_QEE: 'Configuração do Intervalo de Captura de DRP/DRC',
      SET_STANDARD_FROZEN_DATA: 'Configuração do Template de Energia padrão',
      SUCESS: 'Executado com Sucesso',
      TEMPORARY_FAILURE: 'Falha Temporaria',
      TIMEOUT: 'Atingiu Tempo Máximo de Execução',
      SYSTEMTIMEOUT: 'Atingiu Tempo Máximo do Sistema',
      TYPE_UNMATCHED: 'Tipo Inconsistente',
      WAITING: 'Aguardando Resposta',
      EXECUTING: 'Executando',
      NO_COMISSIONED: 'Comissão não registrada',
      SCHEDULED: 'Agendado',
      SENT: 'Enviado',
      FINISHED: 'Finalizado',
      CANCELLED: 'Cancelado',
      SUCCESS: 'Executado com Sucesso',
      COMMUNICATIONERROR: 'Erro de comunicação',
      EXECUTIONERROR: 'Erro de execução',
      INTERNALERROR: 'Erro interno',
      INVALID_METERS: 'Medidor(es) inválido(s)',
      ACKNOWLEDGMENT: 'Reconhecimento Simples',
      INVALID_SCHEMA: 'Formato de Requisição Inválida',
      DATA_UNAVAILABLE: 'Dados Indisponíveis',
      NOT_SUPPORTED: 'Funcionalidade Não Suportada',
      INVALIDMETER: 'Medidor Inválido',
      CUT_AT_IMPROPER_TIME: 'Fora de Horário Permitido',
    },
    CommandType: {
      DisableCollectiveCut: 'Autorizar Abertura de Portas',
      EnableCollectiveCut: 'Desativar Abertura de Porta',
      GetQEEIndicator: 'Solicitar parâmetros de qualidade',
      GetVoltageOutLong: 'Obter Alarme de Interrupção Longa',
      GetVoltageOutShort: 'Obter Alarme de Interrupção Curta',
      ImportFrozenData: 'Importar Totalizadores de Energia',
      ImportMassMemory: 'Importar Memória de Massa',
      ImportQEEIndicator: 'Importar Parâmetros de Qualidade',
      ImportVoltageOutAlarm: 'Importar Alarmes de Interrupção',
      InstantMeasure: 'Requisitar Energia Instantânea',
      ListMetersSmcSerial: 'Requisitar Medidores do SMC',
      MarkAlarmAsRead: 'Marcar Alarme Como Lido',
      MeterAddedToSmc: 'Adicionar medidor ao smc (Sistema)',
      MeterRemovedFromSmc: 'Remover medidor do smc (Sistema)',
      NicReset: 'Reset da NIC',
      RecoverEventQeeIndicator: 'Recuperar indicadores de qualidade',
      RecoverFrozenData: 'Recuperar Totalizadores de Energia',
      RecoverGbtMessage: 'GBT',
      RecoverMassMemory: 'Recuperar Memória de Massa',
      RelayOff: 'Desconectar o Relé',
      RelayOn: 'Conectar o Relé',
      RelayOnAllMetersOfSmc: 'Religar Todos os Clientes',
      RelayStatus: 'Obter estado do Relé',
      SmiInfoRequest: 'Obter informações do medidor',
      RequestDoorStatus: 'Obter Status do Corte Coletivo',
      RequestRelayStatusAllSmc: 'Requisitar Estado do Relé de Todos os Medidores',
      Rollback: 'Rollback',
      SendKeyAk: 'Envio de Chaves de autenticação para os medidores',
      SendKeyEk: 'Envio de Chaves de criptografia para os medidores',
      GetCellIDAndIP: 'Obter Cell ID e IP',
      SetDatetime: 'Setar Data e Hora do SMC',
      SetIntervalOLongOutEvent: 'Configuração do Intervalo de Captura de Interrupção Longa',
      SetIntervalOfQee: 'Configuração do Intervalo de Captura de DRP/DRC',
      SetStandardFrozenData: 'Configuração do Template de Energia padrão',
      Set_Current: 'Modificar corrente de corte',
      UpdateDateTime: 'Atualizar Data e Hora',
      ReadDateTime: 'Ler Data e Hora',
      UplinkPeriod: 'Alterar Periodo de Leitura de Uplink',
      DoorStatusAbsolute: 'Obter estado da porta',
      SetSmiVoltage: 'Setar tensão de referência',
      SetDisplayConfiguration: 'Setar Configuração de Display Auto',
      SetDisplayConfigurationManual: 'Setar Configuração de Display Manual',
      SetDisplayConfigurationMicromax: 'Setar Configuração de Display Auto MicroMax',
      SetDisplayConfigurationManualMicromax: 'Setar Configuração de Display Manual MicroMax',
      GetSmiVoltage: 'Obter tensão de referência',
      MeterRecoverEventQeeIndicator: 'Recuperar Parâmetros de Qualidade',
      SetQualityMeasureParams: 'Configurar Parâmetros de Qualidade',
      GetQeeBuffer: 'Obter buffer Qee',
      GetEnergyTotalizer: 'Solicitar Energia Ativa Direta',
      MassRegistration: 'Cadastro em Massa',
      MassEdit: 'Edição em Massa',
      ChangeNetworkType: 'Mudar tipo de rede',
      GetNetworkType: 'Obter tipo de rede',
      GetNetworkInfo: 'Obter tipo de tecnologia',
      GetHeartBeatCommand: 'Recuperar qualidade de sinal',
      ChangeNetworkTech: 'Mudar tipo de tecnologia',
      GetDaylightSavingsEnabled: 'Obter status horário de verão',
      GetDaylightSavingsEnd: 'Obter final horário de verão',
      GetDaylightSavingsDeviation: 'Obter alteração horário de verão',
      GetDaylightSavingsBegin: 'Obter início horário de verão',
      GetSpecialDaysTable: 'Obter feriados',
      SetSpecialDaysTable: 'Adicionar feriados',
      DeleteSpecialDays: 'Apagar feriados',
      GetDmrcSwitch: 'Requisitar switch DMRC e UFER',
      SetDmrcSwitch: 'Setar switch DMRC e UFER',
      SetDayPassiveActivityCalendar: 'Adicionar dia calendário passivo',
      SetWeekPassiveActivityCalendar: 'Adicionar semana calendário passivo',
      ActivatePassiveTimeCalendarActivityCalendar: 'Adicionar tempo para ativação',
      SetDayProfilePassiveCalendarActivityCalendar: 'Adicionar dia calendário passivo DMRC',
      DrmcSetWeekProfilePassiveCalendarActivityCalendar: 'Adicionar semana calendário passivo DMRC',
      DrmcGetDayProfilePassiveActivityCalendar: 'Requisitar dias do calendário passivo DMRC',
      DrmcGetActivatePassiveTimeCalendarActivityCalendar:
        'Requisitar tempo de ativação calendário passivo DMRC',
      GetActivatePassiveTimeCalendarActivityCalendar:
        'Requisitar tempo de ativação calendário passivo',
      GetWeekProfilePassiveActivityCalendar: 'Requisitar semana do calendário passivo',
      GetWeekProfileActiveActivityCalendar: 'Requisitar semana do calendário ativo',
      GetDayProfileActiveActivityCalendar: 'Requisitar dias do calendário ativo',
      GetDayProfilePassiveActivityCalendar: 'Requisitar dias do calendário passivo',
      DrmcGetWeekProfileActiveActivityCalendar: 'Requisitar semana do calendário ativo DMRC',
      DrmcGetWeekProfilePassiveActivityCalendar: 'Requisitar semana do calendário passivo DMRC',
      DrmcGetDayProfileActiveActivityCalendar: 'Requisitar dias do calendário ativo DMRC',
      DrmcActivatePassiveTimeCalendarActivityCalendar: 'Adicionar tempo para ativação DMRC',
      SetActivatePassiveCalendarActivityCalendar: 'Definir status de perfil DMRC',
      ActivatePassiveCalendarActivityCalendar: 'Definir status de perfil',
      SetDaylightSavingsEnabled: 'Definir status horário de verão',
      SetDaylightSavingsDeviation: 'Definir alteração horário de verão',
      SetDaylightSavingsBegin: 'Definir início horário de verão',
      SetDaylightSavingsEnd: 'Definir final horário de verão',
      GetTaxPage: 'Recuperar Página Fiscal',
      GetDemandRegisters: 'Recuperar registradores',
      GetGeneralReadingValues: 'Recuperar leituras',
      DeactivateMeter: 'Desativar medidor',
      AddMeterToGateway: 'Adicionar Medidor ao Gateway',
      RemoveMeterFromGateway: 'Remover Medidor ao Gateway',
      ListMetersFromGateway: 'Listar Medidores da Gateway',
      ReadDisplayConfiguration: 'Leitura da Configuração de Display',
      ReadDatetime: 'Leitura de Data e Hora',
      GetDailyBilling: 'Recuperar Faturamento Diário',
      GetLoadProfile: 'Recuperar Perfil de Carga',
      GetFiscalPage: 'Recuperar Página Fiscal',
      ReprocessBilling: 'Reprocessar Faturamento',
      ReprocessCutRelay: 'Reprocessar Corte/Religa',
      ReprocessDetailUc: 'Reprocessar Detalhes da Unidade Consumidora',
      VoltageInterruptionMonthly: 'Obter Interrupção de Tensão Mensal',
      DrpDrcMonthly: 'Solicitar DRP/DRC Mensal',
      DrpDrcCycle: 'Solicitar Ciclo DRP/DRC ',
      SetTariffConfiguration: 'Definir Tipo de Tarifa',
      DeviceReset: 'Reinicialização de dispositivo',
      RecoverMonitoring: 'Perfil de Carga(Energia + Memória de Massa)',
      InfoRequest: 'Ler informações gerais',
      RequestConfiguration: 'Ler configurações',
      GetBlockSize: 'Obter Tamanho do Bloco',
      ImageTransferInitiate: 'Iniciar Transferência de Imagem',
      ImageTransferData: 'Dados de Transferência de Imagem',
      GetFirstBlockNotTransferred: 'Obter Primeiro Bloco Não Transferido',
      ImageTransferVerify: 'Verificar Transferência de Imagem',
      ImageTransferActivate: 'Ativar Transferência de Imagem',
      UpdateFirmware: 'Atualizar Firmware',
      UploadFirmware: 'Carregar Firmware',
      GetHardwareInfo: 'Obter Informações de Hardware',
      ReadNicInfo: 'Ler Informações do NIC',
      ReadNicSetup: 'Ler Configuração do NIC',
      ReadRelay: 'Ler Relé',
      ReadTimestamp: 'Ler Timestamp',
      ReadNicData: 'Ler Dados do NIC',
      NicSetup: 'Configuração do NIC',
      ReadLdrUpper: 'Ler LDR Superior',
      ReadLdrBottom: 'Ler LDR Inferior',
      ReadLdrMin: 'Ler LDR Mínimo',
      SetLdrUpper: 'Definir LDR Superior',
      SetLdrBottom: 'Definir LDR Inferior',
      SetLdrMin: 'Definir LDR Mínimo',
      ReadNicSerial: 'Ler Serial do NIC',
      ReadRelayWithLastSwitchOn: 'Ler Relé com Último Acionamento',
      ReadRelayWithLastSwitchOnAndOff: 'Ler Relé com Último Acionamento e Desligamento',
      SetBlockSize: 'Definir Tamanho do Bloco',
      MulticastGroupSetup: 'Configuração de Grupo Multicast',
      MulticastClassCSession: 'Sessão Multicast Classe C',
      MulticastSetupConfirmation: 'Confirmação de Configuração Multicast',
      ImageTransferStatus: 'Status da Transferência de Imagem',
      GetFirmwareVersion: 'Obter Versão do Firmware',
      ReadAlarmFakeOnOff: 'Ler Alarme Falso On/Off',
      ConfigureApplicationGroup: 'Configurar Grupo de Aplicação',
      ReadALarmLastGasp: 'Ler Alarme de Último Suspiro',
      SetLastGaspVoltageLevel: 'Definir Nível de Tensão de Último Suspiro',
      ReadAlarmVoltageMonitor: 'Ler Monitor de Tensão de Alarme',
      SetVoltageMinimalInterval: 'Definir Intervalo Mínimo de Tensão',
      SetAlarmFakeOnOffThreshold: 'Definir Limite de Alarme Falso On/Off',
      ReadTemperatureValue: 'Ler Valor da Temperatura',
      ReadRelayWithDelay: 'Ler Relé com Atraso',
      DeviceCreated: 'Dispositivo criado',
      DeviceUpdated: 'Dispositivo atualizado',
      ScheduleCreated: 'Agendamento criado',
      scheduleUpdated: 'Agendamento atualizado',
      groupCreated: 'Grupo criado',
      groupUpdated: 'Grupo atualizado',
      setAlarmFakeOnOff: 'Alarme On/Off',
      scheduleCanceled: 'Agendamento cancelado',
      scheduleDeleted: 'Agendamento excluido',
      deviceDeleted: 'Dispositivo excluido',
      groupDeleted: 'Grupo excluido',
      checkScheduleStatus: 'Checar Status de Agendamento',
      activateSchedule: 'Ativar agendamento',
      deactivateSchedule: 'Desativar agendamento',
      checkScheduleExist: 'Checar se agendamento existe',
      readDeviceType: 'Ler tipo de dispositivo',
      writeDeviceRole: 'Atribuir tipo de dispositivo',
      fullScheduleCommand: 'Comando completo de agendamento',
      scheduleCreatedOnSystem: 'Agendamento criado (Sistema)',
      activateScheduleOnSystem: 'Ativar agendamento (Sistema)',
      checkScheduleStatusOnSystem: 'Checar Status de Agendamento (Sistema)',
      writeDeviceRoleOnSystem: 'Atribuir tipos de dispositivo (Sistema)',
      deactivateScheduleOnSystem: 'Desativar agendamento (Sistema)',
      checkScheduleExistOnSystem: 'Checar se agendamento existe (Sistema)',
      readDeviceTypeOnSystem: 'Ler tipo de dispositivo (Sistema)',
      setDatetimeOnSystem: 'Atualizar Data e Hora (Sistema)',
      periodicConfiguration: 'Configuração da Periodicidade',
      decommissioning: 'Descomissionamento',
      openSession: 'Abrir Sessão com Medidor',
      readMeterSerial: 'Ler Serial do Medidor',
      importMassMeters: 'Importar medidores em massa',
      saveConfig: 'Salvar configuração',
      readConfig: 'Ler configuração',
      saveTime: 'Salvar datetime',
      timeCorrection: 'Correção do time',
      storage: 'Armazenamento',
      fuotaPause: 'Pausa da atualização de firmware',
      deleteSpecialDays: 'Apagar feriados',
      getTotalizers: 'Ler totalizadores',
      getRelayStatusControl: 'Ler Status de Controle do Relé',
      setRelayStatusControl: 'Alterar Status de Controle do Relé',
      getIntegrationInstantaneousReadings: 'Ler valores instantâneos',
      getVoltageOutLongShort: 'Obter Alarme Voltage Out Long e short',
      relayStatusOrca: 'Recuperar estado do relé orca',
      getQeeOnDemand: 'Solicitar parâmetros de qualidade por demanda',
      getQeeHistoricalData: 'Solicitar o histórico de leitura de dados dos parâmetros de qualidade',
      getLoadProfile: 'Ler dados de Memória de massa',
      getDailyBilling: 'Ler dados de Energia',
      recoverFragmentedPacket: 'Recuperar dados fragmentados',
      drpDrcEventLog: 'DRP and DRC Event Log',
      readTariffPeriods: 'Get Tariff Reading',
      smartFuseAlarmAck: 'Alarme Ack',
      SetInterval: 'Alterar Período de Envio',
      SetBroker: 'Alterar Broker MQTT',
      SetWifi: 'Alterar Rede WIFI',
      ImportAlarms: 'Importar Alarmes',
    },
    ServiceTypeEquatorial: {
      TurnOnPower: 'Religa',
      TurnOffPower: 'Corte',
      RequestRead: 'Requisição de Leitura',
      RequestNoteLq: 'Requisição de QEE',
    },
    RequestStatusEquatorial: {
      Waiting: 'Aguardando',
      Processing: 'Processando',
      Running: 'Em Execução',
      CommunicationWithMDCFailed: 'Falha na Comunicação com MDC',
      InternalFailure: 'Falha Interna',
      MDCTicketFinalized: 'Ticket MDC Finalizado',
      MDCTicketFailed: 'Ticket MDC Falhou',
      FinishedWithSuccess: 'Finalizado com Sucesso',
      FinishedWithFailure: 'Finalizado com Falha',
      Cancelled: 'Cancelado',
    },
    CommandStatus: {
      CHANGING_COLLECTIVE_CUT_ALARM: 'Alterando o status de corte Coletivo',
      CHANGING_RELAY_STATUS: 'Alterando Estado do Relé',
      GBT: 'GBT',
      GET_QEE_INDICATORS: 'Solicitando parâmetros de qualidade',
      INSTANT_MEASURE: 'Solicitando medida Instantânea',
      MARK_ALARM_AS_READ: 'Marcando Alarme Como Lido',
      NIC_RESET: 'Reset da NIC',
      RECOVER_EVENT_QEE_INDICATOR: 'Recuperando parâmetros de qualidade',
      RECOVER_FROZEN_DATA: 'Recuperando Totalizadores de Energia',
      RECOVER_MASS_MEMORY: 'Recuperando Memória de Massa',
      REGISTERING_DATETIME: 'Registrando Data e Hora',
      REGISTERING_KEYS: 'Registrando Chaves',
      RELAY_ON_ALL_METERS_SMC: 'Religando todos os clientes',
      REQUESTING_DATE: 'Requisitando Data',
      REQUESTING_RELAY_STATUS: 'Requisitando Estado do Relé',
      REQUESTING_RELAY_STATUS_ALL_SMC: 'Requisitando status dos relés',
      REQUESTING_SERIAL: 'Requisitando Serial',
      REQUEST_DOOR_STATUS: 'Obtendo Status do corte coletivo',
      ROLLBACK: 'Executando RollBack!',
      SET_CURRENT: 'Modificando corrente de corte',
      SET_INTERVAL_OF_LONG_OUT_VOLTAGE: 'Configurando Intervalo de Captura de Interrupção Longa',
      SET_INTERVAL_OF_QEE: 'Configurando Intervalo de Captura de DRP/DRC',
      SET_STANDARD_FROZEN_DATA: 'Configurando Template de Energia padrão',
      UPLINK_PERIOD: 'Alterando Período de Uplink de leitura',
      WAITING_COMMAND: 'Aguardando Comando',
      SET_SMI_VOLTAGE: 'Configurando tensão de referência',
      GET_VOLTAGE: 'Solicitando tensão de referência',
      DOOR_STATUS_ABSOLUTE: 'Obtendo estado da porta',
      SET_DISPLAY_CONFIGURATION: 'Configurando display auto',
      SET_DISPLAY_CONFIGURATION_MANUAL: 'Configurando display manual',
      METER_SET_QUALITY_MEASURE_PARAMS: 'Recuperando Parâmetros de Qualidade',
      METER_RECONVER_EVENT_QEE_INDICATOR: 'Recuperando Parâmetros de Qualidade',
      GET_QEE_BUFFER: 'Obtendo tamanho do Buffer Qee',
      GET_ENERGY_TOTALIZER: 'Obtendo Energia Ativa Direta',
      CHANGING_NETWORK_TYPE: 'Mudando tipo de Rede',
      GETTING_NETWORK_TYPE: 'Obtendo tipo de Rede',
    },
    ComunicationStatus: {
      BUSY: 'Ocupado',
      COMMUNICATION_FAILED: 'Falha de Comunicação',
      NO_INFORMATION: 'Sem Informação',
      SUCCESS: 'Sucesso',
    },
    tariffsType: {
      tariff: 'Tipo de Tarifa',
      IRRIGANTE: 'Irrigante',
      TARIFA_BRANCA: 'Tarifa Branca',
      GD: 'Geração Distribuída',
      IRRIGANTE_GD: 'Irrigante Geração Distribuída',
      TARIFA_BRANCA_GD: 'Tarifa Branca Geração Distribuída',
      CONVENCIONAL: 'Convencional',
      CONVENCIONAL_GD: 'Convencional Geração Distribuída',
      MMGD: 'MMGD',
      REN871: 'REN871',
      GRUPO_B_IRRIGANTE: 'Grupo B Irrigante',
      GRUPO_A: 'Grupo A',
      CLIENTE_LIVRE: 'Cliente Livre',
      TARIFA_BRANCA_MMGD: 'Tarifa Branca + MMGD',
      TARIFA_BRANCA_MMGD_IRRIGANTE: 'Tarifa Branca + MMGD + Irrigante',
      GRUPO_A_IRRIGANTE: 'Grupo A Irrigante',
    },
    MeterTypes: {
      Integration: 'Integração',
      IntegrationDcu: 'Integração Wasion DCU',
      Nepen: 'Integração MDX',
    },
    CceeIntegrationMethod: {
      placeholder: 'Selecione o método de integração CCEE',
      None: 'Nenhum',
      Soap: 'SOAP',
      Rest: 'REST',
    },
    AlarmDescription: {
      POWER_RESTORE: 'Energia restaurada',
      TERMINAL_COVER_REMOVED_START: 'Início de remoção da tampa de terminais',
      TERMINAL_COVER_REMOVED_END: 'Fim de remoção da tampa de terminais',
      CURRENT_REVERSAL_L1_START: 'Início de inversão de corrente L1',
      CURRENT_REVERSAL_L1_END: 'Fim de inversão de corrente L1',
      MAGNETIC_FIELD_DETECTION_START: 'Início de detecção de campo magnético',
      MAGNETIC_FIELD_DETECTION_END: 'Fim de detecção de campo magnético',
      METER_COVER_OPEN: 'Tampa do medidor aberta',
      METER_COVER_CLOSE: 'Tampa do medidor fechada',
      METER_AUTHENTICATION_FAILS: 'Falha de autenticação do medidor',
      PRESENCE_OF_VOLTAGE_AT_LOAD_SIDE_START: 'Início de presença de tensão no lado da carga',
      PRESENCE_OF_VOLTAGE_AT_LOAD_SIDE_END: 'Fim de presença de tensão no lado da carga',
      FIRMWARE_UPGRADE: 'Atualização de firmware',
      DISCONNECT: 'Desconexão',
      CONNECT: 'Conexão',
      CURRENT_REVERSAL_L2_START: 'Início de inversão de corrente L2',
      CURRENT_REVERSAL_L2_END: 'Fim de inversão de corrente L2',
      CURRENT_REVERSAL_L3_START: 'Início de inversão de corrente L3',
      CURRENT_REVERSAL_L3_END: 'Fim de inversão de corrente L3',
      MISSING_VOLTAGE_L1_START: 'Início de ausência de tensão L1',
      MISSING_VOLTAGE_L1_END: 'Fim de ausência de tensão L1',
      MISSING_VOLTAGE_L2_START: 'Início de ausência de tensão L2',
      MISSING_VOLTAGE_L2_END: 'Fim de ausência de tensão L2',
      MISSING_VOLTAGE_L3_START: 'Início de ausência de tensão L3',
      MISSING_VOLTAGE_L3_END: 'Fim de ausência de tensão L3',
      UNDER_VOLTAGE_L1_START: 'Início de subtensão L1',
      UNDER_VOLTAGE_L1_END: 'Fim de subtensão L1',
      UNDER_VOLTAGE_L2_START: 'Início de subtensão L2',
      UNDER_VOLTAGE_L2_END: 'Fim de subtensão L2',
      UNDER_VOLTAGE_L3_START: 'Início de subtensão L3',
      UNDER_VOLTAGE_L3_END: 'Fim de subtensão L3',
      OVER_VOLTAGE_L1_START: 'Início de sobretensão L1',
      OVER_VOLTAGE_L1_END: 'Fim de sobretensão L1',
      OVER_VOLTAGE_L2_START: 'Início de sobretensão L2',
      OVER_VOLTAGE_L2_END: 'Fim de sobretensão L2',
      OVER_VOLTAGE_L3_START: 'Início de sobretensão L3',
      OVER_VOLTAGE_L3_END: 'Fim de sobretensão L3',
    },
  },
  NetworkManagement: {
    tables: {
      signalQualityTitle: 'Histórico Qualidade de Sinal',
      commandsPacketsTitle: 'Histórico de Pacotes de Comando',
      status: 'Estado do Comando',
      commandType: 'Tipo do Comando',
      lastUpdate: 'Última Atualização',
      serial: 'Serial',
      commandsPackagesHistory: 'Histórico de Pacotes de Comando',
      executeNetworkCommands: 'Executar Comandos de Rede',
    },
    map: {
      tooltip: 'Legenda do Sinal',
      noSignal: 'Sem Sinal',
      poorSignal: 'Muito Fraco',
      fairSignal: 'Fraco',
      regularSignal: 'Regular',
      goodSignal: 'Bom',
      excellentSignal: 'Excelente',
    },
    errors: {
      fetchCommandsPackagesHistoryError: 'Erro ao buscar histórico de pacotes de comando',
      fetchSignalQualityHistoryError: 'Erro ao buscar histórico de qualidade de sinal',
      fetchMetersError: 'Erro ao buscar medidores',
    },
    general: {
      NoSentPackages: 'Nenhum Pacote Enviado Para esse Comando',
      NoReceivedPackages: 'Nenhum Pacote Recebido Para esse Comando',
      NetworkDetails: 'Detalhes de Rede do Medidor',
      DailySignalQualityHistory: 'Qualidade de Sinal',
      SignalQualityHistory: 'Histórico de Sinal',
      RssiQualityHistory: 'Histórico de RSSI',
      commandsPackagesHistory: 'Histórico de Comandos de Rede',
    },
  },
  ReadingsTable: {
    serial: 'Serial',
    dateTime: 'Horário de Leitura',
    totalEnergy_Wh: 'Totalizador Geral (kWh)',
    totalActiveEnergy_Wh: 'Energia Ativa Total (kWh)',
    totalDirectActiveEnergy_Wh: 'Energia Ativa Direta Total (kWh)',
    borderTotalizer_Wh: 'Totalizador Ponta (kWh)',
    reservedTotalizer_Wh: 'Totalizador Fora Ponta (kWh)',
    offBorderTotalizer_Wh: 'Totalizador Reservado (kWh)',
    totalIntermediary_Wh: 'Total Intermediário (kWh)',
    generatedEnergyTotal_Wh: 'Energia Gerada - Total (kWh)',
    totalReverseActiveEnergy_Wh: 'Energia Ativa Reversa Total (kWh)',
    generatedOffBorderEnergyTotal_Wh: 'Energia Gerada Fora Ponta (kWh)',
    generatedIntermediaryEnergyTotal_Wh: 'Energia Gerada Intermediária (kWh)',
    generatedBorderEnergyTotal_Wh: 'Energia Gerada Ponta (kWh)',
    generatedReservedEnergyTotal_Wh: 'Energia Gerada Reservada (kWh)',
    apparentPowerA: 'Potência Aparente A',
    apparentPowerB: 'Potência Aparente B',
    apparentPowerC: 'Potência Aparente C',
    reactivePowerA: 'Potência Reativa A',
    reactivePowerB: 'Potência Reativa B',
    reactivePowerC: 'Potência Reativa C',
    q1ReactiveEnergy_VarH: 'Energia Reativa Q1 (kVarH)',
    q2ReactiveEnergy_VarH: 'Energia Reativa Q2 (kVarH)',
    q3ReactiveEnergy_VarH: 'Energia Reativa Q3 (kVarH)',
    q4ReactiveEnergy_VarH: 'Energia Reativa Q4 (kVarH)',
    reactiveEnergyImportQiRi_VarH: 'Energia Reativa Import QI (+Ri) (kVarH)',
    reactiveEnergyImportQivRc_VarH: 'Energia Reativa Import QIV (–Rc) (kVarH)',
    phaseAVoltageAverage_V: 'Tensão Média Fase A (V)',
    phaseBVoltageAverage_V: 'Tensão Média Fase B (V)',
    phaseCVoltageAverage_V: 'Tensão Média Fase C (V)',
    lastAverageVoltageL1_V: 'Média de Tensão L1 (V)',
    lastAverageVoltageL2_V: 'Média de Tensão L2 (V)',
    lastAverageVoltageL3_V: 'Média de Tensão L3 (V)',
    phaseACurrentAverage_A: 'Corrente Média Fase A (A)',
    phaseBCurrentAverage_A: 'Corrente Média Fase B (A)',
    phaseCCurrentAverage_A: 'Corrente Média Fase C (A)',
    lastAverageCurrentL1_A: 'Média de Corrente L1 (A)',
    lastAverageCurrentL2_A: 'Média de Corrente L2 (A)',
    lastAverageCurrentL3_A: 'Média de Corrente L3 (A)',
    totalPowerFactor_NoUnit: 'Fator de Potência Total',
    phaseAVoltageThd_NoUnit: 'THD Tensão Fase A',
    phaseBVoltageThd_NoUnit: 'THD Tensão Fase B',
    phaseCVoltageThd_NoUnit: 'THD Tensão Fase C',
    phaseACurrentThd_NoUnit: 'THD Corrente Fase A',
    phaseBCurrentThd_NoUnit: 'THD Corrente Fase B',
    phaseCCurrentThd_NoUnit: 'THD Corrente Fase C',
    activePowerThd_NoUnit: 'THD Energia Ativa',
    group0DirectEnergy_Wh: 'Grupo 0 Energia Direta (kWh)',
    group0InductiveReactiveDirectEnergy_VArhPlus: 'Grupo 0 Energia Direta (kVArh+)',
    group0CapacitiveReactiveDirectEnergy_VArhMinus: 'Grupo 0 Energia Direta (kVArh–)',
    group1ReverseEnergy_Wh: 'Grupo 1 Energia Reversa (kWh)',
    group1InductiveReactiveReverseEnergy_VArhPlus: 'Grupo 1 Energia Reversa (kVArh+)',
    group1CapacitiveReactiveReverseEnergy_VArhMinus: 'Grupo 1 Energia Reversa (kVArh–)',
    group2VoltageVaH_V: 'Grupo 2 Tensão Va (V)',
    group2VoltageVbH_V: 'Grupo 2 Tensão Vb (V)',
    group2VoltageVcH_V: 'Grupo 2 Tensão Vc (V)',
    group3CurrentIaH_A: 'Grupo 3 Corrente Ia (A)',
    group3CurrentIbH_A: 'Grupo 3 Corrente Ib (A)',
    group3CurrentIcH_A: 'Grupo 3 Corrente Ic (A)',
    group4ThdVoltageVaH_NoUnit: 'Grupo 4 THD Tensão Va',
    group4ThdVoltageVbH_NoUnit: 'Grupo 4 THD Tensão Vb',
    group4AngleUiA_deg: 'Grupo 4 Ângulo Ui A (º)',
    group4AngleUiB_deg: 'Grupo 4 Ângulo Ui B (º)',
    group4AngleUiC_deg: 'Grupo 4 Ângulo Ui C (º)',
    group4ThdVoltageVcH_NoUnit: 'Grupo 4 THD Tensão Vc',
    group5ThdCurrentIaH_NoUnit: 'Grupo 5 THD Corrente Ia',
    group5ThdCurrentIbH_NoUnit: 'Grupo 5 THD Corrente Ib',
    group5ThdCurrentIcH_NoUnit: 'Grupo 5 THD Corrente Ic',
    totalEnergyIncremental_Wh: 'Totalizador Geral Incremental (kWh)',
    q1ReactiveEnergyIncremental_VarH: 'Energia Reativa Q1 Incremental (kVarH)',
    q4ReactiveEnergyIncremental_VarH: 'Energia Reativa Q4 Incremental (kVarH)',
    voltageA: 'Tensão A (V)',
    voltageB: 'Tensão B (V)',
    voltageC: 'Tensão C (V)',
    currentA: 'Corrente A (A)',
    currentB: 'Corrente B (A)',
    currentC: 'Corrente C (A)',
    activePowerA: 'Potência Ativa A (W)',
    activePowerB: 'Potência Ativa B (W)',
    activePowerC: 'Potência Ativa C (W)',
    maximumVoltageA_V: 'Tensão Máxima A (V)',
    maximumVoltageB_V: 'Tensão Máxima B (V)',
    maximumVoltageC_V: 'Tensão Máxima C (V)',
    minimumVoltageA_V: 'Tensão Mínima A (V)',
    minimumVoltageB_V: 'Tensão Mínima B (V)',
    minimumVoltageC_V: 'Tensão Mínima C (V)',
    maximumCurrentA_A: 'Corrente Máxima A (A)',
    minimumVoltageL1_V: 'Tensão Mínima L1 (V)',
    minimumVoltageL2_V: 'Tensão Mínima L2 (V)',
    minimumVoltageL3_V: 'Tensão Mínima L3 (V)',
    totalInductiveReactiveEnergy_VarH: 'Energia Reativa Indutiva Total (kVarH)',
    totalCapacitiveReactiveEnergy_VarH: 'Energia Reativa Capacitiva Total (kVarH)',
    reactiveEnergyImportQiiiRi_VarH: 'Energia Reativa Import QIII (–Ri) (kVarH)',
    reactiveEnergyImportQiiRc_VarH: 'Energia Reativa Import QII (+Rc) (kVarH)',
    maximumVoltageL1_V: 'Tensão Máxima L1 (V)',
    maximumVoltageL2_V: 'Tensão Máxima L2 (V)',
    maximumVoltageL3_V: 'Tensão Máxima L3 (V)',
    maximumCurrentL1_A: 'Corrente Máxima L1 (A)',
    maximumCurrentL2_A: 'Corrente Máxima L2 (A)',
    maximumCurrentL3_A: 'Corrente Máxima L3 (A)',
    instantaneousVoltageL1_V: 'Tensão Instantânea L1 (V)',
    instantaneousVoltageL2_V: 'Tensão Instantânea L2 (V)',
    instantaneousVoltageL3_V: 'Tensão Instantânea L3 (V)',
    instantaneousCurrentL1_V: 'Corrente Instantânea L1 (A)',
    instantaneousCurrentL2_V: 'Corrente Instantânea L2 (A)',
    instantaneousCurrentL3_V: 'Corrente Instantânea L3 (A)',
    instantaneousActiveImportPowerAPlusL1: 'Potência Ativa Instantânea Import L1 (W)',
    instantaneousActiveExportPowerAMinusL1: 'Potência Ativa Instantânea Export L1 (W)',
    instantaneousReactiveImportPowerRPlusL1: 'Potência Reativa Instantânea Import L1 (VAr)',
    instantaneousReactiveExportPowerRMinusL1: 'Potência Reativa Instantânea Export L1 (VAr)',
    totalPowerFactorPhaseA_NoUnit: 'Fator de Potência Fase A',
    totalPowerFactorPhaseB_NoUnit: 'Fator de Potência Fase B',
    totalPowerFactorPhaseC_NoUnit: 'Fator de Potência Fase C',
    inductiveDirectIncremental_VarH: 'Incremental Indutivo Direto (kVarH)',
    capacitiveDirectIncremental_VarH: 'Incremental Capacitivo Direto (kVarH)',
    inductiveReverseIncremental_VarH: 'Incremental Indutivo Reverso (kVarH)',
    capacitiveReverseIncremental_VarH: 'Incremental Capacitivo Reverso (kVarH)',
    directActiveEnergyIncremental_Wh: 'Energia Ativa Direta Incremental (kWh)',
    reverseActiveEnergyIncremental_Wh: 'Energia Ativa Reversa Incremental (kWh)',
  },
  FrozenData: {
    serial: 'Serial',
    dateTime: 'Horário de Leitura',
    amrProfileStatus: 'Status do Perfil AMR',
    borderTotalizer_Wh: 'Energia Ativa de Pico (kWh)',
    totalEnergy: 'Energia Ativa Total (kWh)',
    totalEnergy_Wh: 'Energia Ativa Total (kWh)',
    forderTotalizer_Wh: 'Energia Ativa Direta T1 (kWh)',
    reservedTotalizer_Wh: 'Energia Ativa Reservado (kWh)',
    offBorderTotalizer_Wh: 'Energia Ativa Fora Ponta (kWh)',
    totalIntermediary_Wh: 'Energia Ativa Intermediário (kWh)',
    generatedEnergyTotal_Wh: 'Energia Ativa Gerada (kWh)',
    totalReverseActiveEnergy_Wh: 'Energia Ativa Reverse Total (kWh)',
    generatedOffBorderEnergyTotal_Wh: 'Energia Ativa Gerada Fora Ponta (kWh)',
    generatedIntermediaryEnergyTotal_Wh: 'Energia Ativa Gerada Intermediário (kWh)',
    generatedBorderEnergyTotal_Wh: 'Energia Ativa Gerada Pico (kWh)',
    generatedReservedEnergyTotal_Wh: 'Energia Ativa Gerada Reservado (kWh)',
    positiveReactiveEnergy_Wh: 'Energia Reativa Positiva (kWh)',
    negativeReactiveEnergy_Wh: 'Energia Reativa Negativa (kWh)',
    totalDirectEnergyTariffC_Wh: 'Wh Totalizador de energia ativa direta na tarifa C',
    totalDirectEnergyTariffB_Wh: 'Wh Totalizador de energia ativa direta na tarifa B',
    totalDirectEnergyTariffA_Wh: 'Wh Totalizador de energia ativa direta na tarifa A',
    totalDirectEnergyTariffD_Wh: 'Wh Totalizador de energia ativa direta na tarifa D',
    totalReverseEnergyTariffC_Wh: 'Wh Totalizador de energia ativa reversa na tarifa C',
    totalReverseEnergyTariffB_Wh: 'Wh Totalizador de energia ativa reversa na tarifa B',
    totalReverseEnergyTariffA_Wh: 'Wh Totalizador de energia ativa reversa na tarifa A',
    totalReverseEnergyTariffD_Wh: 'Wh Totalizador de energia ativa reversa na tarifa D',
    totalInductiveReactiveEnergy_VarH: 'Energia Reativa Indutiva Total (KvarH)',
    totalCapacitiveReactiveEnergy_VarH: 'VarH Energia Reativa Capacitiva Total (KvarH)',
    totalInductiveReactiveEnergyTariffC_Wh: 'Wh Totalizador de energia ativa reversa na tarifa C',
    totalInductiveReactiveEnergyTariffB_Wh: 'Wh Totalizador de energia ativa reversa na tarifa B',
    totalInductiveReactiveEnergyTariffA_Wh: 'Wh Totalizador de energia ativa reversa na tarifa A',
    totalInductiveReactiveEnergyTariffD_Wh: 'Wh Totalizador de energia ativa reversa na tarifa D',
    generatedEnergyTotal: 'Energia Ativa Gerada (kWh)',
    generatedOffBorderEnergyTotal: 'Energia Ativa Gerada Fora Ponta',
    generatedIntermediaryEnergyTotal: 'Energia Ativa Gerada Intermediário',
    generatedBorderEnergyTotal: 'Total de Energia de Ponta Gerada',
    borderTotalizer: 'Totalizador de Pico',
    reservedTotalizer: 'Totalizador de Reservado',
    offBorderTotalizer: 'Totalizador Fora Ponta',
    totalIntermediary: 'Total Intermediário',
    totalReactiveInductiveEnergy: 'Energia Reativa Indutiva Total',
    totalReactiveCapacitiveEnergy: 'Energia Reativa Capacitiva Total',
    consumedMaximunDemand_W: 'Demanda Máxima Consumida (kW)',
    injectedMaximunDemand_W: 'Demanda Máxima Injetada (kW)',
    reverseCapacitiveReactiveEnergy_VarH: 'Energia Reativa Capacitiva Reversa (kVarH)',
    reverseInductiveReactiveEnergy_VarH: 'Energia Reativa Indutiva Reverso (kVarH)',
    cumulativeMaximumDemandRegisterPlusA: 'Demanda Acumulada Total (kW)',
    cumulativeMaximumDemandRegisterMinusA: 'Demanda Acumulada Total Reversa (kW)',
  },
  app: {
    name: 'Sistema de Monitoramento Elétrico',
    description: 'Painel de controle para medição, controle e relatórios de energia',
    language: 'Selecione o idioma',
  },
  navigation: {
    home: 'Página Inicial',
    dashboard: 'Dashboard',
    devices: 'Gerenciar Dispositivos',
    reports: 'Relatórios Detalhados',
    settings: 'Configurações do Sistema',
    logout: 'Sair do Sistema',
    meters: 'Medidores',
    scheduledCommands: {
      label: 'Comandos Agendados',
      systemCommands: 'Comandos do Sistema',
      routineListing: 'Listagem de Rotinas',
    },
    massCommands: {
      label: 'Comandos em Massa',
      readings: 'Leituras',
      cutReconnect: 'Corte/Religamento',
    },
    parametrization: 'Parametrização',
    customReport: 'Relatórios',
    ccee: 'Mercado Livre',
    energyBalance: 'Balanço Energético',
    smcs: 'SMCs',
    billing: 'Faturamento',
    dataExtraction: 'Exportação de dados',
    downloadCenter: 'Central de Downloads',
    transformers: 'Transformadores',
    areas: 'Áreas',
    regions: 'Regiões',
    serviceNotes: 'Notas de Serviço',
    vee: {
      label: 'VEE',
      overview: 'Visão Geral VEE',
      groupsLegacy: 'Grupos VEE (legado)',
      monitoring: 'Monitoramento',
      resume: 'Resumo',
      batchApproval: 'Aprovação em lote',
      readingImport: 'Importação de leituras',
      requestQueue: 'Fila de solicitações',
      zeroConsumption: 'Consumo zero',
      limitDeviations: 'Desvios de limites',
      executionMonitor: 'Monitor de execução',
      configuration: {
        label: 'Configuração VEE',
        groups: 'Grupos VEE',
        rules: 'Biblioteca de regras',
        thresholds: 'Thresholds por regra',
        calendar: 'Calendário de faturamento',
        notifications: 'Notificações',
        hierarchy: 'Associação por hierarquia',
        customRule: 'Regra customizada',
      },
    },
    iagd: {
      label: 'IAGD',
      overview: 'Visão Geral',
      analysis: 'Status da Análise',
      settings: 'Configurações',
      completeness: 'Completude de Dados',
      ranking: 'Ranking de Suspeita',
    },
    management: {
      label: 'Gerenciamento',
      networkManagement: 'Gerenciamento de Rede',
      firmware: 'Firmware',
      gateways: 'Gateways',
      users: 'Usuários',
      keys: 'Chaves',
      tags: 'Tags',
      groups: 'Grupos',
      clients: 'Clientes',
      models: 'Modelos',
      configuration: 'Configurações',
    },
  },
  views: {
    iagd: {
      overviewTitle: 'Visão Geral — IAGD',
      distributor: 'Distribuidora',
      analyzedUcs: 'UCS GD em análise',
      analysis: {
        title: 'Status da Análise',
        funnelTitle: 'Estados',
        totalUcsGd: 'Total UCs GD',
        inAnalysis: 'Em análise',
        excluded: 'Excluídas',
        ofTotal: 'do total',
        thresholdTitle: 'Threshold de completude',
        thresholdHint: 'UCs com completude abaixo deste valor são excluídas da análise.',
        configureThreshold: 'Configurar no Settings',
        bandsTitle: 'Faixas de completude',
        pipelineTitle: 'Processamento',
        lastRun: 'Último ciclo analisado',
        nextRun: 'Próxima execução',
        notScheduled: 'Não agendado',
        stateDetail: {
          titleInAnalysis: 'UCs em análise',
          titleExcluded: 'UCs excluídas',
        },
      },
      kpi: {
        totalUcsGd: 'Total UCS GD',
        riskHigh: 'Risco Alto',
        riskMedium: 'Risco Médio',
        totalFlags: 'Total de Flags',
        metersInRanking: 'Medidores no ranking',
        percentOfTotal: 'do total',
        accumulatedInPeriod: 'Acumuladas no período',
      },
      charts: {
        riskDistribution: 'Distribuição por Faixa de Risco',
        flagComposition: 'Composição de Flags por Tipo',
        scoreDistribution: 'Score Normalizado — Distribuição',
        topMeters: 'Top 10 Medidores por Score',
      },
      flagTypes: {
        quedaBrusca: 'Queda Brusca',
        injForaDaJanela: 'Inj. Fora da Janela',
        consumoNoturno: 'Consumo Noturno',
        tensaoIrregular: 'Tensão Irregular',
      },
      riskLevels: {
        alto: 'Alto',
        medio: 'Médio',
        baixo: 'Baixo',
      },
      ranking: {
        title: 'Ranking de Suspeita',
        ucsTag: 'UCs',
        riskLabel: 'Nível de Risco',
        allRisks: 'Todos',
        searchLabel: 'Buscar medidor',
        searchPlaceholder: 'Ex: UC-000001',
        columns: {
          ucId: 'Instalação',
          meterSerial: 'Serial',
          score: 'Score',
          riskLevel: 'Risco',
          quedaBrusca: 'Q. Brusca',
          injForaDaJanela: 'Inj. Fora',
          consumoNoturno: 'C. Noturno',
          tensaoIrregular: 'Tensão',
          cycle: 'Ciclo',
        },
      },
      rankingModal: {
        titleRisk: 'Nível de Risco — Medidores',
        titleFlag: 'Tipo de Flag — Medidores',
        titleScore: 'Faixa de Score — Medidores',
        filterLabelFlag: 'Tipo de Flag',
        filterLabelScore: 'Faixa de Score',
      },
      completeness: {
        title: 'Completude de Dados',
        datePlaceholder: 'Mês/Ano',
        dateLabel: 'Período',
        searchLabel: 'Busca por UC ID',
        searchPlaceholder: 'Ex: UC-000001',
        exportCsv: 'Exportar CSV',
        metersTag: 'medidores',
        excludedTag: 'excluídos da análise',
        legendTitle: 'Legenda',
        columns: {
          ucId: 'Instalação',
          meterSerial: 'Serial',
          completeness: 'Completude',
          excludedReadings: 'Leituras Ausentes',
          status: 'Status',
        },
        status: {
          included: 'Incluído',
          attention: 'Atenção',
          excluded: 'Excluído',
        },
        cluster: {
          high: 'Alta',
          medium: 'Média',
          low: 'Baixa',
        },
        filterStatus: 'Status',
        filterCluster: 'Faixa de Completude',
        filterAll: 'Todos',
      },
      ucDetail: {
        period: 'Período',
        periodTo: 'até',
        chartTitle: 'HISTÓRICO',
        readings: 'LEITURAS (15 MIN)',
        flaggedRegionsLegend: 'Regiões sombreadas em vermelho indicam dias com flags ativas.',
        anomalyIndicators: 'INDICADORES DE ANOMALIA',
        flagHistory: 'HISTÓRICO DE FLAGS ATIVAS',
        tabs: {
          energy: 'Energia (kWh)',
          voltage: 'Tensão (V)',
          current: 'Corrente (A)',
        },
        series: {
          clusterRef: 'Ref. cluster',
          energyDirect: 'Energia Direta',
          energyReverse: 'Energia Reversa',
          movingAverage: 'Média Móvel',
          voltage: 'Tensão',
          current: 'Corrente',
        },
        noData: 'Nenhuma análise IAGD disponível para esta unidade consumidora.',
      },
      settings: {
        title: 'Configurações',
        save: 'Salvar configurações',
        saving: 'Salvando...',
        saveSuccess: 'Configurações salvas com sucesso',
        saveError: 'Erro ao salvar configurações',
        solarWindow: {
          title: 'Janela Solar',
          start: 'Início',
          end: 'Fim',
          startPlaceholder: 'Ex: 06:00',
          endPlaceholder: 'Ex: 20:00',
        },
        flagThresholds: {
          title: 'Limiares de Flags',
          abruptDrop: 'Queda Brusca (%)',
          abruptDropHint: 'Queda em relação à média móvel (default: 40%)',
          nightConsumption: 'Consumo Noturno Z-score',
          nightConsumptionHint: 'Limiar de desvio estatístico (default: 2.5)',
          irregularVoltage: 'Tensão Irregular Z-score',
          irregularVoltageHint: 'Limiar de desvio do σ diário (default: 2.5)',
        },
        pipelineParams: {
          title: 'Parâmetros do Pipeline',
          completeness: 'Limiar de Completude (%)',
          completenessHint: 'Medidores abaixo deste valor são excluídos (default: 70%)',
          clusters: 'Número de Clusters (K)',
          clustersHint: 'Usado no K-Means de perfil de consumo',
          analysisWindow: 'Janela de análise (dias)',
        },
        schedules: {
          title: 'Agendamentos',
          scoring: 'Cron — Scoring',
          scoringHint: 'Formato cron. Default: 0 2 * * * (diário, 02h UTC)',
          clustering: 'Cron — Clusterização',
          clusteringHint: 'Default: 0 3 * * 1 (semanal, seg. 03h UTC)',
        },
      },
    },
    downloads: {
      exportStarted: 'Exportação iniciada',
      exportStartedDefault:
        'O arquivo estará disponível na aba de downloads assim que o processo for finalizado.',
      exportCompleted: 'Arquivo disponível',
      exportCompletedDetail: 'O arquivo já está disponível na Central de Downloads.',
      exportError: 'Erro na exportação',
      exportErrorDefault: 'Não foi possível concluir a exportação',
      exportDelayed: 'Exportação ainda em processamento',
      exportDelayedDetail:
        'A exportação está demorando mais do que o esperado. Você pode acompanhar o andamento na Central de Downloads.',
    },
    massCommands: {
      invalidModel: 'Modelo inválido',
      requiredSerialColumn: 'A coluna obrigatória é: Serial',
      invalidDateColumnFormat:
        'A coluna Data deve estar no formato: ano-mês-dia, por exemplo 2026-01-01.',
      billingProcessStarted:
        'Processo de faturamento iniciado. Você será redirecionado para acompanhar o andamento.',
      billingProcessStartError: 'Não foi possível iniciar o processo de faturamento.',
    },
    dashboard: {
      title: 'Dashboard',
      tabs: {
        general: 'Geral',
        commands: 'Comandos',
        alarms: 'Alarmes',
        averageVariation: 'Variação Média',
        abruptVariation: 'Variação Abrupta',
        effectivenessAndAvailability: 'Eficiência e Disponibilidade',
        quality: 'Qualidade',
        vee: 'VEE',
      },
      effectivenessDailyReport: {
        title: 'Relatório diário rápido',
        description:
          'Esse download gera o relatório do dia anterior e não considera os filtros aplicados abaixo.',
        action: 'Baixar relatório',
      },
      averageVariation: {
        titleConfigAverageVariation: 'Configuração de Variação Abrupta',
        dailyConsumption: 'Consumo Diário',
        weeklyConsumption: 'Consumo Semanal',
        monthlyConsumption: 'Consumo Mensal',
        events: 'Eventos',
        alarms: 'Alarmes',
        dailySettings: 'Configurações de Variação Diária',
        weeklySettings: 'Configurações de Variação Semanal',
        monthlySettings: 'Configurações de Variação Mensal',
        weekDay: 'Dia da Semana',
        month: 'Mês',
        weekDays: {
          all: 'Todos',
          monday: 'Segunda-feira',
          tuesday: 'Terça-feira',
          wednesday: 'Quarta-feira',
          thursday: 'Quinta-feira',
          friday: 'Sexta-feira',
          saturday: 'Sábado',
          sunday: 'Domingo',
        },
        months: {
          all: 'Todos',
          january: 'Janeiro',
          february: 'Fevereiro',
          march: 'Março',
          april: 'Abril',
          may: 'Maio',
          june: 'Junho',
          july: 'Julho',
          august: 'Agosto',
          september: 'Setembro',
          october: 'Outubro',
          november: 'Novembro',
          december: 'Dezembro',
        },
        placeholders: {
          selectWeekDay: 'Selecione o dia da semana',
          selectMonth: 'Selecione o mês',
          selectEventType: 'Selecione o tipo de evento',
          loading: 'Carregando...',
        },
        eventType: 'Tipo de Evento',
        eventTypes: {
          all: 'Todos',
          flow_inversion: 'Inversão de Fluxo',
          incomplete_memory: 'Energia Incompleta',
          abrupt_consumption_variation_day: 'Variação Abrupta de Consumo (Dia Anterior)',
          abrupt_consumption_variation_week: 'Variação Abrupta de Consumo (Semana Anterior)',
          abrupt_consumption_variation_month: 'Variação Abrupta de Consumo (Mês Anterior)',
          abrupt_generation_variation_day: 'Variação Abrupta de Geração (Dia Anterior)',
          abrupt_generation_variation_week: 'Variação Abrupta de Geração (Semana Anterior)',
          abrupt_generation_variation_month: 'Variação Abrupta de Geração (Mês Anterior)',
          last_gasp: 'Last Gasp',
        },
        abruptVariation: 'Variação Abrupta',
        abruptVariationChart: 'Gráfico de Variação Abrupta',
        settings: {
          title: 'Configurações de Variação Abrupta',
          percentageValue: 'Valor de Referência (%)',
          interval: 'Intervalo',
          loading: 'Carregando...',
          cancel: 'Cancelar',
          save: 'Salvar',
        },
        search: 'Buscar',
        tableHeaders: {
          startWeek: 'Início da Semana',
          endWeek: 'Fim da Semana',
          date: 'Data',
          weekDay: 'Dia da Semana',
          month: 'Mês',
          serial: 'Serial',
          instalation: 'Instalação',
          installation: 'Instalação',
          consumption: 'Consumo (kWh)',
          generation: 'Geração (kWh)',
          difference: 'Saldo (kWh)',
          startMonth: 'Início do Mês',
          endMonth: 'Fim do Mês',
          eventDateTime: 'Data/Hora do Evento',
          eventType: 'Tipo de Evento',
        },
      },
    },
    veeDashboard: {
      overviewTitle: 'Visão Geral VEE',
      filters: {
        title: 'Filtros',
        region: 'Região',
        tariffClass: 'Classe Tarifária',
        technology: 'Tecnologia',
        period: 'Período',
        group: 'Grupo VEE',
        selectRegion: 'Selecione a região',
        selectTariffClass: 'Selecione a classe tarifária',
        selectTechnology: 'Selecione a tecnologia',
        selectPeriod: 'Selecione o período',
        selectGroup: 'Selecione o grupo VEE',
        apply: 'Aplicar',
        clear: 'Limpar',
      },
      cards: {
        validatedReadings: 'Leituras Validadas',
        validatedReadingsCaption: 'do total de leituras no período',
        pendingExceptions: 'Exceções Pendentes',
        estimatesToApprove: 'Estimativas para Aprovar',
        dataGaps: 'Lacunas de Dados',
        communicationFailures: 'Falhas de Comunicação',
        nextBilling: 'Próximo Faturamento',
        aging: 'aging',
        days: 'dias',
        meters: 'medidores',
        approveInBulk: 'Aprovar em lote',
        approveInBulkDialog: {
          title: 'Aprovar estimativas em lote',
          message: 'Confirma a aprovação em lote de {count} estimativa(s) pendente(s)?',
          cancel: 'Cancelar',
          confirm: 'Aprovar',
          successSummary: 'Estimativas aprovadas em lote com sucesso.',
        },
      },
      trendChart: {
        title: 'Tendência de Qualidade dos Dados',
        validated: 'Validado',
        exception: 'Exceção',
        granularity: 'Granularidade',
        daily: 'Diária',
        weekly: 'Semanal',
        monthly: 'Mensal',
      },
      communicationStatus: {
        title: 'Status de Comunicação',
        online: 'Online',
        offline: 'Offline',
        absent: 'Ausente',
      },
      alerts: {
        title: 'Alertas Recentes',
        alert: 'Alerta',
        severity: 'Severidade',
        meter: 'Medidor',
        date: 'Data',
        viewDetails: 'Ver detalhes',
        empty: 'Nenhum alerta recente',
        detailsDialog: {
          title: 'Detalhes do Alerta',
          close: 'Fechar',
          resolve: 'Marcar como resolvido',
          resolveSuccess: 'Alerta marcado como resolvido com sucesso.',
        },
      },
      groupsTable: {
        title: 'Grupos',
        group: 'Grupo',
        validatedPercent: '% Validado',
        exceptions: 'Exceções',
        pendingEstimates: 'Estimativas Pendentes',
        nextBilling: 'Próx. Faturamento',
        empty: 'Nenhum grupo encontrado',
        downloadSuccess: 'Download iniciado com sucesso.',
      },
      serviceRequests: {
        title: 'Solicitações de Serviço',
        meter: 'Medidor',
        issue: 'Problema',
        slaRemaining: 'SLA Restante',
        status: 'Status/Ação',
        empty: 'Nenhuma solicitação pendente',
        detailsDialog: {
          title: 'Detalhes da Solicitação',
          close: 'Fechar',
          resolve: 'Marcar como resolvido',
          resolveSuccess: 'Solicitação marcada como resolvida com sucesso.',
        },
      },
      refreshSuccess: 'Dados atualizados com sucesso.',
    },
    billing: {
      filters: {
        title: 'Filtros',
        status: 'Status do Faturamento',
        stage: 'Etapa do Faturamento',
        period: 'Período',
        manufacturer: 'Fabricante',
        selectStatus: 'Selecione o status',
        selectStage: 'Selecione a etapa',
        apply: 'Aplicar',
        clear: 'Limpar',
      },
    },
    customReport: {
      title: 'Relatórios',
      emptyState: 'Sem dados para exibir.',
      readings: 'Leituras',
      itemsFound: 'itens encontrados',
      comingSoon: 'Em breve.',
      transformers: 'Trafos',
      warnings: {
        invalidPeriodSummary: 'Período inválido',
        invalidPeriodDetail:
          'Na aba Variação Abrupta, o período selecionado deve conter datas do mesmo ano. Selecione datas que estejam dentro do mesmo ano civil.',
      },
      events: {
        charts: {
          overload: 'Trafos em Sobrecarga',
          overvoltage: 'Trafos em Sobretensão',
          undervoltage: 'Trafos em Subtensão',
          unbalance: 'Desequilíbrio de Tensão',
        },
        tables: {
          overload: 'Sobrecarga',
          overvoltage: 'Sobretensão',
          undervoltage: 'Subtensão',
          unbalance: 'Desequilíbrio de Tensão',
        },
        columns: {
          overload: 'Sobrecarga (%)',
          overvoltage: 'Sobretensão (%)',
          undervoltage: 'Subtensão (%)',
          unbalance: 'Desequilíbrio (%)',
        },
        viewMore: 'Ver Mais',
      },
      tabs: {
        general: 'Visão Geral',
        events: 'Eventos',
        alarms: 'Alarmes',
        loads: 'Carregamentos',
        abruptVariation: 'Variação Abrupta',
      },
      ccee: {
        dateRange: 'Selecione o período',
        kpi: {
          metersOnline: 'Medidores Online',
          readingsSent: 'Leituras Enviadas (Hoje)',
          successRate: 'Taxa de Sucesso Mercado Livre',
          pendingTickets: 'Tickets Pendentes',
        },
        statusMap: {
          title: 'Mapa de Status',
          accepted: 'Dados Aceitos',
          waiting: 'Aguardando confirmação CCEE',
          lacuna: 'Lacuna',
          failed: 'Falha no envio',
        },
        alerts: {
          title: 'Alertas em Destaque',
          columns: {
            meter: 'Medidor',
            alert: 'Alerta',
            priority: 'Prioridade',
          },
          priority: {
            low: 'Baixa',
            medium: 'Média',
            high: 'Alta',
          },
          filters: {
            serial: 'Serial do Medidor',
            priority: 'Prioridade',
            allPriorities: 'Todas as prioridades',
          },
          meterModal: {
            title: 'Medidores Relacionados',
          },
        },
        sendStatus: {
          title: 'Status de Envio',
          columns: {
            meter: 'Medidor',
            datetime: 'Data/Hora',
            status: 'Status',
            ticket: 'Ticket CCEE',
          },
          status: {
            accepted: 'Aceito',
            sent: 'Enviado',
            rejected: 'Rejeitado',
            gap: 'Lacuna',
          },
          filters: {
            serial: 'Serial do Medidor',
            status: 'Status',
            allStatuses: 'Todos os status',
          },
        },
        anomalies: {
          title: 'Anomalias Detectadas',
          columns: {
            meter: 'Medidor',
            anomaly: 'Anomalia',
            suggestion: 'Sugestão',
            rule: 'Regra do documento',
            action: 'Ação',
          },
        },
        performance: {
          title: 'Performance dos últimos 30 dias',
          metrics: {
            metersOnline: 'Medidores Online',
            correctedGaps: 'Lacunas Corrigidas',
            cceeAcceptance: 'Aceitação CCEE',
            sendRate: 'Taxa de Envio',
          },
        },
        availableReports: {
          title: 'Relatórios Disponíveis',
          columns: {
            report: 'Relatório',
            type: 'Tipo',
          },
        },
        generatedFiles: {
          title: 'Arquivos Gerados',
          columns: {
            report: 'Relatório',
            period: 'Período',
            format: 'Formato',
            items: 'Itens',
            records: 'Registros',
          },
        },
        collectionGrid: {
          title: 'Extrato de Coleta',
          monthPicker: 'Selecione o mês',
          meter: 'Medidor',
          noData: 'Nenhum dado encontrado para o período selecionado',
          filters: {
            serial: 'Filtrar por serial',
          },
        },
        readingsModal: {
          title: 'Leituras',
          filters: {
            period: 'Período',
            status: 'Status',
            allStatuses: 'Todos os status',
          },
          columns: {
            datetime: 'Data/Hora',
            status: 'Status',
            ticket: 'Ticket CCEE',
            integrationMethod: 'Método',
            activeEnergyIn: 'Ativa Entrada',
            activeEnergyOut: 'Ativa Saída',
            reactiveEnergyIn: 'Reativa Entrada',
            reactiveEnergyOut: 'Reativa Saída',
            consumoKwh: 'Consumo',
          },
        },
      },
      filters: {
        equipment: 'Distribuidora',
        installation: 'MFINSTALA',
        region: 'Regional',
        polygon: 'Polígono',
        load: 'Carregamento',
        loadRange: '% CARREGAMENTO',
        cluster: 'Cluster',
        selectPeriod: 'Selecione o período',
        minPlaceholder: 'Min',
        maxPlaceholder: 'Máx',
        superintendency: 'Superintendência',
        sectional: 'Seccional',
        city: 'Município',
        itemsSelected: 'itens selecionados',
        equipmentOptions: {
          eqtlMa: 'EQTL-MA',
          eqtlBa: 'EQTL-BA',
          eqtlPi: 'EQTL-PI',
        },
        installationOptions: {
          mfinstala: 'MFINSTALA',
          finstala: 'FINSTALA',
          nfinstala: 'NFINSTALA',
        },
        regionOptions: {
          regional: 'Regional',
          east: 'Leste',
          west: 'Oeste',
        },
        polygonOptions: {
          default: 'Polígono',
          centerWest: 'Centro-Oeste',
          coast: 'Litoral',
        },
        loadOptions: {
          default: 'Carregamento',
          normal: 'Normal',
          overload: 'Sobrecarga',
        },
        clusterOptions: {
          default: 'Cluster',
          upTo100: 'Até 100%',
          between100And125: '100% a 125%',
          above175: 'Acima de 175%',
        },
      },
      legend: {
        normalLoad: 'Carga Normal',
        overload: 'Sobrecarga',
      },
      cards: {
        loadClusters: 'Clusters de Carregamento',
        overloadByPolygon: 'Sobrecarga por Polígono',
        maxMonthlyLoad: 'Máximo Carregamento Mensal',
        maxLoad: 'Carregamento Máximo',
        maxLoadCurve: 'Curva de Carregamento Máximo',
        maxPhaseUnbalanceCurve: 'Curva de Desbalanço de Fase Máximo',
        timeByTier: 'Tempo por Patamar',
        phaseUnbalanceClusters: 'Clusters de Desbalanço de Fase',
      },
      charts: {
        maxLoadCurve: 'Curva de Carregamento Máximo',
        maxPhaseUnbalanceCurve: 'Curva de Desbalanço de Fase Máximo',
        phaseUnbalanceClusters: 'Desbalanço de Fase',
      },
      tiers: {
        upTo100: 'até 100%',
        between100And125: '100% a 125%',
        between125And150: '125% a 150%',
        between150And175: '150% a 175%',
        above175: 'Acima de 175%',
      },
      unbalance: {
        upTo10: 'até 10%',
        between10And20: '10% a 20%',
        between20And30: '20% a 30%',
        between30And40: '30% a 40%',
        between40And50: '40% a 50%',
        above50: 'acima de 50%',
      },
      tables: {
        transformer: 'Trafo',
        transformerName: 'Nome do Trafo',
        loadPercent: '% Carregamento',
        maxLoad: 'Carreg. Máx.',
        cluster: 'Cluster',
        phaseUnbalance: 'Desbalanço Fase',
        date: 'Data',
        month: 'Mês',
        range: 'Faixa',
        total: 'Total',
        percent: 'Percentual',
        polygon: 'Polígono',
        region: 'Regional',
        normal: 'Normal',
        overload: 'Sobrecarga',
      },
      details: {
        mfinstala: 'MFINSTALA',
        distributor: 'Distribuidora',
        transformer: 'Trafo',
        power: 'Potência',
        region: 'Regional',
        polygon: 'Polígono',
        dataDate: 'Data Dados',
        posto: 'Posto',
        measurementDate: 'Data Medição',
        imax: 'Imax',
        inum: 'Inum',
        loadPercent: '% Carregamento',
        loadPercentA: '% Carreg. A',
        loadPercentB: '% Carreg. B',
        loadPercentC: '% Carreg. C',
        clusterPercent: 'Cluster %',
        overload: 'Sobrecarga',
        phaseUnbalance: 'Desbalanço Fase',
        unbalanceCluster: 'Cluster Desbalanço',
        currentA: 'Corrente A',
        currentB: 'Corrente B',
        currentC: 'Corrente C',
        undefined: 'Indefinido',
      },
    },
    process: {
      title: 'Processo',
      user: 'Usuário Responsável',
      processType: 'Tipo de Processo',
      updatedAt: 'Última Atualização',
    },
    meters: {
      title: 'Medidores',
      periodUpdateAt: 'Período de última atualização',
      meterInfo: {
        title: 'Detalhes do Medidor',
        infoClient: 'Info. Cliente',
        moreDetails: 'Ver Mais',
        noInformation: 'Sem informação',
        serial: 'Serial',
        installation: 'Unidade Consumidora',
        displayConfigured: 'Configuração de Display',
        firmware: 'Firmware',
        accountantStatus: 'Estado de Relé',
        referenceVoltage: 'Tensão de Referência',
        status: 'Estado de Comunicação',
        associatedGateway: 'Gateway associado:',
        networkTypePublic: 'Pública',
        networkTypePrivate: 'Privada',
        latLong: 'Lat / Long',
        crcMassMemory: 'CRC memória de massa',
        uplinkPeriod: 'Período de Uplink de Leitura',
        crcFrozenData: 'CRC Energia',
        tags: 'Tags do Medidor',
        regional: 'Regional',
        sectional: 'Seccional',
        polygon: 'Polígono',
        potency: 'Potência',
        noTags: 'Nenhuma tag encontrada',
        meterModel: {
          manufacturer: 'Fabricante',
        },
        delete: 'Excluir',
        confirmDelete: 'Confirmar exclusão do Medidor',
        confirmDeleteDescription: 'Deseja excluir o Medidor?',
        confirmDeleteText: 'Sim, excluir',
        actions: {
          fileUpload: 'Upload de arquivo',
          editReadings: 'Edição de Leituras',
          editTags: 'Configurar Tags',
          searchTags: 'Pesquisar tags pelo nome',
        },
        editReadingsTabs: {
          meterAlarms: 'Alarmes do Medidor',
          dataReadings: 'Leituras de Dados',
          frozenData: 'Dados Congelados',
          qeeIndicators: 'Indicadores QEE',
          smcAlarms: 'Alarmes de SMC',
        },
        tabs: {
          overview: 'Visão Geral',
          iagd: 'IA-GD',
          vee: 'Visualização VEE',
        },
      },
      criticalAlarms: {
        title: 'Alertas Críticos',
        criticalAlarm: 'Alarme crítico',
        readDateTime: 'Horário de Leitura:',
        updatedAt: 'Última Atualização:',
        notFound: 'Nenhum alarme crítico encontrado!',
        relayFailure: 'Falha do Relé',
        smiTimeout: 'SMI Timeout',
        lastGasp: 'Last Gasp',
        localReset: 'Religamento local',
        measurementError: 'Erro no sistema de medição',
      },
      maps: {
        title: 'Visualização no Mapa',
        noLocation: 'Não há localização disponível',
      },
      display: {
        title: 'Display do Medidor',
        config: 'Configurações do Display',
        save: 'Atualizar Configuração',
        readDisplay: 'Solicitar leitura do Display',
        '001': 'Dia, mês, e ano atuais',
        '002': 'Hora, minuto, e segundos atuais',
        '003': 'Totalizador Geral Ativo',
        '004': 'Totalizador Ponta Ativo',
        '006': 'Totalizador Reservado Ativo',
        '008': 'Totalizador Fora Ponta Ativo',
        '009': 'Totalizador Intermediário Ativo',
        '024': 'Totalizador de Energia Reativa Indutiva',
        '103': 'Totalizador Geral Reverso',
        '104': 'Totalizador Ponta Reverso',
        '106': 'Totalizador Reservado Reverso',
        '108': 'Totalizador Fora Ponta Reverso',
        '109': 'Totalizador Intermediário Reverso',
      },
      placeholders: {
        serial: 'Digite o serial do medidor',
      },
    },
    meterDetails: {
      titleWithSerial: 'Informações do Medidor - {serial}',
    },
    meterFileUpload: {
      title: 'Upload de arquivo',
      meterCardTitle: 'Medidor - {serial}',
      selectPlaceholder: 'Tipo de importação',
      importSpreadsheet: 'Importar planilha',
      cancel: 'Cancelar',
      send: 'Enviar',
      emptyHint:
        'Selecione um tipo e importe a planilha para visualizar os registros antes do envio.',
      importedRecordsTitle: 'Registros importados',
      qualityWarningTitle: 'Atenção',
      qualityWarningDetail:
        'Existem {total} registro(s) sem indicadores de qualidade preenchidos. Esses registros podem ser rejeitados no processamento, pois não possuem DRP, DRC, DTT95, FD95 ou indicadores por fase.',
      total: 'Total',
      tableEmpty: 'Nenhum registro encontrado.',
      removeDialogTitle: 'Remover importação',
      removeDialogMessage: 'Deseja remover o arquivo e limpar os dados carregados?',
      remove: 'Remover',
      sendDialogTitle: 'Confirmar envio',
      sendDialogMessage: 'Deseja finalizar esta operação e enviar {total} registro(s)?',
      importModalTitle: 'Importar - {label}',
      types: {
        massMemory: 'Memória de massa',
        quality: 'Parâmetros de qualidade',
        energy: 'Totalizadores de energia',
        alarms: 'Alarmes',
      },
      toast: {
        importedTitle: 'Arquivo importado',
        importedDetail: '{total} registro(s) carregado(s).',
        removedTitle: 'Importação removida',
        removedDetail: 'Dados limpos com sucesso.',
        unavailableTitle: 'Indisponível',
        alarmsNotImplemented: 'A opção ainda não está disponível.',
        sentTitle: 'Envio realizado',
        sentDetail: 'Importação iniciada com sucesso.',
        sendError: 'Não foi possível enviar os dados. Tente novamente.',
        noRows: 'Nenhum registro encontrado no arquivo.',
        invalidSerial: 'Serial inválido',
      },
    },
    meterVeeDetails: {
      titleWithSerial: 'VEE — Medidor {serial}',
      currentReadingCardTitle: 'Leitura atual',
      group: 'Grupo VEE',
      statusCardTitle: 'Status',
      blockingCardTitle: 'Bloqueio',
      status: {
        ok: 'OK',
        estimated: 'Em estimativa',
        noCommunication: 'Sem comunicação',
        blocked: 'Bloqueado',
        notBlocked: 'Não bloqueado',
      },
      chart: {
        title: 'Leituras e eventos AMI',
        real: 'Real',
        estimatedApproved: 'Estimado aprovado',
        proposed: 'Proposto',
        events: {
          interruption: 'Interrupção',
          tamper: 'Tamper',
          communicationFailure: 'Falha de comunicação',
        },
      },
      exceptions: {
        title: 'Exceções ativas',
        empty: 'Nenhuma exceção ativa',
        edit: 'Editar',
        resolve: 'Resolver',
        status: {
          pendente: 'Pendente',
          emAnalise: 'Em Análise',
          resolvida: 'Resolvida',
          ignorada: 'Ignorada',
        },
      },
      estimateProposals: {
        title: 'Propostas de estimativa',
        empty: 'Nenhuma proposta pendente',
        approve: 'Aprovar',
        reject: 'Rejeitar',
      },
      editReadingDialog: {
        title: 'Editar leitura',
        editReading: 'Editar leitura',
        currentValue: 'Valor atual',
        newValue: 'Novo valor',
        justification: 'Justificativa (obrigatória)',
        justificationPlaceholder: 'Descreva o motivo da edição manual',
        cancel: 'Cancelar',
        save: 'Salvar',
      },
      errors: {
        loadFailed: 'Não foi possível carregar os dados VEE deste medidor.',
        retry: 'Tentar novamente',
      },
      toast: {
        justificationRequiredTitle: 'Justificativa obrigatória',
        justificationRequired: 'Informe a justificativa para editar a leitura.',
        readingUpdatedTitle: 'Leitura atualizada',
        readingUpdatedDetail: 'A leitura foi atualizada com sucesso.',
        proposalApprovedTitle: 'Estimativa aprovada',
        proposalApprovedDetail: 'Proposta por {method} aprovada e aplicada à leitura atual.',
        proposalRejectedTitle: 'Estimativa rejeitada',
        proposalRejectedDetail: 'Proposta por {method} rejeitada.',
        exceptionResolvedTitle: 'Exceção resolvida',
        exceptionResolvedDetail: '{rule} marcada como resolvida.',
      },
    },
    manualInsertReadings: {
      title: 'Edição de Leituras/Alarmes manuais',
      tabs: {
        meterAlarms: 'Alarmes Medidores',
        dataReadings: 'Memória de Massa',
        frozenData: 'Totalizadores',
        qeeIndicators: 'Qualidade',
        smcAlarms: 'Alarmes SMCs',
      },
      meterAlarmsTable: {
        serial: 'Serial',
        description: 'Descrição',
        terminal: 'Terminal',
        read: 'Lido',
        manualInsert: 'É manual',
        installation: 'Instalação',
        user: 'Usuário',
        translate: 'Tradução',
        readDate: 'Data Leitura',
        updatedAt: 'Ultima Atualização',
      },
      dataReadingsTable: {},
      frozenDataTable: {},
      qeeIndicatorsTable: {
        serial: 'Serial',
        comissioned: 'Comiss',
        online: 'Online',
        dateTimeInitial: 'Data/Hora Inicial',
        dateTimeFinal: 'Data/Hora Final',
        drp: 'DRP',
        drc: 'DRC',
        dtt95: 'DTT95',
        fd95: 'FD95',
        count: 'Contagem',
        meterActivated: 'Medidores Ativados',
        drcPhaseA: 'DrcPhaseA',
        drcPhaseB: 'DrcPhaseB',
        drcPhaseC: 'DrcPhaseC',
        drpPhaseA: 'DrpPhaseA',
        drpPhaseB: 'DrpPhaseB',
        drpPhaseC: 'DrpPhaseC',
        consumerUnitsId: 'Unidade Consumidora',
        updatedAt: 'Atualizado em',
      },
      smcAlarmsTable: {
        serial: 'Serial',
        description: 'Descrição',
        read: 'Lido',
        isManualInsert: 'É manual',
        user: 'Usuário',
        translate: 'Tradução',
        readDateTime: 'Data/Hora Leitura',
        updatedAt: 'Última Atualização',
      },
      messages: {
        qeeEditUnavailable: 'Edição indisponível.',
        qeeDeleteUnavailable: 'Exclusão indisponível.',
        qeeClosedCycle:
          'O período selecionado já foi fechado e não permite edição manual. Prazo permitido até: {deadline}.',
        qeeDeleteClosedCycle:
          'O período selecionado já foi fechado e não permite exclusão manual. Prazo permitido até: {deadline}.',
        invalidDateRange: 'Data/Hora Inicial não pode ser maior que Data/Hora Final.',
        requiredDrpDrc: 'DRP e DRC são obrigatórios.',
        useCommaDecimalSeparator: 'Informe DRP e DRC usando vírgula e no máximo 3 casas decimais.',
        qeeUpdateSuccess: 'Parâmetro atualizado com sucesso.',
        qeeUpdateError: 'Não foi possível atualizar o parâmetro QEE.',
        qeeDeleteConfirmTitle: 'Confirmar exclusão',
        qeeDeleteConfirmMessage: 'Deseja realmente excluir este parâmetro de qualidade?',
        qeeDeleteConfirmAction: 'Excluir',
        qeeDeleteSuccess: 'Parâmetro de qualidade excluído com sucesso.',
        qeeDeleteError: 'Não foi possível excluir o parâmetro de qualidade.',
      },
    },
    consumerUnit: {
      fullName: 'Nome Completo',
      address: 'Endereço',
      locationCode: 'Código de Localização',
      consumerUnitCode: 'Código da Unidade',
      situationCode: 'Código da Situação',
      situationDate: 'Data de Situação',
      consumptionClassCode: 'Código de Consumo',
      equipmentNumber: 'Equipamento',
      historyUc: 'Histórico',
      communicationDescription: 'Comunicação',
      startRelationDatetime: 'Início da Relação',
      endRelationDatetime: 'Fim da Relação',
    },
    smcs: {
      title: 'SMCs',
      smcInfo: {
        title: 'Detalhes do SMC',
        model: 'Modelo',
        brand: 'Marca',
        serial: 'Serial',
        qtyMeters: 'Quantidade de Clientes',
        uplinkPeriod: 'Período de Uplink de Leitura',
        signalQuality: 'Qualidade do Sinal',
        networkPublic: 'Pública ',
        networkPrivate: 'Privada ',
        description: 'Descrição',
        latitude: 'Latitude',
        longitude: 'Longitude',
        tagsFilterTitle: 'Filtros aplicados',
        tagsFilterDetails: 'Filtros por tags aplicado, porém SMC não há tags.',
        doorStatus: 'Estado da Porta',
        online: 'Estado de Comunicação',
        comissioned: 'Comissionamento',
      },
      criticalAlarms: {
        title: 'Alertas Críticos',
        criticalAlarm: 'Alarme crítico',
        readDateTime: 'Horário de Leitura:',
        updatedAt: 'Última Atualização:',
        notFound: 'Nenhum alarme crítico encontrado!',
        relayFailure: 'Falha do Relé',
        openDoor: 'Porta Aberta',
        smcTimeout: 'SMC Timeout',
        lastGasp: 'Last Gasp',
        localReset: 'Religamento local',
        measurementError: 'Erro no sistema de medição',
        keysHLSInvalid: 'Chaves HLS Inválidas',
        invalidMeter: 'Medidor Inválido',
      },
      success: {
        createSmc: 'SMC criado com sucesso',
        updateSmc: 'SMC atualizado com sucesso',
      },
      errors: {
        createSmc: 'Erro ao criar SMC',
        updateSmc: 'Erro ao atualizar SMC',
        loadSmcModels: 'Erro ao carregar modelos de SMC',
      },
      summary: {
        statusTitle: 'Status',
        commissioningTitle: 'Comissionamento',
        portTitle: 'Status da porta',
        fetchErrorTitle: 'Erro',
        fetchErrorDetail: 'Erro ao buscar resumo de SMCs',
        online: 'Online',
        offline: 'Offline',
        absent: 'Ausente',
        commissioned: 'Comissionado',
        notCommissioned: 'Não Comissionado',
        authorized: 'Autorizado',
        unauthorized: 'Desautorizado',
        details: {
          onlineTitle: 'SMCs Online',
          offlineTitle: 'SMCs Offline',
          absentTitle: 'SMCs Ausentes',
          commissionedTitle: 'SMCs Comissionados',
          notCommissionedTitle: 'SMCs Não Comissionados',
          authorizedTitle: 'SMCs com status da porta Autorizado',
          unauthorizedTitle: 'SMCs com status da porta Desautorizado',
          selectBrand: 'Selecione a marca',
        },
      },
      registerSmcFile: 'Importar SMCs por arquivo',
      editSmcFile: 'Editar SMCs por arquivo',
      massActionStartedTitle: 'Processo iniciado',
      massActionStartedDetail: 'Processo iniciado. Aguarde a finalização da ação.',
    },
    modemInfo: {
      title: 'Modem',
      notAvailable: 'Não disponível',
      noInformation: 'Sem informação',
      deviceEui: 'EUI',
      firmwareVersion: 'Firmware',
      signal: 'Sinal',
      iccid: 'ICCID',
      imei: 'IMEI',
      imsi: 'IMSI',
      operator: 'Operadora',
      cellId: 'Cell ID',
      signalQuality: 'Sinal',
      bootCounter: 'Boot Counter',
      snr: 'SNR',
      rssi: 'RSSI',
      bleStack: 'BleStack',
      mcuRevision: 'Revisão MCU',
      celLv: 'Nível de Célula',
      tempC: 'Temperatura',
      rsrp: 'RSRP',
      rsrq: 'RSRQ',
      txpwr: 'Potência TX',
      band: 'Band',
    },
    commands: {
      title: 'Comandos',
      command: 'Comando',
      notAvailable: 'Não disponível',
      state: 'Estado',
      commandQueue: 'Comandos na Fila',
      noCommand: 'Sem Comando na Fila',
      lastSeen: 'Última Comunicação',
      communication: 'Comunicação',
      noCommunication: 'Não disponível',
      lastCommand: 'Último Comando',
      sendCommand: 'Enviar',
      notImplemented: 'Comando não implementado',
      voltageOutIntervalMinites: 'Minuto(s)',
      voltageOutIntervalHours: 'Hora(s)',
      voltageOutIntervalDays: 'Dia(s)',
      sendToSelected: 'Enviar Para Selecionados',
      sendToAll: 'Enviar para todos',
      userDangerousCommandConfirmation:
        'Confirmo que estou ciente de que o preenchimento incorreto destas informações poderá resultar na perda de comunicação remota do medidor, sendo necessária intervenção local para restabelecimento da conexão.',
      nicResetConfirm: {
        title: 'Resetar a NIC',
        message:
          'O processo de reset implica no recomissionamento da NIC, o que depende das condições de rede atuais. Deve-se aguardar o período médio de comissionamento até que a NIC volte ao status online.',
        checkboxLabel: 'Estou consciente e quero resetar a nic.',
        cancel: 'Cancelar',
        confirm: 'RESETAR',
      },
      listOfCommands: {
        setSmiVoltageOutInterval: 'Definir Intervalo DIC/FIC',
        setSmiQueeInterval: 'Definir Intervalo DRP/DRC',
        setTariff: 'Definir Tipo de Tarifa',
        updateDateTime: 'Atualizar Data e Hora',
        readDateTime: 'Ler Data e Hora',
        updatePeriod: 'Alterar Período',
        getRelay: 'Obter estado do relé',
        setRelayOff: 'Desconectar Relé',
        setRelayOn: 'Conectar Relé',
        setReferenceVoltage: 'Tensão de Referência',
        getReferenceVoltage: 'Obter Tensão de Referência',
        recoverActiveEnergy: 'Solicitar Energias',
        getNetworkType: 'Obter Tipo de Rede',
        setNetworkPublic: 'Mudar para rede pública',
        setNetworkPrivate: 'Mudar para rede privada',
        getTech: 'Obter Tecnologia',
        setNetworkCatm1: 'Mudar para CATM1',
        setNetworkNbiot: 'Mudar para NBIoT',
        getCellIdAndIP: 'Obter Cell ID e IP',
        getHeartbeat: 'Recuperar qualidade de sinal',
        setEventQeeIndicator: 'Recuperar Parâmetros de Qualidade',
        setStandartFrozenData: 'Definir Energias Padrão',
        setDisplayAuto: 'Configurar Display Auto',
        setDisplayManual: 'Configurar Display Manual',
        setDisplayAutoMicroMax: 'Configurar Display Auto MicroMax',
        setDisplayManualMicroMax: 'Configurar Display Manual MicroMax',
        recoverShortDurationAlarms: 'Recuperar Alarmes de Curta Duração',
        getFiscalPage: 'Recuperar Página Fiscal',
        getLoadProfile: 'Recuperar Perfil de Carga',
        getDailyBilling: 'Recuperar Faturamento Diário',
        updateDatetimeSmc: 'Atualizar Data/Hora (SMC)',
        updateDatetimeSmi: 'Atualizar Data/Hora (SMI)',
        instantMeasureSmc: 'Leitura Instantânea SMC',
        instantMeasureSmi: 'Leitura Instantânea',
        requestInstantMeasures: 'Solicitar medidas instantâneas',
        nicResetSmi: 'Reset da NIC SMI',
        nicResetSmc: 'Reset da NIC SMC',
        recoverMassMemorySmc: 'Recuperar Memória de Massa (SMC)',
        recoverMassMemorySmi: 'Recuperar Memória de Massa (SMI)',
        recoverEnergySmc: 'Recuperar Energia SMC',
        recoverEnergySmi: 'Recuperar Energia',
        recoverQeeIndicator: 'Recuperar Indicador QEE (Nepen)',
        requestRelayStatusAllSmc: 'Requisitar Status de Todos os Relés',
        requestDoorStatus: 'Obter Estado da Porta',
        getVoltageOutLong: 'Obter Alarme Longa Interrupção',
        getVoltageOutShort: 'Obter Alarme Curta Interrupção',
        setStandardFrozenData: 'Configuração do Template de Energia padrão',
        getQeeTransparent: 'Obter Transparência',
        readDisplayConfiguration: 'Ler Configuração do Display',
        setDisplayConfiguration: 'Configurar Display',
        voltageInterruptionMonthly: 'Obter Interrupção de Tensão Mensal',
        drpDrcMonthly: 'Solicitar DRP/DRC Mensal',
        drpDrcCycle: 'Solicitar Ciclo DRP/DRC ',
        nicReset: 'Reset da NIC',
        monitoring: 'Perfil de Carga (Energia + Memória)',
        deviceReset: 'Resetar Dispositivo',
        infoRequest: 'Ler informações gerais',
        requestConfiguration: 'Ler configurações',
        getBlockSize: 'Obter Tamanho do Bloco',
        imageTransferInitiate: 'Iniciar Transferência de Imagem',
        imageTransferData: 'Dados de Transferência de Imagem',
        getFirstBlockNotTransferred: 'Obter Primeiro Bloco Não Transferido',
        imageTransferVerify: 'Verificar Transferência de Imagem',
        imageTransferActivate: 'Ativar Transferência de Imagem',
        updateFirmware: 'Atualizar Firmware',
        uploadFirmware: 'Carregar Firmware',
        getHardwareInfo: 'Obter Informações de Hardware',
        readNicInfo: 'Ler Informações do NIC',
        readNicSetup: 'Ler Configuração do NIC',
        readRelay: 'Ler Relé',
        readTimestamp: 'Ler Timestamp',
        readNicData: 'Ler Dados do NIC',
        nicSetup: 'Configuração do NIC',
        readLdrUpper: 'Ler LDR Superior',
        readLdrBottom: 'Ler LDR Inferior',
        readLdrMin: 'Ler LDR Mínimo',
        setLdrUpper: 'Definir LDR Superior',
        setLdrBottom: 'Definir LDR Inferior',
        setLdrMin: 'Definir LDR Mínimo',
        readNicSerial: 'Ler Serial do NIC',
        readRelayWithLastSwitchOn: 'Ler Relé com Último Acionamento',
        readRelayWithLastSwitchOnAndOff: 'Ler Relé com Último Acionamento e Desligamento',
        setBlockSize: 'Definir Tamanho do Bloco',
        multicastGroupSetup: 'Configuração de Grupo Multicast',
        multicastClassCSession: 'Sessão Multicast Classe C',
        multicastSetupConfirmation: 'Confirmação de Configuração Multicast',
        imageTransferStatus: 'Status da Transferência de Imagem',
        getFirmwareVersion: 'Obter Versão do Firmware',
        readAlarmFakeOnOff: 'Ler Alarme Falso On/Off',
        configureApplicationGroup: 'Configurar Grupo de Aplicação',
        readALarmLastGasp: 'Ler Alarme de Último Suspiro',
        setLastGaspVoltageLevel: 'Definir Nível de Tensão de Último Suspiro',
        readAlarmVoltageMonitor: 'Ler Monitor de Tensão de Alarme',
        setVoltageMinimalInterval: 'Definir Intervalo Mínimo de Tensão',
        setAlarmFakeOnOffThreshold: 'Definir Limite de Alarme Falso On/Off',
        readTemperatureValue: 'Ler Valor da Temperatura',
        readRelayWithDelay: 'Ler Relé com Atraso',
        deviceCreated: 'Dispositivo criado',
        deviceUpdated: 'Dispositivo atualizado',
        scheduleCreated: 'Agendamento criado',
        scheduleUpdated: 'Agendamento atualizado',
        groupCreated: 'Grupo criado',
        groupUpdated: 'Grupo atualizado',
        setAlarmFakeOnOff: 'Alarme On/Off',
        scheduleCanceled: 'Agendamento cancelado',
        scheduleDeleted: 'Agendamento excluido',
        deviceDeleted: 'Dispositivo excluido',
        groupDeleted: 'Grupo excluido',
        checkScheduleStatus: 'Checar Status de Agendamento',
        activateSchedule: 'Ativar agendamento',
        deactivateSchedule: 'Desativar agendamento',
        checkScheduleExist: 'Checar se agendamento existe',
        readDeviceType: 'Ler tipo de dispositivo',
        writeDeviceRole: 'Atribuir tipo de dispositivo',
        fullScheduleCommand: 'Comando completo de agendamento',
        scheduleCreatedOnSystem: 'Agendamento criado (Sistema)',
        activateScheduleOnSystem: 'Ativar agendamento (Sistema)',
        checkScheduleStatusOnSystem: 'Checar Status de Agendamento (Sistema)',
        writeDeviceRoleOnSystem: 'Atribuir tipos de dispositivo (Sistema)',
        deactivateScheduleOnSystem: 'Desativar agendamento (Sistema)',
        checkScheduleExistOnSystem: 'Checar se agendamento existe (Sistema)',
        readDeviceTypeOnSystem: 'Ler tipo de dispositivo (Sistema)',
        setDatetimeOnSystem: 'Atualizar Data e Hora (Sistema)',
        periodicConfiguration: 'Configuração da Periodicidade',
        decommissioning: 'Descomissionamento',
        openSession: 'Abrir Sessão com Medidor',
        readMeterSerial: 'Ler Serial do Medidor',
        importMassMeters: 'Importar medidores em massa',
        saveConfig: 'Salvar configuração',
        readConfig: 'Ler configuração',
        saveTime: 'Salvar datetime',
        timeCorrection: 'Correção do time',
        storage: 'Armazenamento',
        fuotaPause: 'Pausa da atualização de firmware',
        deleteSpecialDays: 'Apagar feriados',
        getTotalizers: 'Ler totalizadores',
        getRelayStatusControl: 'Ler Status de Controle do Relé',
        setRelayStatusControl: 'Alterar Status de Controle do Relé',
        getIntegrationInstantaneousReadings: 'Ler valores instantâneos',
        getVoltageOutLongShort: 'Obter Alarme Voltage Out Long e short',
        relayStatusOrca: 'Recuperar estado do relé orca',
        getQeeOnDemand: 'Solicitar parâmetros de qualidade por demanda',
        getQeeHistoricalData:
          'Solicitar o histórico de leitura de dados dos parâmetros de qualidade',
        recoverFragmentedPacket: 'Recuperar dados fragmentados',
        drpDrcEventLog: 'DRP and DRC Event Log',
        readTariffPeriods: 'Get Tariff Reading',
        smartFuseAlarmAck: 'Alarme Ack',
        getCollectiveCutStatus: 'Obter Estado de corte coletivo',
        sendRollback: 'Enviar RollBack',
        disableCollectiveCut: 'Autorizar Abertura de Portas',
        enableCollectiveCut: 'Desativar Abertura de Porta',
        relayOnAllMeterSmc: 'Religar Todos os Clientes',
        getStatus: 'Obter Estado do Relé',
        activate: 'Ativar Relé',
        disable: 'Desativar Relé',
        requestMeters: 'Requisitar Medidores',
        setInterval: 'Alterar Período de Envio',
        setBroker: 'Alterar Broker MQTT',
        setWifi: 'Alterar Rede WIFI',
        getTariffReading: 'Obter Tipo de Tarifa',
        ImportAlarms: 'Importar Alarmes',
      },
      placeholders: {
        selectCommand: 'Selecione um comando',
        sendToSelected: 'Enviar Para Selecionados',
        setInformation: 'Definir intervalo de Informação(min)',
        setMonitoring: 'Definir intervalo de Monitoramento(min)',
        ssid: 'SSID',
        wifiMode: 'Modo',
        selectWifiMode: 'Selecione o modo',
        accessPoint: 'Ponto de Acesso',
        brokerAddress: 'Endereço do Broker',
        userName: 'Nome de Usuário',
        port: 'Porta',
      },
      messagesSuccess: {
        success: 'Sucesso',
        commandSent: 'Comando enviado com sucesso!',
        commandExecuted: 'Comando executado com sucesso!',
      },
      messagesErrors: {
        error: 'Erro',
        commandSent: 'Erro ao enviar comando',
        commandExecuted: 'Erro ao executar comando',
        errorVerifyCommandCondition: 'Erro ao verificar condição do comando',
        errorFilterCommands: 'Erro ao filtrar comandos disponíveis',
        commandExecutedTryAgain:
          'Não foi possível executar o comando.\nTente novamente mais tarde.',
        commandExecutedPartial: 'Os comandos foram executados parcialmente.',
        commandExecutedPartialNotExecute: ' não executaram.',
      },
    },
    dataExtraction: {
      title: 'Exportação de dados',
      cardTitle: 'Extração de dados em massa',
      dateRangePlaceholder: 'Selecione o período',
      dateRangeTooltip: 'Informe um período de no máximo 30 dias',
      selectPlaceholder: 'Tipo de exportação',
      consult: 'Consultar',
      serialLabel: 'Serial',
      serialsPlaceholder:
        'Informe um serial por linha, ou separados por vírgula, espaço ou ponto e vírgula. O preenchimento é opcional. Você pode ajustar as informações que deseja puxar conforme os filtros informados. Apenas o tipo de exportação e o período são obrigatórios; serial e cliente são opcionais.',
      serialsHint: 'Total de seriais válidos: {total}',
      previewTitle: 'Pré-visualização dos registros',
      tableEmpty: 'Nenhum registro encontrado',
      noResults: 'Nenhum registro foi encontrado para os filtros informados.',
      previewError: 'Erro ao consultar os dados para exportação.',
      maxRangeExceededError: 'O intervalo informado deve ser de no máximo 30 dias.',
      maxRangeFutureDateError: 'A data final não pode ser maior que a data de hoje.',
      filter: {
        typeLabel: 'Tipo de exportação',
        periodLabel: 'Período',
        clientLabel: 'Cliente',
        clientPlaceholder: 'Selecione um cliente',
        validationMessage:
          'Informe o tipo de exportação e o período. Serial e cliente são opcionais.',
      },
      types: {
        massMemory: 'Memória de massa',
        energy: 'Energia',
        alarms: 'Alarmes',
        latestQualityParameters: 'Parâmetros de qualidade mais recentes',
        qualityDicFic: 'Parâmetros de qualidade - DIC/FIC',
        qualityDrpDrc: 'Parâmetros de qualidade - DRP/DRC',
      },
      clearFiltersDialog: {
        title: 'Limpar filtros',
        message: 'Deseja realmente limpar os filtros e a pré-visualização dos dados?',
        cancel: 'Cancelar',
        confirm: 'Confirmar',
      },
      summary: {
        warning: 'Atenção',
        info: 'Informação',
        success: 'Sucesso',
        error: 'Erro',
      },
      importSpreadsheet: {
        button: 'Importar planilha',
        downloadModel: 'Baixar modelo',
        noFileSelected: 'Nenhum arquivo selecionado.',
        serialWhitespaceError:
          'As linhas {rows} do arquivo possuem seriais com espaços em branco inválidos.',
        emptySerialError: 'O arquivo contém linhas com o campo Serial vazio.',
        noValidSerials: 'Nenhum serial válido foi encontrado na planilha.',
        fileProcessError: 'Erro ao processar arquivo.',
        importSuccess: '{total} serial(is) importado(s) da planilha com sucesso.',
      },
    },
    firmware: {
      title: 'Versão de Firmware',
      version: 'Versão de Firmware',
      registerFirmware: 'Nova Versão',
      editFirmware: 'Editar firmware',
      registerFirmwareFile: 'Importar firmwares por arquivo',
      editFirmwareFile: 'Editar firmwares por arquivo',
      success: {
        getFirmwares: 'Firmwares buscados com sucesso',
      },
      errors: {
        getFirmwares: 'Erro ao buscar firmwares',
      },
    },
    keys: {
      title: 'Chaves',
      importKeys: 'Importar Chaves',
      editKeysInBulk: 'Editar Chaves em Massa',
      registerKeysInBulk: 'Cadastrar Chaves em Massa',
      periodPlaceholder: 'Selecione o período',
      success: {
        getKeys: 'Chaves buscadas com sucesso',
        createKey: 'Chave cadastrada com sucesso',
        updateKey: 'Chave atualizada com sucesso',
        addMassKeys: 'Requisição de cadastro de chaves enviada',
      },
      errors: {
        getKeys: 'Erro ao buscar chaves',
        createKey: 'Erro ao cadastrar chave',
        updateKey: 'Erro ao atualizar chave',
        addMassKeys: 'Erro ao enviar comando',
        convertKey: 'Erro ao converter chave para hexadecimal',
      },
      toasts: {
        importSuccess: 'Importação realizada com sucesso',
        importSuccessDetail: 'Todas as chaves foram importadas com sucesso',
        importPartial: 'Importação parcialmente concluída',
        importPartialDetail: 'chave importada com sucesso, | chaves importadas com sucesso,',
        importError: 'Erro ao importar chaves',
        editSuccess: 'Edição realizada com sucesso',
        editSuccessDetail: 'Todas as chaves foram editadas com sucesso',
        editPartial: 'Edição parcialmente concluída',
        editPartialDetail: 'chave editada com sucesso, | chaves editadas com sucesso,',
        editError: 'Erro ao editar chaves',
        failed: 'falhou | falharam',
      },
    },
    tags: {
      title: 'Tags',
      newTag: 'Nova Tag',
      success: {
        getTags: 'Tags buscadas com sucesso',
        createTag: 'Tag criada com sucesso',
        updateTag: 'Tag atualizada com sucesso',
        deleteTag: 'Tag excluída com sucesso',
      },
      errors: {
        getTags: 'Erro ao buscar tags',
        createTag: 'Erro ao criar tag',
        updateTag: 'Erro ao atualizar tag',
        deleteTag: 'Erro ao excluir tag',
      },
    },
    groups: {
      title: 'Grupos',
    },
    veeGroups: {
      pageTitle: 'Configuração VEE - Grupos VEE',
      title: 'Grupos VEE',
      tableTitle: 'Grupos VEE',
      actions: {
        newGroup: 'Novo Grupo VEE',
      },
      columns: {
        name: 'Nome',
        purpose: 'Finalidade',
        scope: 'Escopo',
        mode: 'Modo',
        period: 'Vigência',
        frequency: 'Frequência',
        priority: 'Prioridade',
        rules: 'Regras',
        status: 'Status',
        actions: 'Ações',
      },
      filters: {
        searchLabel: 'Busca por nome ou descrição',
        searchPlaceholder: 'Pesquisa rápida',
        purpose: 'Finalidade',
        status: 'Status',
        scope: 'Escopo de dados',
        mode: 'Modo operacional',
        referenceDate: 'Data de referência',
        referenceDatePlaceholder: 'Selecione a data de referência',
        selectOption: 'Selecione',
      },
      status: {
        active: 'Ativo',
        inactive: 'Inativo',
      },
      scopes: {
        massMemory: 'Memória de Massa',
        totalizers: 'Totalizadores',
        both: 'Híbrido',
      },
      modes: {
        gate: 'Gate',
        consultative: 'Consultivo',
      },
      purpose: {
        billing: 'Validação para Faturamento',
        monitoring: 'Monitoramento Operacional',
      },
      retentionLevel: {
        reading: 'Leitura',
        channel: 'Canal',
        cycle: 'Ciclo',
        meter: 'Medidor',
      },
      period: {
        openEnded: 'Aberto',
      },
      details: {
        loadingTitle: 'Carregando Grupo VEE...',
        breadcrumbTitle: 'Detalhes do Grupo VEE',
        badge: 'Operação/consulta',
        inDevelopment: 'Funcionalidade em desenvolvimento',
        sections: {
          configuration: 'Configuração do Grupo VEE',
          fallback: 'Configuração de Estimativa (Fallback)',
          pipeline: 'Pipeline',
          readingHistory: 'Histórico de Leituras',
          groupMeters: 'Medidores do grupo',
          pendingEstimates: 'Propostas de estimativa pendentes',
        },
        labels: {
          historicalWindow: 'Janela Histórica',
        },
        fallbackSettings: {
          caption: 'Reordene o fallback e ajuste a janela histórica conforme o contrato atual.',
          savingTitle: 'Salvando...',
          saving: 'Salvando configuração de fallback...',
          successTitle: 'Sucesso',
          success: 'Configuração de fallback atualizada com sucesso',
          errorTitle: 'Erro',
          error: 'Erro ao atualizar configuração de fallback',
        },
        actions: {
          retry: 'Tentar novamente',
          backToList: 'Voltar para Grupos VEE',
          configureGroup: 'Configurar grupo',
          approveSelected: 'Aprovar selecionadas',
          reject: 'Rejeitar',
        },
        empty: {
          fallback: 'Nenhum fallback configurado.',
        },
        summary: {
          notAvailable: '-',
          caption: 'Resumo operacional com dados reais já disponíveis no detalhe do grupo.',
          labels: {
            group: 'Grupo',
            scope: 'Tipo/Escopo',
            objective: 'Objetivo',
            mode: 'Modo',
            lastExecution: 'Última execução',
            priority: 'Prioridade',
            frequency: 'Frequência',
            period: 'Período',
            status: 'Status',
          },
        },
        configuration: {
          caption: 'Escopo, vigência, modo, bloqueio e nível de resolução do grupo.',
          labels: {
            scope: 'Escopo do grupo',
            validity: 'Vigência',
            mode: 'Modo Gate/Consultivo',
            blockingPolicy: 'Política de bloqueio',
            resolutionLevel: 'Nível de resolução hierárquica',
            frequency: 'Frequência',
          },
          blockingPolicies: {
            none: 'Não aplicável',
            blockOnOpenException: 'Bloquear em exceção aberta',
          },
        },
        errors: {
          title: 'Erro ao carregar Grupo VEE',
          load: 'Erro ao carregar Grupo VEE',
          groupNotFound: 'Grupo não encontrado',
        },
        pipeline: {
          caption:
            'Preview visual local do pipeline enquanto a biblioteca nativa de regras e o fluxo real ainda nao foram implementados.',
          columns: {
            name: 'Nome',
            lastExecution: 'Última execução',
            actions: 'Ações',
          },
        },
        readingHistory: {
          real: 'Real',
          approvedEstimated: 'Estimado aprovado',
          proposed: 'Proposto',
          previewHint:
            'Pré-visualização local do detalhe do grupo com três séries visuais: real, estimado aprovado e proposto.',
        },
        meters: {
          openTab: 'Abrir aba VEE',
          previewHint:
            'Preview visual local enquanto a abertura da Aba VEE do medidor fica para atividade futura.',
          columns: {
            serial: 'Medidor',
            note: 'Observação',
            state: 'Estado',
            actions: 'Ações',
          },
          notes: {
            stableReadings: 'Medidor com leituras reais consistentes nas últimas janelas.',
            approvedInterpolation: 'Último intervalo com estimativa aprovada por interpolação.',
            noCommunication: 'Sem comunicação no período mais recente do grupo.',
            withPendency: 'Medidor com proposta de estimativa aguardando aprovação.',
            blocked: 'Medidor bloqueado para faturamento até resolução da exceção.',
          },
          states: {
            ok: 'OK',
            estimated: 'Estimado',
            noCommunication: 'Sem comunicação',
            withPendency: 'Com pendência',
            blocked: 'Bloqueado',
          },
        },
        pendingEstimates: {
          previewHint:
            'Preview visual local das propostas pendentes deste grupo, sem implementar fluxo operacional novo.',
          summary: '{count} propostas pendentes',
          summaryCaption: 'Métodos mais recorrentes: interpolação, dia proxy e perfil de carga.',
          pendingStatus: 'Pendente',
          labels: {
            method: 'Método',
            proposedValue: 'Valor proposto',
          },
          columns: {
            status: 'Status',
          },
        },
      },
      form: {
        createTitle: 'Criar Grupo VEE',
        editTitle: 'Editar Grupo VEE',
        fields: {
          name: 'Nome do grupo',
          purposeCode: 'Finalidade',
          dataScope: 'Escopo de dados',
          period: 'Período',
          effectiveFrom: 'Vigência inicial',
          effectiveTo: 'Vigência final',
          fallback: 'Fallback',
          historicalWindow: 'Janela Histórica',
          blockingPolicyCode: 'Gatilho de faturamento',
          executionFrequency: 'Frequência de execução',
          operationalMode: 'Modo',
          priority: 'Prioridade (1-10)',
        },
        placeholders: {
          name: 'Nome do grupo',
          effectiveFrom: 'Selecione',
          effectiveTo: 'Selecione',
          blockingPolicyCode: 'Gatilho de faturamento',
          select: 'Selecione',
        },
        frequency: {
          immediate: 'Sob Demanda',
          dailyDigest: 'Digest diário',
          weeklyDigest: 'Digest semanal',
        },
        fallback: {
          interpolation: 'Interpolação',
          proxyDay: 'Dia Proxy',
          loadProfile: 'Perfil de Carga',
          scalarCalculation: 'Cálculo escalar',
          moveUp: 'Mover fallback para cima',
          moveDown: 'Mover fallback para baixo',
          sevenDays: '7 dias',
          fifteenDays: '15 dias',
          oneMonth: '1 mês',
        },
        priorityScale: {
          low: 'Baixa',
          medium: 'Média',
          high: 'Alta',
        },
        actions: {
          cancel: 'Cancelar',
          save: 'Salvar',
          saving: 'Salvando',
        },
        messages: {
          saveNotAvailableTitle: 'Fluxo em preparação',
          saveNotAvailableDetail:
            'O salvamento do VEE Group será implementado nas próximas microatividades.',
        },
        validation: {
          title: 'Atenção',
          summary: 'Revise os campos destacados antes de salvar',
          required: 'Campo obrigatório',
          nameRequired: 'Nome do grupo é obrigatório',
          purposeRequired: 'Finalidade é obrigatória',
          dataScopeRequired: 'Escopo de dados é obrigatório',
          effectiveFromRequired: 'Data inicial é obrigatória',
          invalidPeriod: 'A data final deve ser maior ou igual à data inicial',
          blockingPolicyCodeRequired: 'Gatilho de faturamento é obrigatório no modo Gate',
          executionFrequencyRequired: 'Frequência de execução é obrigatória',
          operationalModeRequired: 'Modo é obrigatório',
          priorityRange: 'Prioridade deve estar entre 1 e 10',
        },
      },
      errors: {
        title: 'Erro',
        loadList: 'Erro ao carregar grupos VEE',
        create: 'Erro ao criar Grupo VEE',
        update: 'Erro ao atualizar Grupo VEE',
        deactivate: 'Erro ao inativar Grupo VEE',
      },
      success: {
        title: 'Sucesso',
        create: 'Grupo VEE criado com sucesso',
        update: 'Grupo VEE atualizado com sucesso',
        deactivate: 'Grupo VEE inativado com sucesso',
      },
      deactivateDialog: {
        title: 'Confirmar inativação',
        description: 'Deseja realmente inativar este Grupo VEE?',
        confirm: 'Inativar',
      },
      placeholderDialog: {
        title: 'Fluxo em preparação',
        close: 'Fechar',
        messages: {
          view: 'A visualização detalhada do VEE Group será implementada nas próximas microatividades.',
          inactivate: 'A inativação do VEE Group será implementada nas próximas microatividades.',
        },
      },
    },
    veeConfiguration: {
      groupDetails: {
        loadingTitle: 'Carregando configuração...',
        breadcrumbTitle: 'Configuração do Grupo VEE',
        pageTitlePrefix: 'Configuração VEE',
        actions: {
          backToDetails: 'Voltar para o Detalhe do Grupo',
          retry: 'Tentar novamente',
        },
        sections: {
          identification: 'Escopo, vigência, modo, bloqueio, nível hierárquico e frequência',
          pipeline: 'Pipeline de regras',
          fallback: 'Estimativa - fallback e Janela Histórica',
        },
        labels: {
          scope: 'Escopo',
          validity: 'Vigência',
          mode: 'Modo',
          blockingPolicy: 'Política de bloqueio',
          resolutionLevel: 'Nível de resolução hierárquica',
          frequency: 'Frequência',
        },
        blockingPolicyOptions: {
          perMeter: 'Por medidor inteiro',
          perReadingPeriod: 'Por período de leitura',
          alertOnly: 'Apenas alerta',
        },
        pipeline: {
          caption:
            'Pré-visualização local do pipeline enquanto a biblioteca nativa de regras (atividade 008) ainda não está disponível.',
          columns: {
            order: 'Ordem',
            rule: 'Regra',
            severity: 'Severidade',
            action: 'Ação',
            validity: 'Vigência',
            actions: 'Ações',
          },
          severities: {
            info: 'Info',
            issue: 'Issue',
            terminate: 'Terminate',
          },
          actions: {
            alert: 'Apenas alertar',
            hold: 'Reter',
            blockBilling: 'Bloquear billing',
            stopPipeline: 'Impedir finalização',
          },
          crud: {
            create: 'Cadastrar Pipeline',
            edit: 'Editar',
            delete: 'Excluir',
          },
          form: {
            createTitle: 'Cadastrar Regra do Pipeline',
            editTitle: 'Editar Regra do Pipeline',
            fields: {
              rule: 'Regra',
              severity: 'Severidade',
              action: 'Ação',
              effectiveFrom: 'Vigência início',
              effectiveTo: 'Vigência fim',
            },
            placeholders: {
              select: 'Selecione',
              effectiveFrom: 'Início da vigência',
              effectiveTo: 'Fim da vigência',
            },
            validation: {
              ruleRequired: 'Selecione uma regra para o pipeline',
              effectiveFromRequired: 'A vigência início é obrigatória',
              invalidPeriod: 'A vigência fim não pode ser anterior à vigência início',
            },
          },
          deleteDialog: {
            title: 'Excluir regra do pipeline',
            description: 'Esta ação removerá a regra selecionada do pipeline.',
            confirm: 'Excluir',
          },
          toast: {
            created: 'Regra do pipeline cadastrada com sucesso',
            updated: 'Regra do pipeline atualizada com sucesso',
            deleted: 'Regra do pipeline excluída com sucesso',
          },
        },
        errors: {
          title: 'Erro ao carregar configuração',
          load: 'Erro ao carregar a configuração do grupo',
          groupNotFound: 'Grupo não encontrado',
        },
      },
      rulesLibrary: {
        pageTitle: 'Configuração VEE - Biblioteca de Regras',
        breadcrumbTitle: 'Biblioteca de Regras',
        tableTitle: 'Biblioteca de Regras',
        columns: {
          name: 'Regra',
          scope: 'Escopo',
          cost: 'Custo',
          status: 'Status',
          actions: 'Ação',
        },
        actions: {
          create: 'Cadastrar regra',
          thresholds: 'Thresholds',
          thresholdsTooltip: 'Configurar thresholds da regra',
          edit: 'Editar',
          delete: 'Excluir',
        },
        filters: {
          searchPlaceholder: 'Pesquisa rápida',
          scope: 'Escopo',
          cost: 'Custo',
          status: 'Status',
          severity: 'Severidade',
          selectOption: 'Selecione',
        },
        form: {
          createTitle: 'Cadastrar Regra',
          editTitle: 'Editar Regra',
          fields: {
            name: 'Regra',
            description: 'Descrição',
            scope: 'Escopo',
            dataType: 'Tipo de dado',
            defaultSeverity: 'Severidade padrão',
            defaultAction: 'Ação operacional padrão',
            cost: 'Custo',
            status: 'Status',
          },
          placeholders: {
            name: 'Nome da regra',
            description: 'Descrição resumida da regra',
            select: 'Selecione',
          },
          validation: {
            nameRequired: 'Informe o nome da regra',
          },
          actions: {
            cancel: 'Cancelar',
            save: 'Salvar',
          },
        },
        deleteDialog: {
          title: 'Excluir regra',
          description:
            'Esta ação é apenas uma simulação visual, nenhuma regra será removida de fato.',
          confirm: 'Excluir',
        },
        toast: {
          created: 'Regra criada com sucesso',
          updated: 'Regra atualizada com sucesso',
          deleted: 'Regra excluída com sucesso',
        },
      },
      ruleThresholds: {
        dialogTitle: 'Thresholds da Regra',
        labels: {
          rule: 'Regra',
          upperLimit: 'Limite superior (%)',
          lowerLimit: 'Limite inferior (%)',
          basis: 'Base de cálculo',
          seasonality: 'Sazonalidade',
        },
        basisOptions: {
          absolute: 'Absoluto',
          historical: 'Baseado em histórico',
        },
        placeholders: {
          selectRule: 'Selecione a regra',
        },
        validation: {
          lowerGreaterThanUpper: 'O limite inferior não pode ser maior que o limite superior',
        },
        actions: {
          cancel: 'Cancelar',
          save: 'Salvar',
        },
        toast: {
          saved: 'Configuração salva com sucesso',
        },
      },
      billingCalendar: {
        pageTitle: 'Configuração VEE - Calendário de Faturamento',
        breadcrumbTitle: 'Calendário de Faturamento',
        tableTitle: 'Calendário de Faturamento',
        columns: {
          group: 'Grupo',
          readingDay: 'Dia de leitura',
          closingDay: 'Data de fechamento',
          triggerDMinusN: 'Gatilho D-N',
          status: 'Status',
          actions: 'Ações',
        },
        statusOptions: {
          ready: 'Pronto',
          pending: 'Pendente',
          blocked: 'Bloqueado',
        },
        labels: {
          group: 'Grupo',
          readingDay: 'Dia de leitura',
          closingDay: 'Data de fechamento',
          triggerDMinusN: 'Gatilho D-N',
        },
        placeholders: {
          selectDay: 'Selecione o dia',
          searchPlaceholder: 'Pesquisa rápida',
        },
        filters: {
          status: 'Status',
          selectOption: 'Selecione',
        },
        form: {
          createTitle: 'Cadastrar Calendário',
          editTitle: 'Editar Calendário',
          actions: {
            create: 'Cadastrar Faturamento',
            cancel: 'Cancelar',
            save: 'Salvar',
            edit: 'Editar',
            delete: 'Excluir',
          },
        },
        deleteDialog: {
          title: 'Excluir calendário',
          description:
            'Esta ação é apenas uma simulação visual, nenhum calendário será removido de fato.',
          confirm: 'Excluir',
        },
        toast: {
          created: 'Calendário cadastrado com sucesso',
          updated: 'Calendário atualizado com sucesso',
          deleted: 'Calendário excluído com sucesso',
        },
      },
      notifications: {
        pageTitle: 'Configuração VEE - Notificações',
        breadcrumbTitle: 'Notificações',
        tableTitle: 'Notificações',
        columns: {
          group: 'Grupo',
          frequency: 'Frequência',
          recipients: 'Destinatários',
          escalationChannel: 'Canal de escalonamento',
          eventTypes: 'Tipos de evento',
          status: 'Status',
          actions: 'Ações',
        },
        labels: {
          veeGroup: 'Grupo VEE',
          frequency: 'Frequência',
          groupRecipients: 'Destinatários por grupo',
          escalationChannel: 'Canal de escalonamento (billing readiness crítico)',
          eventTypes: 'Tipos de evento monitorados',
        },
        placeholders: {
          searchPlaceholder: 'Pesquisa rápida',
          selectVeeGroup: 'Selecione o grupo VEE',
        },
        filters: {
          frequency: 'Frequência',
          status: 'Status',
          selectOption: 'Selecione',
        },
        form: {
          createTitle: 'Cadastrar Notificação',
          editTitle: 'Editar Notificação',
          actions: {
            create: 'Cadastrar notificação',
            cancel: 'Cancelar',
            save: 'Salvar',
            edit: 'Editar',
            delete: 'Excluir',
          },
        },
        deleteDialog: {
          title: 'Excluir notificação',
          description:
            'Esta ação é apenas uma simulação visual, nenhuma notificação será removida de fato.',
          confirm: 'Excluir',
        },
        validation: {
          invalidEmail: 'Informe um e-mail válido',
          veeGroupRequired: 'Selecione o grupo VEE',
        },
        toast: {
          created: 'Notificação cadastrada com sucesso',
          updated: 'Notificação atualizada com sucesso',
          deleted: 'Notificação excluída com sucesso',
        },
      },
      hierarchyAssociation: {
        pageTitle: 'Configuração VEE - Associação por Hierarquia',
        breadcrumbTitle: 'Associação por Hierarquia',
        tableTitle: 'Associação por Hierarquia',
        columns: {
          level: 'Nível',
          criterion: 'Critério',
          appliedGroup: 'Grupo aplicado',
          priority: 'Prioridade',
          validity: 'Vigência',
          status: 'Status',
          actions: 'Ações',
        },
        statusOptions: {
          active: 'Ativo',
          inactive: 'Inativo',
        },
        levelOptions: {
          meter: 'Medidor',
          meterGroup: 'Grupo de medidores',
          tariffClass: 'Classe tarifária',
          technology: 'Tecnologia',
          default: 'Default',
        },
        actions: {
          create: 'Cadastrar associação',
          edit: 'Editar',
          delete: 'Excluir',
        },
        filters: {
          searchPlaceholder: 'Pesquisa rápida',
          level: 'Nível',
          status: 'Status',
          selectOption: 'Selecione',
        },
        form: {
          createTitle: 'Cadastrar Associação',
          editTitle: 'Editar Associação',
          fields: {
            level: 'Nível',
            criterion: 'Critério',
            appliedGroup: 'Grupo aplicado',
            priority: 'Prioridade',
            effectiveFrom: 'Vigência início',
            effectiveTo: 'Vigência fim',
            status: 'Status',
          },
          placeholders: {
            criterion: 'Informe o critério',
            select: 'Selecione',
            effectiveFrom: 'Data de início',
            effectiveTo: 'Data de término',
          },
          validation: {
            criterionRequired: 'Informe o critério',
            effectiveFromRequired: 'A vigência início é obrigatória',
            invalidPeriod: 'A vigência fim não pode ser anterior à vigência início',
          },
          actions: {
            cancel: 'Cancelar',
            save: 'Salvar',
          },
        },
        deleteDialog: {
          title: 'Excluir associação',
          description:
            'Esta ação é apenas uma simulação visual, nenhuma associação será removida de fato.',
          confirm: 'Excluir',
        },
        toast: {
          created: 'Associação criada com sucesso',
          updated: 'Associação atualizada com sucesso',
          deleted: 'Associação excluída com sucesso',
        },
      },
      customRule: {
        pageTitle: 'Configuração VEE - Regra Customizada',
        breadcrumbTitle: 'Regra Customizada',
        sections: {
          condition: 'Regra Customizada',
          sandbox: 'Sandbox',
          dryRun: 'Dry-run - impacto',
        },
        labels: {
          condition: 'Condição',
          operator: 'Operador',
          value: 'Valor',
          window: 'Janela',
          period: 'Período',
          action: 'Ação operacional',
          sandboxGroup: 'Amostra',
          summary: 'Resumo da regra',
        },
        actions: {
          runTest: 'Executar teste',
          activate: 'Ativar em produção',
        },
        dryRun: {
          affectedMeters: 'Medidores afetados',
          sampleExceptions: 'Exceções de exemplo',
        },
        toast: {
          testRun: 'Teste executado com sucesso. Agora você pode ativar a regra em produção.',
          activated: 'Operação realizada com sucesso',
        },
      },
    },
    veeGroupsLegacy: {
      title: 'Grupos VEE',
      tableTitle: 'Listagem de grupos',
      actions: {
        newGroup: 'Novo Grupo VEE',
      },
      columns: {
        name: 'Nome',
        purpose: 'Finalidade',
        scope: 'Escopo',
        mode: 'Modo',
        period: 'Vigência',
        frequency: 'Frequência',
        priority: 'Prioridade',
        rules: 'Regras',
        status: 'Status',
        actions: 'Ações',
      },
      filters: {
        searchLabel: 'Busca por nome ou descrição',
        searchPlaceholder: 'Digite nome ou descrição',
        purpose: 'Finalidade',
        status: 'Status',
        scope: 'Escopo de dados',
        mode: 'Modo operacional',
        referenceDate: 'Data de referência',
        referenceDatePlaceholder: 'Selecione a data de referência',
        selectOption: 'Selecione',
      },
      status: {
        active: 'Ativo',
        inactive: 'Inativo',
      },
      scopes: {
        massMemory: 'Memória de Massa',
        totalizers: 'Totalizadores',
        both: 'Híbrido',
      },
      modes: {
        gate: 'Gate',
        consultative: 'Consultivo',
      },
      purpose: {
        billing: 'Validação para Faturamento',
        monitoring: 'Monitoramento Operacional',
      },
      formDialog: {
        createTitle: 'Novo Grupo VEE',
        editTitle: 'Editar Grupo VEE',
        name: 'Nome',
        description: 'Descrição',
        frequency: 'Frequência',
        frequencyOptions: {
          daily: 'Diária',
          weekly: 'Semanal',
          monthly: 'Mensal',
        },
        priority: 'Prioridade',
        period: 'Vigência',
        cancel: 'Cancelar',
        save: 'Salvar',
        nameRequired: 'Informe um nome para o grupo.',
      },
      detailsDialog: {
        title: 'Detalhes do Grupo VEE',
        close: 'Fechar',
      },
      inactivateDialog: {
        title: 'Inativar Grupo VEE',
        message: 'Tem certeza que deseja inativar o grupo "{name}"?',
        cancel: 'Cancelar',
        confirm: 'Inativar',
      },
      toasts: {
        createSuccess: 'Grupo VEE criado com sucesso.',
        editSuccess: 'Grupo VEE atualizado com sucesso.',
        inactivateSuccess: 'Grupo VEE inativado com sucesso.',
      },
    },
    veeResume: {
      title: 'Monitoramento VEE — Resumo',
      badge: 'Operação/consulta',
      cards: {
        batchProcessed: 'Lote processado (%)',
        metersCompleted: 'Medidores concluídos',
        estimatesToApprove: 'Estimativas p/ aprovar',
        blocks: 'Bloqueios',
      },
      billingReadiness: {
        title: 'Prontidão de faturamento',
        empty: 'Nenhum medidor encontrado.',
        columns: {
          meter: 'Medidor',
          status: 'Status',
          pending: 'Pendências',
          action: 'Ação recomendada',
        },
        status: {
          ready: 'Pronto',
          pending: 'Pendências',
          blocked: 'Bloqueios',
        },
        units: {
          estimates: 'estimativas',
          critical: 'crítica',
        },
        actions: {
          approveEstimates: 'Aprovar estimativas',
          reviewBlock: 'Revisar bloqueio',
        },
        noPending: '—',
        actionDialog: {
          approveTitle: 'Aprovar estimativas',
          reviewTitle: 'Revisar bloqueio',
          approveMessage: 'Confirma a aprovação de {count} estimativa(s) para o medidor {meter}?',
          reviewMessage: 'Confirma a resolução do bloqueio crítico do medidor {meter}?',
          cancel: 'Cancelar',
          confirm: 'Confirmar',
          approveSuccess: 'Estimativas do medidor {meter} aprovadas com sucesso.',
          reviewSuccess: 'Bloqueio do medidor {meter} resolvido com sucesso.',
          justification: 'Justificativa (obrigatória para desbloquear)',
          justificationPlaceholder: 'Descreva o motivo do desbloqueio manual do faturamento',
          columns: {
            item: 'Item',
            value: 'Valor estimado',
          },
        },
      },
      calendar: {
        title: 'Calendário mensal',
        configureTooltip: 'Configurar calendário de faturamento',
        legend: {
          ready: 'Pronto',
          pending: 'Pendências',
          blocked: 'Bloqueios',
          note: '(com rótulo do grupo)',
        },
        weekDays: {
          sunday: 'Dom',
          monday: 'Seg',
          tuesday: 'Ter',
          wednesday: 'Qua',
          thursday: 'Qui',
          friday: 'Sex',
          saturday: 'Sáb',
        },
      },
    },
    veeBatchApproval: {
      title: 'Monitoramento VEE — Aprovação em lote',
      badge: 'Operação/consulta · supervisor',
      filters: {
        title: 'Filtros',
        group: 'Grupo',
        selectGroup: 'Selecione o grupo',
        region: 'Região',
        selectRegion: 'Selecione a região',
        method: 'Método',
        selectMethod: 'Selecione o método',
        period: 'Período',
        selectPeriod: 'Selecione o período',
        clear: 'Limpar',
        apply: 'Aplicar',
      },
      table: {
        title: 'Estimativas pendentes de aprovação',
        empty: 'Nenhuma estimativa pendente de aprovação.',
        columns: {
          meter: 'Medidor',
          method: 'Método',
          proposedValue: 'Valor proposto',
          deviation: 'Desvio',
        },
      },
      actions: {
        reject: 'Rejeitar selecionadas',
        approve: 'Aprovar selecionadas',
      },
      toasts: {
        approveSummary: 'Estimativas aprovadas',
        approveDetail: '{count} estimativa(s) aprovada(s) com sucesso.',
        rejectSummary: 'Estimativas rejeitadas',
        rejectDetail: '{count} estimativa(s) rejeitada(s).',
        noSelectionSummary: 'Nenhuma estimativa selecionada',
        noSelectionDetail: 'Selecione ao menos uma estimativa para continuar.',
        highRiskGroupSummary: 'Aprovação em lote não permitida',
        highRiskGroupDetail:
          'Medidores do Grupo A - Alta Tensão exigem aprovação individual na aba VEE do medidor, não em lote.',
        processingErrorSummary: 'Falha ao processar parte da seleção',
        processingErrorDetail: '{count} medidor(es) não puderam ser processados e permanecem selecionados.',
      },
    },
    veeReadingImport: {
      title: 'Monitoramento VEE — Importação de leituras',
      badge: 'Operação/consulta',
      downloadTemplate: 'Baixar modelo',
      importSpreadsheet: 'Importar planilha',
      importDialogTitle: 'Importar Leituras',
      dropzone: 'Arraste o arquivo ou clique para selecionar',
      empty: 'Nenhum arquivo importado ainda.',
      columns: {
        line: 'Linha',
        meter: 'Medidor',
        value: 'Valor',
        result: 'Resultado',
      },
      results: {
        ok: 'OK',
        suggestion: 'Sugestão: {value}',
        rejected: 'Rejeitada',
      },
      confirm: 'Aceitar sugestões e confirmar',
      toasts: {
        emptyFile: 'Nenhuma linha encontrada no arquivo importado.',
        validatedSummary: 'Arquivo validado',
        validatedDetail: 'Validação linha a linha concluída. Revise o resultado antes de confirmar.',
        confirmedSummary: 'Importação confirmada',
        confirmedDetail: '{suggestions} sugestão(ões) de correção aceita(s) automaticamente.',
      },
    },
    veeRequestQueue: {
      title: 'Monitoramento VEE — Fila de solicitações',
      badge: 'Operação/consulta',
      empty: 'Nenhuma solicitação pendente.',
      columns: {
        meter: 'Medidor',
        issue: 'Problema',
        slaRemaining: 'SLA restante',
        actions: 'Ações',
      },
      actions: {
        createOrder: 'Criar OS',
        edit: 'Editar',
      },
      actionDialog: {
        cancel: 'Cancelar',
        confirm: 'Confirmar',
      },
      createOrderDialog: {
        title: 'Criar Ordem de Serviço',
        technician: 'Equipe responsável',
        priority: 'Prioridade',
        dueDate: 'Prazo',
        priorities: {
          low: 'Baixa',
          medium: 'Média',
          high: 'Alta',
        },
        successSummary: 'Ordem de serviço criada com sucesso para o medidor {meter}.',
      },
      editDialog: {
        title: 'Editar estimativa',
        newValue: 'Novo valor',
        note: 'Observação',
        successSummary: 'Estimativa do medidor {meter} atualizada com sucesso.',
        invalidValueTitle: 'Valor inválido',
        invalidValueDetail: 'Informe um novo valor maior que zero.',
        justificationRequiredTitle: 'Observação obrigatória',
        justificationRequiredDetail: 'Descreva o motivo da alteração antes de confirmar.',
      },
    },
    veeZeroConsumption: {
      title: 'Monitoramento VEE — Consumo zero prolongado',
      badge: 'Operação/consulta',
      affectedMeters: 'Medidores afetados',
      empty: 'Nenhum medidor com consumo zero.',
      columns: {
        meter: 'Medidor',
        zeroSince: 'Zero desde',
        duration: 'Duração',
        vacant: 'Desocupado',
        action: 'Ação',
      },
      actions: {
        checkField: 'Verificar campo',
      },
      checkDialog: {
        title: 'Verificar campo',
        message: 'Qual o resultado da verificação de campo para o medidor {meter}?',
        outcomes: {
          vacant: 'Confirmar desocupação',
          defective: 'Medidor com defeito',
          resumed: 'Consumo retomado',
        },
        cancel: 'Cancelar',
        confirm: 'Confirmar',
        successSummary: 'Verificação de campo do medidor {meter} registrada com sucesso.',
      },
    },
    veeLimitDeviations: {
      title: 'Monitoramento VEE — Desvios de limites',
      badge: 'Operação/consulta',
      empty: 'Nenhum desvio encontrado.',
      cards: {
        above: 'Desvios acima',
        aboveUnit: 'medidores',
        below: 'Desvios abaixo',
        belowUnit: 'medidores',
      },
      charts: {
        deviationTitle: 'Distribuição de desvios por medidor',
        severityTitle: 'Distribuição por severidade',
        legendAbove: 'Acima do limite',
        legendBelow: 'Abaixo do limite',
      },
      columns: {
        meter: 'Medidor',
        deviation: 'Desvio',
        baseline: 'Baseline',
        severity: 'Severidade',
      },
    },
    veeExecutionMonitor: {
      title: 'Monitoramento VEE — Monitor de execução do batch',
      badge: 'Operação/consulta',
      empty: 'Nenhuma execução encontrada.',
      columns: {
        execution: 'Execução',
        group: 'Grupo',
        status: 'Status',
        volume: 'Volume',
        duration: 'Duração',
        backlog: 'Backlog',
      },
      status: {
        completed: 'Concluída',
        running: 'Em execução',
      },
    },
    groupDetails: {
      monthlyQualityParameters: {
        title: 'Média de DRP/DRC mensal',
        button: 'Calcular média mensal de DRP/DRC',
        dialogTitle: 'Média mensal de DRP/DRC',
        success: 'Média mensal de DRP/DRC calculada com sucesso',
        error: 'Erro ao calcular a média mensal de DRP/DRC',
        exportError: 'Selecione uma referência para exportar a média mensal de DRP/DRC.',
      },
      latestQualityParameters: {
        title: 'Parâmetros de qualidade mais recentes',
        error: 'Erro ao buscar os parâmetros de qualidade mais recentes',
      },
    },
    clients: {
      client: 'Cliente',
      clients: 'Clientes',
      clientDetails: 'Detalhes do Cliente',
      fullName: 'Nome Completo',
      location: 'Localização',
      updatedAt: 'Atualizado em',
      editClient: 'Editar Cliente',
      metersTableTitle: 'Medidores do Cliente',
      addMeters: 'Adicionar Medidores',
      removeMeters: 'Remover Medidores',
      removeMetersDescription:
        'Tem certeza que deseja remover o vínculo dos medidores selecionados neste cliente?',
      confirmRemoveMeters: 'Sim, remover',
      weights: 'Pesos',
      prefixUf: 'Prefixo UF',
      bulkLink: 'Vincular em lote',
      manageLinks: 'Gerenciar vínculos',
      linkedUsers: 'Usuários vinculados',
      unlinkSelected: 'Desvincular selecionados',
      associateClients: 'Associar clientes',
      addToTenant: 'Adicionar usuário',
      removeFromTenant: 'Remover do cliente',
      userAdded: 'Usuário adicionado ao cliente.',
      userRemoved: 'Usuário removido do cliente.',
      newUser: 'Novo usuário',
      editUser: 'Editar usuário',
      bulkLinkHeader: 'Vincular usuário a clientes em lote',
      manageLinkHeader: 'Gerenciar vínculos de usuário',
      unlinkConfirm: 'Desvincular selecionados',
      selectUser: 'Selecione um usuário',
      selectClients: 'Selecione os clientes',
      link: 'Vincular',
      errorLoadingClients: 'Erro ao carregar clientes',
      deleteClients: 'Exclusão de clientes',
      noClientSelected: 'Nenhum cliente selecionado',
      linksTitle: 'Vínculos',
      clientsLinked: '{count} cliente(s) vinculado(s).',
      clientsLinkFailed: '{count} falharam.',
      errorLinkingClients: 'Erro ao vincular clientes.',
      unlinked: 'Desvinculado.',
      countUnlinked: '{count} desvinculado(s).',
      errorUnlinking: 'Erro ao desvincular.',
      goToBulkLink: 'Ir para vincular em lote',
      goToManageLinks: 'Ir para gerenciar vínculos',
      userCreated: 'Usuário criado com sucesso.',
      errorCreatingUser: 'Erro ao criar usuário',
    },
    users: {
      title: 'Usuários',
      user: 'Usuário',
      newUser: 'Novo usuário',
      editUser: 'Editar usuário',
      yourAccountTab: 'Sua Conta',
      allUsersTab: 'Todos os Usuários',
      lastUpdateLabel: 'Última Modificação',
      confirmDelete: 'Confirmar exclusão de usuários',
      userEdited: 'Usuário editado com sucesso.',
      userAddedToClient: 'Usuário adicionado ao cliente.',
      errorAddingUser: 'Erro ao adicionar usuário',
      userUnlocked: 'Usuário desbloqueado com sucesso.',
      errorFetchingUsers: 'Erro ao buscar usuários',
      noUserSelected: 'Nenhum usuário selecionado',
      deleteUsers: 'Exclusão de usuários',
      removeUsers: 'Remover usuários',
      countRemoved: '{count} removido(s) do cliente.',
      countFailed: '{count} falharam.',
      usernameLabel: 'Nome de usuário',
      typeColumnLabel: 'Tipo',
      usernamePlaceholder: 'Digite o nome de usuário',
      grantAccess: 'Conceder acesso',
      createUser: 'Criar',
      userTypeLabel: 'Tipo de Autenticação',
      userTypeNormal: 'Normal',
      userTypeLdap: 'LDAP',
      userExists: 'Usuário encontrado no sistema.',
      userNotFound: 'Usuário não encontrado. Preencha os dados para criar.',
      nameLabel: 'Nome',
      emailLabel: 'E-mail',
      emailPlaceholder: 'Digite o e-mail',
      passwordLabel: 'Senha',
      confirmPasswordLabel: 'Confirmar senha',
      descriptionLabel: 'Descrição',
      roleLabel: 'Função',
      receiveEmailsLabel: 'Receber e-mails',
      selectRolePlaceholder: 'Selecione uma função',
      optionalPlaceholder: 'Opcional',
      passwordOptionalPlaceholder: 'Deixe em branco para manter a senha atual',
      updateButton: 'Atualizar',
      invalidEmail: 'E-mail inválido.',
      nameMinLength: 'O nome deve conter pelo menos 4 letras.',
      passwordRequirements:
        'A senha deve conter ao menos 8 caracteres, uma letra maiúscula e uma minúscula.',
      passwordMismatch: 'As senhas não coincidem.',
      clientLabel: 'Vínculos de cliente',
      noClientPlaceholder: 'Sem vínculo',
      ldapOnly: 'Somente LDAP',
      statusHeader: 'Situação',
      blocked: 'Bloqueado',
      active: 'Ativo',
      loginTypeHeader: 'Tipo de login',
      updated: 'Usuário atualizado com sucesso.',
      errorUpdatingUser: 'Erro ao atualizar usuário.',
      noClients: 'Nenhum cliente vinculado.',
      addClientPlaceholder: 'Adicionar clientes...',
    },
    balance: {
      title: 'Balanço',
      balanceCalculation: 'Cálculo de Balanço',
      balanceSettings: 'Configurações do Balanço',
      publicLighting: 'Iluminação Pública - IP (kWh)',
      search: 'Buscar',
      balanceEnergy: 'Balanço Energético',
      balanceEnergyChart: 'Gráfico de Balanço Energético',
      data: 'Data',
      meterTrafo: 'Medidor do Trafo',
      energyRequired: 'Energia Requerida (kWh)',
      energyConsumed: 'Energia Consumida (kWh)',
      energyPublicLightingLabel: 'Iluminação Pública',
      loss: 'Perda (kWh)',
      lossPercentage: 'Perda %',
      energyPublicLighting: 'Energia IP (kWh)',
      readingDateTime: 'Data de Leitura',
      initialReadingDateTime: 'Data de Leitura Inicial',
      finalReadingDateTime: 'Data de Leitura Final',
      energyInjectedConsumers: 'Energia Injetada dos Consumidores (kWh)',
      energyReverseTransformer: 'Energia Reversa do Trafo (kWh)',
      empty: 'Vazio por enquanto...',
      results: 'Resultado',
      transformerName: 'Nome do Trafo',
      areaName: 'Nome da Área',
      regionName: 'Nome da Região',
      placeholders: {
        publicLighting: 'Digite o valor',
      },
      errors: {
        loadBalance: 'Erro ao buscar balanço',
      },
    },
    transformers: {
      title: 'Transformadores',
      transformer: 'Transformador',
      startDate: 'Data inicial',
      endDate: 'Data final',
      placeholders: {
        loading: 'Carregando...',
        select: 'Escolher Transformador',
        selectDate: 'Selecione a data',
      },
      errors: {
        title: 'Erro',
        loadTransformers: 'Erro ao carregar transformadores',
      },
    },
    scheduledCommands: {
      title: 'Listagem de Rotinas',
      filterByGroup: 'Filtrar pelo nome do Grupo',
      statusChanged: 'Status do agendamento alterado',
      deleteSuccess: 'Agendamento deletado com sucesso',
      timeMax: 'Tempo máximo para execução do comando',
      description: 'Descrição',
      selectGroup: 'Selecionar grupo',
      selectCommand: 'Selecionar comando',
      editRoutine: 'Editar Rotina',
      addRoutine: 'Adicionar Rotina',
      configure: 'Configurar',
      review: 'Revisar',
      quantityLastMeasures: 'Quantidade de Últimas Medições',
      quantityLastMeasuresSmc: 'Quantidade de Últimas Medições (SMC)',
      commandParameters: 'Parâmetros do Comando',
      alternativeDataSmi: 'Dados Alternativos (SMI)',
      energyRecoveryDataSmi: 'Dados de Recuperação de Energia (SMI)',
      initialDateTime: 'Data/Hora Inicial',
      finalDateTime: 'Data/Hora Final',
      intervalMinutes: 'Intervalo em Minutos',
      seconds: 'Segundos',
      back: 'Voltar',
      update: 'Atualizar',
      add: 'Adicionar',
      routineUpdated: 'Rotina Atualizada',
      routineCreated: 'Rotina Criada',
      saveRoutineError: 'Erro ao salvar Rotina',
      unknownError: 'Erro desconhecido',
      loadGroupsError: 'Erro ao buscar grupos',
      successTitle: 'Sucesso',
      errorTitle: 'Erro',
      statusChangeError: 'Erro ao alterar status',
      deleteRoutineError: 'Erro ao excluir agendamento',
      minuteUnit: 'minuto',
      minutesUnit: 'minutos',
      placeholders: {
        filterByGroup: 'Digite o nome do Grupo',
        description: 'Digite uma descrição para a rotina',
        selectGroup: 'Selecione um grupo',
        selectCommand: 'Selecione um comando',
        quantity: 'Digite a quantidade',
        initialDate: 'Selecione a data inicial',
        finalDate: 'Selecione a data final',
        interval: 'Digite o intervalo',
        secondsQuantity: 'Digite a quantidade de segundos',
      },
      days: 'Dia(s)',
      hours: 'Hora(s)',
      minutes: 'Minuto(s)',
      cronEditor: 'Editor Cron',
      validation: {
        descriptionRequired: 'Informe a descrição da rotina.',
        descriptionHtmlNotAllowed: 'A descrição da rotina não pode conter HTML.',
        groupRequired: 'Selecione um grupo.',
        minimumDuration: 'O tempo máximo para execução do comando deve ser de pelo menos 1 minuto.',
        invalidCron: 'Configure um cron válido para a rotina.',
      },
      cronEditorOptions: {
        intlLocale: 'pt-BR',
        every: 'Todo(a)',
        second: 'Segundo',
        minute: 'Minuto',
        hour: 'Hora',
        day: 'Dia',
        week: 'Semana',
        month: 'Mês',
        year: 'Ano',
        everySecond: 'a cada segundo',
        everyMinute: 'a cada minuto',
        everyHour: 'a cada hora',
        everyMonth: 'todo mês',
        everyDayOfWeek: 'todo dia específico da semana',
        noSpecificDay: 'sem dia específico',
        noSpecificDayOfWeek: 'sem dia específico da semana',
        all: 'todos',
        of: 'de',
        onDays: 'no(s) dia(s)',
        and: 'e',
        andOf: 'e de',
        at: 'às',
        secondsSuffix: 'segundo(s)',
      },
      nextExecution: 'Próxima execução',
      lastExecution: 'Última execução',
      routineDetails: 'Detalhes da Rotina',
      routinePage: 'Página de Rotina',
      deleteRoutine: 'Deletar Rotina',
      noProcessYet: 'Nenhum processo encontrado para esta rotina até o momento.',
    },
    transformerDetails: {
      title: 'Detalhes do Transformador',
      details: 'Detalhes',
      transformer: 'Transformador',
      editTransformer: 'Editar transformador',
      name: 'Nome',
      meterSerial: 'Serial do Medidor',
      metersCount: 'Quantidade de Medidores',
      publicLighting: 'Iluminação Pública',
      coordinates: 'Coordenadas',
      updatedAt: 'Última Atualização',
      description: 'Descrição',
      viewMore: 'Ver Mais',
      meterDetails: 'Medidor do Transformador',
      manufacturerType: 'Fabricante | Tipo',
      serial: 'Serial',
      installation: 'Unidade Consumidora',
      displayConfiguration: 'Configuração de Display',
      firmware: 'Firmware',
      relayStatus: 'Estado de Relé',
      status: 'Estado',
      meterMoreDetails: 'Mais detalhes do medidor',
      latitude: 'Lat',
      longitude: 'Long',
      massMemoryCrc: 'CRC memória de massa',
      uplinkPeriod: 'Período de Uplink de Leitura',
      energyCrc: 'CRC Energia',
      tags: 'Tags do Medidor',
      noTags: 'Nenhuma tag encontrada',
      close: 'Fechar',
      loading: 'Carregando...',
    },
    areas: {
      title: 'Áreas',
      startDate: 'Data inicial',
      endDate: 'Data final',
      search: 'Buscar',
      placeholders: {
        loading: 'Carregando...',
        select: 'Escolher Área',
        selectDate: 'Selecione a data',
      },
      errors: {
        title: 'Erro',
        loadAreas: 'Erro ao carregar áreas',
      },
    },
    areaDetails: {
      title: 'Detalhes da Área',
      details: 'Detalhes',
      area: 'Área',
      editArea: 'Editar área',
      name: 'Nome',
      transformersCount: 'Quantidade de Transformadores',
      updatedAt: 'Última Atualização',
      description: 'Descrição',
      errors: {
        title: 'Erro',
        loadAreaInfo: 'Erro ao buscar informações da área',
      },
    },
    regions: {
      title: 'Regiões',
      regions: 'Regiões',
      selectPeriod: 'Selecione o período',
      startDate: 'Data inicial',
      endDate: 'Data final',
      search: 'Buscar',
      placeholders: {
        loading: 'Carregando...',
        select: 'Escolher Região',
        selectDate: 'Selecione a data',
      },
      errors: {
        title: 'Erro',
        loadRegions: 'Erro ao carregar regiões',
      },
    },
    regionDetails: {
      title: 'Detalhes da Região',
      details: 'Detalhes',
      region: 'Região',
      editRegion: 'Editar região',
      name: 'Nome',
      areasCount: 'Quantidade de Áreas',
      updatedAt: 'Última Atualização',
      description: 'Descrição',
      errors: {
        title: 'Erro',
        loadRegionInfo: 'Erro ao buscar informações da região',
      },
    },
    serviceNotes: {
      code: 'Código',
      contractAccount: 'Conta Contrato',
      dateTimeLimitConclusion: 'Data Limite de Conclusão',
      dateTimeStart: 'Data de Início',
      codeGroup: 'Grupo de Código',
      installation: 'Instalação',
      measureCodeGroup: 'Grupo de Código de Medição',
      noteNumber: 'Número da Nota',
      equipmentSerialNumber: 'Número de Série do Equipamento',
      cancellationRequest: 'Solicitação de Cancelamento',
      noteType: 'Tipo de Nota',
      cPNumber: 'Número CP',
      cSNumber: 'Número CS',
      cSPosition: 'Posição CS',
      noteGroup: 'Grupo da Nota',
      noteCode: 'Código da Nota',
      measureGroup: 'Grupo de Medição',
      equipment: 'Equipamento',
      referenceMonth: 'Mês de Referência',
      creationDate: 'Data de Criação',
      creationHour: 'Hora de Criação',
      limitDate: 'Data Limite',
      limitHour: 'Hora Limite',
      serialMeter: 'Número de Série do Medidor',
      rateType: 'Tipo de Tarifa',
      ssn: 'SSN',
      min: 'MIN',
      readingDate: 'Data da Leitura',
      readingUnit: 'Unidade da Leitura',
      day: 'Dia',
      serial: 'Serial',
      registers: 'Registradores',
      attempts: 'Tentativas',
      origin: 'Origem',
      datetime: 'Data',
      online: 'Status',
      meterActivated: 'Estado do Relé',
      comissioned: 'Comissionado',
      dateTimeInitial: 'Data de Início',
      dateTimeFinal: 'Data de Finalização',
      drp: 'DRP',
      drc: 'DRC',
      updatedAt: 'Atualizado em',
      count: 'Contagem',
      description: 'Descrição',
    },
    models: {
      title: 'Modelos',
      meterModels: 'Modelos de Medidores',
      smcModels: 'Modelos de SMCs',
      newModel: 'Novo Modelo',
      registerModelFile: 'Importar modelos por arquivo',
      editModelFile: 'Editar modelos por arquivo',
      import: {
        successAll: 'Importação realizada com sucesso',
        partial: 'Importação parcialmente concluída',
        error: 'Erro ao importar modelos',
      },
      edit: {
        successAll: 'Edição realizada com sucesso',
        partial: 'Edição parcialmente concluída',
        error: 'Erro ao editar modelos',
      },
      success: {
        createModel: 'Modelo criado com sucesso',
        updateModel: 'Modelo atualizado com sucesso',
      },
      errors: {
        title: 'Erro',
        loadModels: 'Erro ao buscar modelos',
        noModelSelected: 'Nenhum modelo selecionado',
        manufacturerNotFound: 'Fabricante não encontrado',
        createModel: 'Erro ao criar modelo',
        updateModel: 'Erro ao atualizar modelo',
      },
    },
    networkManagement: {
      title: 'Gerenciamento de Rede',
    },
    configuration: {
      title: 'Configurações',
      configure: 'Configurar',
      effectiveness: {
        title: 'Efetividade',
        description: 'Configure a quantidade mínima de medidores para cálculo de efetividade.',
        dialog: {
          title: 'Configuração de Efetividade',
          minimumQuantity: 'Quantidade Mínima',
          loading: 'Carregando...',
          cancel: 'Cancelar',
          save: 'Salvar',
        },
      },
      abruptVariation: {
        title: 'Variação Abrupta',
        description: 'Configure os parâmetros de detecção de variação abrupta de consumo.',
      },
    },
  },
  auth: {
    login: {
      title: 'Acesso ao Sistema',
      tabEmail: 'E-mail',
      tabLdap: 'AD',
      emailLabel: 'E-mail',
      usernameLdapLabel: 'Usuário de rede',
      usernameLdapPlaceholder: 'Digite seu usuário de rede',
      associate: 'Associar',
      associateWarn:
        'Verificamos que você ainda não possui vinculo no sistema. Por favor, adicione seu e-mail.',
      passwordLabel: 'Senha',
      submitButton: 'Entrar Localmente',
      submitButtonAd: 'Entrar pelo Active Directory',
      forgotPassword: 'Senha Expirada?',
      placeholders: {
        email: 'Digite seu e-mail',
        password: 'Digite sua senha',
      },
      validation: {
        invalidEmail: 'Email inválido',
        adCredentialRequired: 'Usuário de rede ou e-mail é obrigatório',
        passwordRequired: 'Senha é obrigatória',
      },
    },
    requiredChangePassword: {
      title: 'Alteração de Senha Obrigatória',
      emailLabel: 'E-mail',
      expiredPasswordLabel: 'Senha atual',
      newPasswordLabel: 'Nova senha',
      submitButton: 'Alterar Senha',
      instructions: 'Altere a senha criada pelo administrador.',
      passwordRequirements:
        'A senha deve conter pelo menos 8 caracteres, uma letra maiúscula, uma letra minúscula, um número e um caractere especial.',
      placeholders: {
        email: 'Digite seu e-mail',
        expiredPassword: 'Digite a senha atual',
        newPassword: 'Digite sua nova senha',
      },
      messages: {
        successSummary: 'Senha Alterada com Sucesso',
        successDetail: 'Da próxima vez, faça login com seu e-mail e nova senha',
        errorSummary: 'Erro',
        errorDetail: 'Erro ao alterar senha',
      },
      validation: {
        emailRequired: 'Email é obrigatório',
        expiredPasswordRequired: 'Senha atual é obrigatória',
        newPasswordMinLength: 'A senha deve ter no mínimo 8 caracteres',
        newPasswordUppercase: 'A senha deve conter pelo menos uma letra maiúscula',
        newPasswordLowercase: 'A senha deve conter pelo menos uma letra minúscula',
        newPasswordNumber: 'A senha deve conter pelo menos um número',
        newPasswordSpecial: 'A senha deve conter pelo menos um caractere especial',
        uppercase: 'Letras maiúsculas e minúsculas [A-Z]',
        lowercase: 'Letras minúsculas [a-z]',
        number: 'Números [0-9]',
        special: 'Caracteres especiais [!,@,#,$,%,^,&,* ou *]',
        minLength: 'Mínimo de 8 caracteres',
      },
    },
    userType: {
      admin: 'Administrador',
      operator: 'Operador Técnico',
      user: 'Usuário',
      erector: 'Instalador',
      manager: 'Gestor Técnico',
      sap: 'Usuário SAP',
      monitor: 'Monitor',
      invalid: 'Inválido',
      root: 'Root',
    },
    errors: {
      invalidCredentials: 'E-mail ou senha inválidos',
      missingFields: 'Todos os campos devem ser preenchidos',
    },
  },
  forms: {
    firmware: {
      title: 'Cadastrar Nova Versão de Firmware',
      detailsFirmware: 'Detalhes do Firmware: ',
      crcHexInfo: 'Valor de hex em decimal: ',
      fields: {
        crc: 'CRC (Hex ou Decimal)',
        firmwareForSMC: 'Firmware para SMC',
        nameFirmware: 'Nome da versão:',
        manufacturer: 'Fabricante:',
      },
      validation: {
        crcRequired: 'CRC é obrigatório',
        crcPrefixError: 'Remova o 0x ou espaço antes do número hexadecimal',
        crcInvalidError:
          'Valor inválido. Insira apenas números decimais ou hexadecimais (0-9, A-F)',
        crcImmutableInfo: 'O CRC não pode ser alterado após a criação',
        nameFirmwareRequired: 'Nome da versão é obrigatório',
        manufacturerRequired: 'Fabricante é obrigatório',
      },
      actions: {
        registerFirmware: 'Cadastrar',
        editFirmware: 'Editar firmware',
        deleteFirmware: 'Excluir firmware',
        deleteConfirmationTitle: 'Confirmar exclusão de firmware em massa',
        cancel: 'Cancelar',
      },
      placeholder: {
        crc: 'Digite o CRC',
        nameFirmware: 'Digite o nome da versão',
        selectManufacturer: 'Selecione um fabricante',
        loadingManufacturers: 'Carregando fabricantes...',
      },
    },
    keys: {
      title: 'Cadastrar chave',
      titleEdit: 'Modificar Chave',
      fields: {
        serial: 'Serial',
        authenticationKey: 'Chave de Autenticação',
        encryptionKey: 'Chave de Criptografia',
        masterKey: 'Chave Mestra',
        lls2: 'LLS2',
      },
      validation: {
        fieldRequired: 'Este campo é obrigatório!',
        serialImmutableInfo: 'O Serial não pode ser alterado após a criação',
        keySize: 'Este campo deve conter 32 caracteres (16 bytes).',
        lls2Size: 'Este campo deve conter 20 caracteres (medidor) ou 16 caracteres (gateway).',
      },
      actions: {
        cancel: 'Cancelar',
        create: 'Cadastrar',
        update: 'Modificar',
        save: 'Salvar',
      },
    },
    tags: {
      title: 'Nova Tag',
      titleDetails: 'Detalhes da Tag: ',
      fields: {
        name: 'Nome',
        colors: 'Cores',
      },
      actions: {
        create: 'Criar tag',
        update: 'Editar tag',
        delete: 'Excluir tag',
        cancel: 'Cancelar',
        deleteConfirmationTitle: 'Confirmar exclusão de tag em massa',
      },
      validation: {
        fieldRequired: 'Este campo é obrigatório!',
      },
    },
    smcs: {
      title: 'Cadastrar novo SMC',
      titleEdit: 'Editar SMC',
      fields: {
        serial: 'Serial do SMC',
        description: 'Descrição',
        manufacturer: 'Fabricante',
        model: 'Modelo',
        latitude: 'Latitude',
        longitude: 'Longitude',
      },
      validation: {
        serialRequired: 'Serial é obrigatório',
        serialNoSpaces: 'O serial do SMC não pode conter espaços no início, no meio ou no final.',
        descriptionRequired: 'Descrição é obrigatória',
        manufacturerRequired: 'Fabricante é obrigatório',
        modelRequired: 'Modelo é obrigatório',
        warningDialogTittle: 'Tem certeza de que deseja marcar os alarmes selecionados como lidos?',
        warningDialogMessage:
          'Ao confirmar, um ticket será gerado automaticamente com os dados do usuário responsável para fins de histórico.',
        warningDialogTittleSingle: 'Tem certeza de que deseja marcar este alarme como lido?',
      },
      actions: {
        cancel: 'Cancelar',
        create: 'Criar SMC',
        update: 'Atualizar',
        confirm: 'Confirmar',
      },
      placeholders: {
        serial: 'Digite o serial do SMC',
        description: 'Digite a descrição do SMC',
        manufacturer: 'Digite o nome do fabricante',
        model: 'Selecione o modelo',
        latitude: 'Digite a latitude',
        longitude: 'Digite a longitude',
      },
    },
    clients: {
      title: 'Cadastrar novo cliente',
      titleEdit: 'Editar cliente',
      fields: {
        fullName: 'Nome completo',
        location: 'Localização',
        weights: 'Pesos',
        prefixUf: 'Prefixo UF',
        selectAvailableMeters: 'Selecionar Medidores Disponíveis',
      },
      validation: {
        fullNameRequired: 'Nome completo é obrigatório',
        locationRequired: 'Localização é obrigatória.',
        weightsInvalidFormat:
          'Informe pesos com um dígito por posição, separados por vírgula, espaço ou ponto e vírgula.',
        weightsInvalidLength:
          'A quantidade de pesos é inválida. Valores aceitos: 6, 7 ou 10 dígitos.',
        prefixUfRequired: 'Prefixo UF é obrigatório.',
        prefixUfInvalid: 'Informe um Prefixo UF válido.',
        meterSerialRequired: 'Serial do medidor é obrigatório',
      },
      actions: {
        cancel: 'Cancelar',
        create: 'Cadastrar',
        update: 'Atualizar',
      },
    },
    tariffs: {
      dateStart: 'Data de Início',
      select: 'Selecione o Tipo de Tarifa',
      dateActivation: 'Data de Ativação',
      send: 'Enviar',
    },
    models: {
      title: 'Cadastrar novo modelo',
      titleEdit: 'Editar modelo',
      fields: {
        name: 'Nome',
        manufacturer: 'Fabricante',
        positionsCount: 'Quantidade de posições',
      },
      validation: {
        nameRequired: 'Nome é obrigatório',
        manufacturerRequired: 'Fabricante é obrigatório',
      },
      actions: {
        cancel: 'Cancelar',
        create: 'Cadastrar',
        update: 'Salvar',
      },
      placeholder: {
        name: 'Informe o nome do modelo',
        selectManufacturer: 'Selecione o fabricante',
        loadingManufacturers: 'Carregando fabricantes...',
        positionsCount: 'Quantidade de posições',
      },
    },
  },
  tables: {
    noData: 'Nenhum dado encontrado',
    general: {
      search: 'Pesquisa rápida',
      status: 'Status',
      period: 'Período',
      dateRange: 'Intervalo de datas',
      dateRangeError: 'Selecione datas de início e fim.',
      quickOptions: 'Opções rápidas',
      quickOptionsHint: 'selecione um período sugerido',
      commands: 'Comandos',
      searchByEmail: 'Pesquisa por e-mail:',
      searchBySerial: 'Pesquisa por serial:',
      selectColumns: 'Selecione as colunas:',
      commandsSelectionLimitSummary: 'Limite de seleção',
      commandsSelectionLimitDetail: 'Você pode selecionar no máximo 5 comandos.',
      commandsSelectionRequiredSummary: 'Atenção',
      commandsSelectionRequiredDetail: 'Selecione ao menos um comando.',
      selectStatus: 'Selecione os status:',
      searchByText: 'Busca por texto:',
      commissioning: 'Comissionamento:',
      typeSignalQuality: 'Tipo de sinal:',
      gatewayName: 'Nome do Gateway:',
      gatewaySerial: 'Serial do Gateway:',
      type: 'Tipo:',
      details: 'Detalhes',
      tags: 'Tags',
      selectTags: 'Selecione as tags',
      selectOption: 'Selecione uma opção',
      all: 'Todos',
      error: 'Erro',
      totalRecords: 'Total de registros: {totalRecords}',
      yes: 'Sim',
      no: 'Não',
      placeholders: {
        searchByText: 'Faça sua busca aqui',
        gatewayName: 'Nome do Gateway',
        gatewaySerial: 'Serial do Gateway',
        commissioning: 'Selecione o comissionamento',
        period: 'Selecione o período',
        type: 'Selecione o tipo',
        typeSignalQuality: 'Selecione o tipo de sinal',
        selectColumns: 'Selecione as colunas',
      },
      tableChart: {
        showAll: 'Mostrar tudo',
        showLess: 'Mostrar menos',
        displayedColumns: 'Colunas exibidas:',
        monoChartDisplayedColumns: 'Grafico:',
      },
    },
    meterFileUpload: {
      massMemory: {
        dateTime: 'Data/Hora de leitura',
        totalEnergy_Wh: 'Totalizador geral (Wh)',
        totalEnergyIncremental_Wh: 'Totalizador incremental (Wh)',
        q1ReactiveEnergy_VarH: 'Energia reativa Q1 (VarH)',
        q4ReactiveEnergy_VarH: 'Energia reativa Q4 (VarH)',
        group2VoltageVaH_V: 'Tensão Va (V)',
        group2VoltageVbH_V: 'Tensão Vb (V)',
        group2VoltageVcH_V: 'Tensão Vc (V)',
        group3CurrentIaH_A: 'Corrente Ia (A)',
        group3CurrentIbH_A: 'Corrente Ib (A)',
        group3CurrentIcH_A: 'Corrente Ic (A)',
        totalActiveEnergy_KWh: 'Energia total ativa (kWh)',
        totalInductiveReactiveEnergy_KVarh: 'Energia reativa indutiva total (kvarh)',
        totalCapacitiveReactiveEnergy_KVarh: 'Energia reativa capacitiva total (kvarh)',
        totalReverseActiveEnergy_KWh: 'Energia reversa total ativa (kWh)',
        reactiveEnergyImportQiiiRi_KVarH: 'Importação energia reativa Q3 +Ri (kvarh)',
        reactiveEnergyImportQiiRc_KVarH: 'Importação energia reativa Q2 +Rc (kvarh)',
        q1ReactiveEnergyIncremental_VarH: 'Energia reativa Q1 incremental (kWh)',
        q4ReactiveEnergyIncremental_VarH: 'Energia reativa Q4 incremental (kWh)',
        totalActiveEnergy_Wh: 'Energia ativa direta (kWh)',
        totalDirectActiveEnergy_Wh: 'Energia ativa direta total (kWh)',
        borderTotalizer_Wh: 'Totalizador ponta (kWh)',
        reservedTotalizer_Wh: 'Totalizador fora ponta (kWh)',
        offBorderTotalizer_Wh: 'Totalizador reservado (kWh)',
        totalIntermediary_Wh: 'Total intermediário (kWh)',
        generatedEnergyTotal_Wh: 'Energia gerada - total (kWh)',
        totalReverseActiveEnergy_Wh: 'Energia ativa reversa total (kWh)',
        totalDemand_W: 'Demanda ativa total (W)',
        borderDemand_W: 'Demanda ativa ponta (W)',
        reservedDemand_W: 'Demanda ativa fora ponta (W)',
        totalApparentDemand_Va: 'Demanda aparente total (VA)',
        borderApparentDemand_Va: 'Demanda aparente ponta (VA)',
        reservedApparentDemand_Va: 'Demanda aparente fora ponta (VA)',
        totalDemandIncremental_W: 'Demanda ativa total incremental (W)',
        borderDemandIncremental_W: 'Demanda ativa ponta incremental (W)',
        reservedDemandIncremental_W: 'Demanda ativa fora ponta incremental (W)',
        demandResetCount: 'Quantidade de resets de demanda',
        demandResetTime: 'Horário de reset de demanda',
        demandResetTimeMs: 'Horário de reset de demanda (ms)',
        demandCurrentTime: 'Horário atual de demanda',
        demandCurrentTimeMs: 'Horário atual de demanda (ms)',
        voltageA: 'Tensão A (V)',
        voltageB: 'Tensão B (V)',
        voltageC: 'Tensão C (V)',
        currentA: 'Corrente A (A)',
        currentB: 'Corrente B (A)',
        currentC: 'Corrente C (A)',
        maximumCurrentA_A: 'Corrente máxima A (A)',
        activePowerA: 'Potência ativa A (W)',
        activePowerB: 'Potência ativa B (W)',
        activePowerC: 'Potência ativa C (W)',
        lastAverageVoltageL1_V: 'Tensão média L1 (V)',
        lastAverageCurrentL1_A: 'Corrente média L1 (A)',
        lastAverageVoltageL2_V: 'Tensão média L2 (V)',
        lastAverageCurrentL2_A: 'Corrente média L2 (A)',
        lastAverageVoltageL3_V: 'Tensão média L3 (V)',
        lastAverageCurrentL3_A: 'Corrente média L3 (A)',
        totalPowerFactor_NoUnit: 'Fator de potência total',
      },
      quality: {
        dateTimeInitial: 'Data/Hora Inicial',
        dateTimeFinal: 'Data/Hora Final',
        description: 'Descrição',
        drp: 'DRP (%)',
        drc: 'DRC (%)',
        dtt95: 'DTT95 (%)',
        fd95: 'FD95 (%)',
      },
      energy: {
        dateTime: 'Data/Hora',
        totalEnergy_Wh: 'Energia ativa total (Wh)',
        borderTotalizer_Wh: 'Totalizador de ponta (Wh)',
        reservedTotalizer_Wh: 'Totalizador reservado (Wh)',
        offBorderTotalizer_Wh: 'Totalizador fora ponta (Wh)',
        totalIntermediary_Wh: 'Totalizador intermediário (Wh)',
        generatedEnergyTotal_Wh: 'Energia gerada total (Wh)',
        totalReverseActiveEnergy_Wh: 'Energia ativa reversa total (kWh)',
        totalInductiveReactiveEnergy_VarH: 'Reativa indutiva total (VarH)',
        totalCapacitiveReactiveEnergy_VarH: 'Reativa capacitiva total (VarH)',
        consumedMaximunDemand_W: 'Demanda máxima consumida (W)',
        injectedMaximunDemand_W: 'Demanda máxima injetada (W)',
        positiveReactiveEnergy_Wh: 'Energia reativa positiva (kWh)',
        negativeReactiveEnergy_Wh: 'Energia reativa negativa (kWh)',
        forderTotalizer_Wh: 'Energia ativa direta T1 (kWh)',
        generatedOffBorderEnergyTotal_Wh: 'Energia ativa gerada fora ponta (kWh)',
        generatedIntermediaryEnergyTotal_Wh: 'Energia ativa gerada intermediário (kWh)',
        generatedBorderEnergyTotal_Wh: 'Energia ativa gerada ponta (kWh)',
        generatedReservedEnergyTotal_Wh: 'Energia ativa gerada reservado (kWh)',
      },
      alarms: {
        dateEvent: 'Data evento',
        description: 'Descrição',
        serial: 'Serial',
        installation: 'Instalação',
        terminal: 'Terminal',
      },
    },
    meters: {
      title: 'Medidores',
      importMeters: 'Importar Medidores',
      editMeters: 'Editar Medidores',
      linkTags: 'Vincular Tags',
      unlinkTags: 'Desvincular Tags',
      commissioning: 'Comissionamento',
      serial: 'Serial',
      installation: 'Unidade Consumidora',
      modemSignalQuality: 'Sinal',
      accountantStatus: 'Situação',
      onlineStatus: 'Status',
      updatedAt: 'Atualizado em',
      readingsCount: 'Quantidade de Leituras',
      totalOfSent: 'Total de Envios',
      successOfSent: 'Envios de Sucesso',
      failOfSent: 'Envios de Falha',
      deviceEui: 'Device Eui',
      meterPhase: 'Fase',
      manufacturer: 'Fabricante',
      position: 'Posição',
      commands: 'Comandos',
      tags: 'Tags',
      firmware: 'Firmware',
      phase: 'Fase',
      communication: 'Comunicação',
      status: 'Estado',
    },
    smcs: {
      title: 'Smcs',
      serial: 'Serial',
      qtyMeters: 'Quantidade',
      firmware: 'Firmware',
      comissioned: 'Comissionado',
      doorStatus: 'Porta',
      online: 'Estado de comunicação',
      smcModel: 'Marca',
      signalQuality: 'Sinal',
      updatedAt: 'Última Atualização',
    },
    alarms: {
      title: 'Alarmes',
      serial: 'Serial',
      description: 'Descrição',
      dateTime: 'Data e Hora',
      alarmType: 'Tipo de Alarme',
      selectAlarmType: 'Selecione o tipo de alarme',
      terminal: 'Terminal',
      updatedAt: 'Última atualização',
      isCritical: 'Alarme Crítico',
      errors: {
        error: 'Erro',
        incompleteMeterData: 'Dados do medidor incompletos para exportação',
      },
    },
    smcAlarms: {
      title: 'Alarmes do SMC',
      readDateTime: 'Data e Hora de leitura',
      description: 'Descrição',
      updatedAt: 'Última atualização',
    },
    meterAlarms: {
      title: 'Alarmes dos Medidores',
      readDateTime: 'Data e Hora de leitura',
      description: 'Descrição',
      updatedAt: 'Última atualização',
      serial: 'Serial',
      terminal: 'Terminal',
    },
    alarmTypesMeter: {
      title: 'Tabela de Eventos SMI/Medidores del SMC',
      description: 'Descrição',
      count: 'Quantidade',
      wasRead: 'Leitura',
      read: 'Lido',
      unread: 'Não Lido',
      errorSearch: 'Erro ao buscar tipos de alarmes',
    },
    alarmTypesSmc: {
      title: 'Tabela de Eventos do SMC',
      description: 'Descrição',
      count: 'Quantidade',
      wasRead: 'Leitura',
      read: 'Lido',
      unread: 'Não Lido',
      errorSearch: 'Erro ao buscar tipos de alarmes',
    },
    tickets: {
      title: 'Tickets',
      serial: 'Serial',
      commandType: 'Comando',
      ticketStatus: 'Estado do Ticket',
      selectTicketStatus: 'Selecione o status do ticket',
      generatedBySystem: 'Gerados pelo sistema',
      statusCommand: 'Estado do Comando',
      lastUpdate: 'Última atualização',
      initialDate: 'Data de envio',
      updatedAt: 'Atualizado em',
      serialMeter: 'Serial do Medidor',
      user: 'Usuário responsável',
      scheduledTickets: 'Tickets Agendados',
      scheduledDate: 'Data Agendada',
      company: 'Empresa',
      manufacturer: 'Fabricante',
      deadline: 'Deadline',
      startDate: 'Início da Execução',
      trackingCode: 'Código',
      serviceType: 'Tipo de Serviço',
      status: 'Status do SAP',
      commandTicket: {
        commandId: 'ID do Comando',
        commandType: 'Tipo de Comando',
        initialDate: 'Início',
        finishDate: 'Fim',
        attempt: 'Número de tentativas',
        messageSent: 'Mensagem enviada',
        messageReceived: 'Mensagem recebida',
        messageError: 'Mensagem de erro',
        messageSuccess: 'Mensagem de sucesso',
        noResponse: 'Sem resposta',
        totalData: 'Total de Dados',
        saved: 'Salvos',
        failedProcesses: 'Processos com falhas',
        answerColumns: {
          answer: 'Resposta',
          lineNumber: 'Linha',
          operation: 'Operação',
          success: 'Sucesso',
          message: 'Mensagem',
          processedAt: 'Processado em',
          position: 'Posição',
          totalEnergy: 'Energia total',
          relayStatus: 'Estado do relé',
          accountantStatus: 'Status do relé',
          serial: 'Serial',
          datetime: 'Data/Hora',
          group2VoltageVaH_V: 'Tensão VaH(V)',
          group3CurrentIaH_A: 'Corrente IaH(A)',
          group2VoltageVbH_V: 'Tensão VbH(V)',
          group3CurrentIbH_A: 'Corrente IbH(A)',
          group2VoltageVcH_V: 'Tensão VcH(V)',
          group3CurrentIcH_A: 'Corrente IcH(A)',
          group4AngleUiA_deg: 'Ângulo UiA(º)',
          group4AngleUiB_deg: 'Ângulo UiB(º)',
          group4AngleUiC_deg: 'Ângulo UiC(º)',
          index: 'Índice',
          specialDayDate: 'Data especial',
          dayOfWeek: 'Dia da semana',
          dayId: 'ID do dia',
          meterId: 'ID do medidor',
          type: 'Tipo',
          name: 'Nome',
          description: 'Descrição',
          time: 'Horário',
          tariffType: 'Tipo de tarifa',
          dailyTariffs: 'Tarifas diárias',
          hourlyTariffs: 'Tarifas horárias',
          drmcDailyTariffs: 'Tarifas diárias DMCR',
          drmcHourlyTariff: 'Tarifas horárias DMCR',
          dmcrType: 'Tipo DMCR',
          hourlyDMCRs: 'DMCRs horários',
          meterProfileId: 'ID do perfil do medidor',
          meterDMCRProfileId: 'ID do perfil DMCR do medidor',
          startDate: 'Data início',
          endDate: 'Data fim',
          deviation: 'Desvio',
          isEnable: 'Ativo',
          enabled: 'Ativo',
          saturdayInductive: 'Sábado indutivo',
          saturdayCapacitive: 'Sábado capacitivo',
          sundayInductive: 'Domingo indutivo',
          sundayCapacitive: 'Domingo capacitivo',
          workdayInductive: 'Dia útil indutivo',
          workdayCapacitive: 'Dia útil capacitivo',
          holidayInductive: 'Feriado indutivo',
          holidayCapacitive: 'Feriado capacitivo',
          timeToActivate: 'Tempo de ativação',
          daylightEndDatetime: 'Data/Hora de término do horário de verão',
          daylightBeginDatetime: 'Data/Hora de início do horário de verão',
        },
      },
    },
    frozenData: {
      title: 'Totalizadores de Energia',
    },
    massMemory: {
      title: 'Memória de Massa',
    },
    tableFiscalFasional: {
      title: 'Página Fiscal',
    },
    billing: {
      title: 'Histórico de Faturamento',
      billing: 'Faturamento',
      stageCode: 'Etapa',
      stageDay: 'Dia',
      dateSent: 'Enviado em',
      status: 'Estado',
      type: 'Tipo',
      typeCode: 'Tipo de Código',
      readingDate: 'Data de leitura',
      readingValue: 'Valor da leitura',
    },
    eventLogs: {
      title: 'Logs de Eventos',
      dateTime: 'Data e Hora',
      message: 'Mensagem',
      logLevel: 'Nível de Log',
      logs: {
        critical: 'Crítico',
        debug: 'Debug',
        error: 'Erro',
        trace: 'Detalhada ( Apenas Degub )',
        warning: 'Aviso',
        none: 'Sem Mensagem',
        information: 'Informação',
      },
      errors: {
        getEventLogs: 'Erro ao obter os logs de eventos',
        serialRequired: 'O serial é obrigatório',
      },
    },
    alarmVoltage: {
      titleShortDuration: 'Alarmes de Interrupção de Curta duração',
      titleLongDuration: 'Alarmes de Interrupção de Longa duração',
      calculateInterruptionIndicators: 'Calcular Indicadores de Interrupção',
      referenceMonth: 'Mês de Referência',
      calculate: 'Calcular',
      fic: 'FIC',
      dic: 'DIC',
      hours: 'Horas',
      hundredthHour: 'Centésimos de Horas',
      minutes: 'Minutos',
      ficTooltip:
        'Frequência de Interrupção Individual por Unidade Consumidora ou por Ponto de Conexão',
      dicTooltip:
        'Duração de Interrupção Individual por Unidade Consumidora ou por Ponto de Conexão expressa em Horas',
      dicHundredthHourTooltip:
        'Duração de Interrupção Individual por Unidade Consumidora ou por Ponto de Conexão expressa em Centésimos de Horas',
      dateTime: 'Data de Leitura',
      dateTimeStart: 'Data de Início',
      dateTimeEnd: 'Data de Término',
      timeVariation: 'Tempo de Variação',
      voltageOut: 'Voltagem',
      createdAt: 'Criado em',
    },
    alarmsMeters: {
      title: 'Alarmes dos Medidores',
    },
    qeeIndicators: {
      title: 'Parâmetros de Qualidade',
      monthlyAverage: 'Média Mensal',
      recoverQualityParams: 'Recuperar parâmetros de qualidade',
      calculateMonthlyAverage: 'Calcular média mensal',
      dateAndTimeInitial: 'Data e Hora inicial',
      dateAndTimeFinal: 'Data e Hora final',
      referenceMonth: 'Mês de Referência',
      meterStatus: 'Estado do Medidor',
      onlineStatus: 'Estado Online',
      description: 'Descrição',
      commissioned: 'Comissionado',
      dateTime: 'Data e Hora',
      drp: 'DRP',
      drc: 'DRC',
      dic: 'DIC',
      fic: 'FIC',
      dmic: 'DMIC',
      dmicOccurrenceTime: 'Momento de Ocorrência DMIC',
      noInformation: 'Sem informações',
      dialog: {
        referenceMonth: 'Mês de Referência',
        quantityOfSamples: 'Quantidade de amostras desejadas',
        initialDate: 'Data Inicial do Conjunto',
        endDate: 'Data Final do Conjunto',
        drp: 'DRP',
        drc: 'DRC',
        dtt95: 'DTT95',
        fd95: 'FD95',
        drcPhaseA: 'DRC Fase A',
        drpPhaseA: 'DRP Fase A',
        drcPhaseB: 'DRC Fase B',
        drpPhaseB: 'DRP Fase B',
        drcPhaseC: 'DRC Fase C',
        drpPhaseC: 'DRP Fase C',
        calculate: 'Calcular',
        cancel: 'Cancelar',
        request: 'Solicitar',
        requestSentTitle: 'Requisição Enviada',
        requestSentSuccess: 'Média mensal solicitada com sucesso',
        requestSentError: 'Não foi possível solicitar Média Mensal',
        relayOff: 'Relé desligado',
        relayOffDescription: 'Não foi possível solicitar a média mensal para este medidor',
        noQualityParametersFound: 'Nenhum parâmetro de qualidade encontrado para o medidor',
      },
      placeholders: {
        referenceMonth: 'Selecione o mês de referência',
      },
      errors: {
        incompleteMeterData: 'Dados do medidor incompletos para exportação',
      },
      confirmDelete: 'Confirmar exclusão do Parâmetro de Qualidade',
      confirmDeleteDescription: 'Deseja excluir o Parâmetro de Qualidade?',
      confirmDeleteText: 'Sim, excluir',
    },
    instantMeasure: {
      title: 'Medições Instantâneas',
      requestMeasure: 'Solicitar leituras',
      readingTime: 'Horário de leitura',
      voltageVa: 'Tensão Va (V)',
      voltageVb: 'Tensão Vb (V)',
      voltageVc: 'Tensão Vc (V)',
      currentIa: 'Corrente Ia (A)',
      currentIb: 'Corrente Ib (A)',
      currentIc: 'Corrente Ic (A)',
      angleUiA: 'Ângulo Ui A (º)',
      angleUiB: 'Ângulo Ui B (º)',
      angleUiC: 'Ângulo Ui C (º)',
    },
    firmware: {
      lastUpdate: 'Última atualização',
      crc: 'CRC',
      name: 'Nome',
      manufacturer: 'Fabricante',
    },
    keys: {
      lastUpdate: 'Última atualização',
      serial: 'Serial',
      authenticationKey: 'Chave de Autenticação',
      encryptionKey: 'Chave de Criptografia',
      masterKey: 'Chave Mestre',
      lls2: 'LLS2',
    },
    tags: {
      lastUpdate: 'Última Atualização',
      tagId: 'ID da Tag',
      name: 'Nome',
      colorCode: 'Cor (Código Hexadecimal)',
      colors: 'Cores',
    },
    models: {
      name: 'Nome',
      manufacturer: 'Fabricante',
      positionsCount: 'Qtd. de posições',
    },
    clients: {
      title: 'Clientes',
      newClient: 'Novo Cliente',
      deleteClients: 'Excluir Clientes',
      name: 'Nome',
      location: 'Localização',
      statusActive: 'Ativo',
      quantityMeterSerials: 'Quantidade de Medidores',
      updatedAt: 'Última atualização',
      weights: 'Pesos',
      prefixUf: 'Prefixo UF',
    },
    process: {
      title: 'Processos',
      processId: 'ID do Processo',
      processType: 'Tipo de Processo',
      user: 'Usuário',
    },
    balanceDevices: {
      title: 'Balanço dos Dispositivos',
      trafo: 'Trafo',
      device: 'Dispositivo',
      initialDate: 'Data Energia Consumida Inicial',
      initialReading: 'Inicial Energia Consumida (kWh)',
      finalDate: 'Data Energia Consumida Final',
      finalReading: 'Final Energia Consumida (kWh)',
      consumption: 'Consumo (kWh)',
      energyInjectedConsumers: 'Energia Injetada (kWh)',
      energyReverseTransformer: 'Energia Reversa (kWh)',
    },
    balanceTransformers: {
      title: 'Balanço dos Transformadores',
      date: 'Data',
      nameTrafo: 'Nome do Trafo',
      trafoMeter: 'Medidor do Trafo',
      energyRequired: 'Energia Requerida (kWh)',
      energyConsumed: 'Energia Consumida (kWh)',
      loss: 'Perda (kWh)',
      streetLighting: 'Energia IP (kWh)',
      lossPercentage: 'Perda %',
    },
    balanceAreasRegions: {
      title: 'Balanço da Áreas',
      data: 'Data',
      nameArea: 'Nome da Área',
      energyRequired: 'Energia Requerida (kWh)',
      energyConsumed: 'Energia Consumida (kWh)',
      loss: 'Perda (kWh)',
      streetLighting: 'Energia pública (kWh)',
      lossPercentage: 'Perda %',
    },
    transformers: {
      title: 'Transformadores',
      newTransformer: 'Novo Transformador',
      deleteTransformers: 'Exclusão de Transformadores',
      name: 'Nome',
      description: 'Descrição',
      publicLighting: 'Iluminação Pública Mensal (kWh)',
      trafoMeter: 'Medidor Trafo',
      connected: 'Conectados',
      latLong: 'Lat/Long',
      updatedAt: 'Última atualização',
      errorSearch: 'Erro ao buscar Transformadores',
      noTransformerSelected: 'Nenhum transformador selecionado',
    },
    scheduledCommands: {
      group: 'Grupo',
      command: 'Comando',
      executionTime: 'Tempo de Execução',
      status: 'Status',
      nextExecution: 'Próxima Execução',
      active: 'Ativo',
      paused: 'Pausado',
      pausedScheduling: 'Agendamento Pausado',
      scheduling: 'agendamento',
      errorSearch: 'Erro ao buscar agendamentos',
      noScheduleSelected: 'Nenhum agendamento selecionado',
      noSchedule: 'Nenhum agendamento cadastrado',
      deleteSchedule: 'Exclusão de Agendamento',
      newRoutine: 'Agendar Comando',
    },
    lowEffectiveness: {
      title: 'Localizações com Baixa Efetividade',
      locationCode: 'Código de Localização',
      regionCode: 'Código da Região',
      estado: 'Estado',
      cidade: 'Cidade',
      totalMeters: 'Total de Medidores',
      lowEffectivenessMeters: 'Medidores com Baixa Efetividade',
      lowEffectivenessPercent: 'Percentual de Baixa Efetividade',
      effectivenessPercent: 'Percentual de Efetividade',
      errorSearch: 'Erro ao buscar localizações com baixa efetividade',
      tabs: {
        state: 'Por Estado',
        city: 'Por Cidade',
      },
    },
    unavailabilityPeak: {
      title: 'Pico de Indisponibilidade',
      meter: 'Medidor',
      consumerUnit: 'Unidade Consumidora',
      locationCode: 'Código de Localização',
      regionCode: 'Código da Região',
      manufacturer: 'Fabricante',
      unavailableDays: 'Dias Indisponíveis',
      totalDays: 'Total de Dias',
      unavailabilityPercent: 'Percentual de Indisponibilidade',
      availabilityPercent: 'Percentual de Disponibilidade',
      errorSearch: 'Erro ao buscar picos de indisponibilidade',
    },
    areas: {
      title: 'Áreas',
      newArea: 'Nova Área',
      name: 'Nome',
      description: 'Descrição',
      transformersCount: 'Quantidade de Transformadores',
      updatedAt: 'Última atualização',
      deleteAreas: 'Exclusão de Áreas',
      errors: {
        title: 'Erro',
        loadAreaInfo: 'Erro ao buscar informações da área',
        noAreaSelected: 'Nenhuma área selecionada',
      },
      areasTransformers: {
        title: 'Transformadores da Área',
        manageTransformers: 'Gerenciar transformadores',
        name: 'Nome',
        serialMeter: 'Serial do Medidor',
        metersCount: 'Quantidade de Medidores',
        publicLighting: 'Iluminação Pública',
        coordinates: 'Coordenadas',
        updatedAt: 'Última atualização',
      },
    },
    regions: {
      title: 'Regiões',
      newRegion: 'Nova Região',
      deleteRegions: 'Exclusão de Regiões',
      name: 'Nome',
      description: 'Descrição',
      areasCount: 'Quantidade de Áreas',
      updatedAt: 'Última atualização',
      errors: {
        title: 'Erro',
        loadRegions: 'Erro ao buscar regiões',
        noRegionSelected: 'Nenhuma região selecionada',
      },
    },
    transformerMeters: {
      title: 'Medidores do Transformador',
      importMeters: 'Importar medidores por arquivo',
      removeMeters: 'Remover medidores por arquivo',
      manageMeters: 'Gerenciar medidores',
      importNameModal: 'modelo-medidores-por-transformador-registro',
      removeNameModal: 'modelo-medidores-por-transformador-remocao',
      meter: 'medidor(es)',
      success: {
        registerMeters: 'Medidores registrados com sucesso',
        removeMeters: 'Medidores removidos com sucesso',
      },
      errors: {
        registerMeters: 'Falha ao registrar medidores',
        removeMeters: 'Falha ao remover medidores',
        metersNotRegistered: 'medidor(es) não puderam ser registrados',
        unknownReason: 'Motivo desconhecido',
      },
      warnings: {
        partialSuccess: 'Registro parcial de medidores',
        metersNotUpdated: 'medidor(es) não foram atualizados',
      },
    },
    regionsAreas: {
      title: 'Áreas da Região',
      manageAreas: 'Gerenciar áreas',
      name: 'Nome',
      description: 'Descrição',
      transformersCount: 'Quantidade de Transformadores',
      updatedAt: 'Última atualização',
    },
  },
  echarts: {
    noteType: {
      title: 'Tipo de Serviço',
      services: 'Serviços',
      regions: 'Regiões',
      manufactures: 'Fabricantes',
    },
    sapStatus: {
      title: 'Status SAP',
      services: 'Serviços',
      regions: 'Regiões',
      manufactures: 'Fabricantes',
    },
    requestStatus: {
      title: 'Status Comando',
      status: 'Status',
      services: 'Serviços',
      regions: 'Regiões',
      manufactures: 'Fabricantes',
    },
    table: {
      createdAt: 'Criado em',
      updatedAt: 'Atualizado em:',
      startDate: 'Início da Execução',
      actionType: 'Tipo de ação',
      status: 'Status',
      company: 'Região',
      manufacturer: 'Fabricante',
      meterSerial: 'Serial',
      trackingCode: 'Rastreio',
    },
    effectiveness: {
      title: 'Efetividade e Disponibilidade',
      manufacturers: 'Fabricantes',
      networkTech: 'Tecnologia de Rede',
      cityOrState: 'Cidade / Estado',
      cityOrStatePlaceholder: 'Digite o nome da cidado/estado',
      meterRegion: {
        serial: 'Serial',
        regionCode: 'Código da Região',
        districtCode: 'Código do Distrito',
        sectionCode: 'Código da Seção',
        locationTypeCode: 'Código do Tipo de Localização',
        locationCode: 'Código da Localização',
        fullAddress: 'Endereço Completo',
        city: 'Cidade',
        feeder: 'Alimentador',
        districtName: 'Nome do Distrito',
        neighborhood: 'Bairro',
        regional: 'Regional',
        sectional: 'Seccional',
      },
    },
    process: {
      title: 'Status',
      success: 'Sucesso',
      failed: 'Falha',
      waiting: 'Aguardando',
      executing: 'Executando',
      scheduled: 'Agendado',
    },
    status: {
      title: 'Status',
      statusOnline: 'Online',
      statusOffline: 'Offline',
      statusAbsent: 'Ausente',
    },
    commission: {
      title: 'Comissionamento',
      commissionOn: 'Comissionado',
      commissionOff: 'Não Comissionado',
      commissionOns: 'Comissionados',
      commissionOffs: 'Não Comissionados',
    },
    situation: {
      title: 'Situação',
      disabled: 'Desconectado',
      activated: 'Conectado',
      noRelay: 'Sem Relé',
      noInformation: 'Não Informado',
      titleNoMeters: 'Tabela de Situação - Medidores',
    },
    billing: {
      title: 'Informações sobre o faturamento',
      status: 'Status',
      success: 'Sucesso',
      noReadings: 'Sem leituras',
      noReadingsDescription: 'Não foram encontradas leituras disponíveis para faturamento.',
      withReadings: 'Com leitura',
      withReadingsDescription:
        'Havia leituras, mas ocorreu um erro ao enviá-las para o sistema comercial.',
      withoutStage: 'Sem etapa',
      withoutStageDescription: 'Ainda não há etapa de faturamento atribuída a este medidor.',
      scheduled: 'Agendado',
      scheduledDescription:
        'Faturamento programado para uma data futura dentro do período definido.',
      notStarted: 'Faturamento não iniciado',
      notStartedDescription: 'A data de faturamento já passou e o processo não foi executado.',
      successDescription: 'Faturamento realizado com sucesso, sem ocorrência de erros.',
    },
    signalQuality: {
      signal: 'Sinal',
      title: 'Qualidade do Sinal',
      unregistered: 'Não registrado',
      metersWith: 'Medidores com',
    },
    commandsSent: {
      title: 'Comandos Enviados',
    },
    statusCommand: {
      title: 'Todos os Comandos',
    },
    alarmStatisticMeter: {
      title: 'Eventos SMI/Medidores do SMC',
      read: 'Lidos',
      unread: 'Não lidos',
    },
    alarmStatisticSmc: {
      title: 'Eventos SMC',
      read: 'Lidos',
      unread: 'Não lidos',
    },
    fiscalPage: {
      title: 'Página Fiscal',
      noData: 'Não há dados disponíveis',
      noDataOnInterval: 'Não há dados para o intervalo selecionado',
      noDataChart: 'Sem dados',
      requestFiscalPage: 'Solicitar Página Fiscal',
      value: 'Valor',
      phaseA: 'Fase A',
      phaseB: 'Fase B',
      phaseC: 'Fase C',
      packageDate: 'Data do Pacote',
      frequency: 'Frequência (Hz)',
      voltage: 'Tensão (V)',
      angleVI: 'Ângulo VI (°)',
      angleVoltage: 'Ângulo Tensão (°)',
      anglePhase: 'Ângulo Fase (AB/BC/CA °)',
      current: 'Corrente',
      currentAngle: 'Ângulo Corrente (°)',
      activePower: 'Potência Ativa (W)',
      reactivePower: 'Potência Reativa (VAR)',
      powerFactor: 'Fator de Potência',
      legend: {
        angVoltageA: 'Ângulo Tensão A',
        angVoltageB: 'Ângulo Tensão B',
        angVoltageC: 'Ângulo Tensão C',
        angVIA: 'Ângulo VI A',
        angVIB: 'Ângulo VI B',
        angVIC: 'Ângulo VI C',
        angPhaseAB: 'Ângulo Fase AB',
        angPhaseBC: 'Ângulo Fase BC',
        angPhaseCA: 'Ângulo Fase CA',
        angPhaseAC: 'Ângulo Fase AC',
        currentAngleA: 'Ângulo Corrente A',
        currentAngleB: 'Ângulo Corrente B',
        currentAngleC: 'Ângulo Corrente C',
      },
    },
  },
  notifications: {
    effectiveness: {
      success: {
        updateConfig: 'Configuração de efetividade atualizada com sucesso!',
      },
      error: {
        updateConfig: 'Falha ao atualizar a configuração de efetividade.',
        getConfig: 'Falha ao buscar a configuração de efetividade.',
      },
    },
    averageVariation: {
      success: {
        updateConfig: 'Configuração atualizada com sucesso!',
      },
      error: {
        updateConfig: 'Falha ao atualizar a configuração.',
        getConfig: 'Falha ao buscar a configuração.',
      },
    },
    tickets: {
      success: {
        getTickets: 'Tickets buscados com sucesso',
      },
      error: {
        getTickets: 'Erro ao buscar Tickets',
      },
    },
    fiscalPage: {
      success: {
        getFiscalPage: 'Página fiscal recuperada com sucesso',
      },
      error: {
        getFiscalPage: 'Erro ao recuperar página fiscal',
      },
    },
    recoverEnergy: {
      success: {
        recoverEnergy: 'Comando de Recuperação dos Totalizadores de Energia Enviado',
      },
      error: {
        recoverEnergy: 'Erro ao enviar comando de recuperação de totalizadores de energia',
      },
    },
  },
  dialogs: {
    deleteMass: {
      title: 'Confirmar exclusão em massa',
      message: 'Você deseja excluir os itens selecionados?',
      confirmButton: 'Sim, excluir',
      cancelButton: 'Cancelar',
    },
    recoverByRangeDate: {
      title: 'Enviar comando',
      description: 'Selecione o intervalo de datas',
      placeholder: 'Intervalo de datas',
      confirmButton: 'Requisitar',
      cancelButton: 'Cancelar',
    },
    importModal: {
      downloadModel: 'Download Modelo',
      chooseFile: 'Escolher Arquivo',
      fileNotSelected: 'Arquivo não selecionado',
      validateFile: 'Validar Arquivo',
      importItems: 'Importar Itens',
      viewValidatedItems: 'Visualizar Itens Validados',
      viewIgnoredItems: 'Visualizar Itens Ignoradas',
      serialWhitespaceError:
        'O serial não pode conter espaços no início, no meio ou no final. Linhas inválidas: {rows}.',
    },
    massTagsToMeters: {
      linkTitle: 'Vincular Tags',
      unlinkTitle: 'Desvincular Tags',
      steps: {
        tags: 'Tags',
        import: 'Importar',
      },
      tagsPlaceholder: 'Selecione as tags',
      selectTagsHint: 'Selecione ao menos uma tag para continuar.',
      next: 'Próximo',
      back: 'Voltar',
      selectedTagsCount: '{count} tag(s) selecionada(s).',
      finishLink: 'Finalizar vinculação',
      finishUnlink: 'Finalizar desvinculação',
      noFileSelected: 'Nenhum arquivo selecionado.',
      emptySerialError: 'O arquivo contém linhas com o campo Serial vazio.',
      fileValidatedSuccess: 'Arquivo validado com sucesso',
      fileValidatedWithIgnored:
        'Arquivo validado com sucesso, porém {count} linha(s) inválida(s) foram ignoradas.',
      fileProcessError: 'Erro ao processar arquivo',
      noValidSerials: 'Nenhum serial válido foi encontrado no arquivo.',
      linkError: 'Não foi possível vincular as tags aos medidores.',
      unlinkError: 'Não foi possível desvincular as tags dos medidores.',
      success: {
        linksCreated: '{affectedLinks} vínculo(s) criado(s) em {processedMeters} medidor(es).',
        linksRemoved: '{affectedLinks} vínculo(s) removido(s) em {processedMeters} medidor(es).',
        notFoundSerials: '{count} serial(is) não encontrado(s).',
        notFoundTagIds: '{count} tag(s) não encontrada(s).',
      },
    },
    dialogTransformer: {},
    dialogArea: {
      titleNewArea: 'Nova Área',
      titleEditArea: 'Editar Área',
      name: 'Nome',
      fieldRequired: 'Este campo é obrigatório!',
      description: 'Descrição',
      delete: 'Excluir',
      cancel: 'Cancelar',
      modify: 'Modificar',
      register: 'Cadastrar',
      success: {
        title: 'Sucesso',
        createArea: 'Área criada com sucesso!',
        updateArea: 'Área atualizada com sucesso!',
      },
      error: {
        title: 'Erro',
        createArea: 'Erro ao criar área',
        updateArea: 'Erro ao atualizar área',
      },
    },
    dialogRegion: {
      editRegion: 'Editar região',
      createRegion: 'Criar região',
      title: 'Gerenciar transformadores da região',
      name: 'Nome',
      fieldRequired: 'Este campo é obrigatório!',
      description: 'Descrição',
      deleteRegion: 'Excluir',
      cancel: 'Cancelar',
      modify: 'Modificar',
      register: 'Cadastrar',
      success: {
        title: 'Sucesso',
        createRegion: 'Região criada com sucesso!',
        updateRegion: 'Região atualizada com sucesso!',
      },
      error: {
        title: 'Erro',
        createRegion: 'Erro ao criar região',
        updateRegion: 'Erro ao atualizar região',
      },
    },
    dialogNewEditAreasInRegion: {
      title: 'Gerenciar áreas da região',
      areasInRegion: 'Áreas na Região',
      total: 'Total',
      availableAreas: 'Áreas Disponíveis',
      available: 'Disponíveis',
      selected: 'Selecionadas',
      removeAreas: 'Remover Áreas',
      addAreas: 'Adicionar Áreas',
      exit: 'Sair',
      name: 'Nome',
      description: 'Descrição',
      transformersCount: 'Transformadores',
      updatedAt: 'Última atualização',
      success: {
        title: 'Sucesso',
        addAreas: 'Áreas adicionadas com sucesso!',
        removeAreas: 'Áreas removidas com sucesso!',
      },
      errors: {
        title: 'Erro',
        loadAvailableAreas: 'Erro ao carregar áreas disponíveis',
        addAreas: 'Erro ao adicionar áreas à região',
        removeAreas: 'Erro ao remover áreas da região',
      },
    },
    dialogNewEditTransformersInArea: {
      title: 'Gerenciar transformadores da área',
      transformersInArea: 'Transformadores na Área',
      total: 'Total',
      availableTransformers: 'Transformadores Disponíveis',
      available: 'Disponíveis',
      selected: 'Selecionados',
      removeTransformers: 'Remover Transformadores',
      addTransformers: 'Adicionar Transformadores',
      exit: 'Sair',
      name: 'Nome',
      serialMeter: 'Serial do Medidor',
      meters: 'Medidores',
      updatedAt: 'Atualização',
      success: {
        title: 'Sucesso',
        addTransformers: 'Transformadores adicionados com sucesso!',
        removeTransformers: 'Transformadores removidos com sucesso!',
      },
      errors: {
        title: 'Erro',
        loadAvailableTransformers: 'Erro ao carregar transformadores disponíveis',
        addTransformers: 'Erro ao adicionar transformadores à área',
        removeTransformers: 'Erro ao remover transformadores da área',
      },
    },
    dialogNewEditMetersInTransformer: {
      title: 'Gerenciar registro de medidores do transformador',
      registeredMeters: 'Medidores Cadastrados',
      availableMeters: 'Medidores Disponíveis',
      total: 'Total',
      available: 'Disponíveis',
      selected: 'Selecionados',
      removeMeters: 'Remover Medidores',
      registerMeters: 'Cadastrar Medidores',
      exit: 'Sair',
      serialMeter: 'Serial do Medidor',
      manufacturer: 'Fabricante',
      phase: 'Fase',
      signalQuality: 'Qualidade de Sinal',
      success: {
        title: 'Sucesso',
        registerMeters: 'Medidores registrados com sucesso',
        removeMeters: 'Medidores removidos com sucesso',
      },
      errors: {
        title: 'Erro',
        registerMeters: 'Falha ao registrar medidores',
        removeMeters: 'Falha ao remover medidores',
      },
    },
    dialogNewEditTransformer: {
      editTransformer: 'Editar Transformador',
      registerTransformer: 'Registrar Transformador',
      requiredField: 'Este campo é obrigatório!',
      requiredFields: 'Preencha todos os campos obrigatórios',
      name: 'Nome',
      publicLighting: 'Iluminação Pública Mensal (kWh)',
      latitude: 'Latitude',
      longitude: 'Longitude',
      readingMeter: 'Medidor de Leitura',
      searchPlaceholder: 'Pesquisar por nome, fabricante ou serial',
      description: 'Descrição',
      cancel: 'Cancelar',
      modify: 'Modificar',
      register: 'Cadastrar',
      success: {
        title: 'Sucesso',
        createTransformer: 'Transformador criado com sucesso!',
        updateTransformer: 'Transformador atualizado com sucesso!',
      },
      errors: {
        title: 'Erro',
        createTransformer: 'Erro ao criar transformador',
        updateTransformer: 'Erro ao atualizar transformador',
      },
    },
    dialogCancelTicket: {
      title: 'Cancelar execução do ticket',
      message: 'Deseja cancelar a execução deste ticket?',
      ticketLabel: 'Ticket',
      commandLabel: 'Comando',
      close: 'Fechar',
      cancelTicket: 'Cancelar Ticket',
      success: {
        title: 'Sucesso',
        message: 'Cancelamento executado com sucesso!',
      },
      error: {
        title: 'Erro',
        message: 'Erro ao cancelar ticket',
      },
    },
  },
  general: {
    cancel: 'Cancelar',
    save: 'Salvar',
    search: 'Buscar',
    selectClient: 'Selecione um cliente',
    meter: 'Medidor',
    meters: 'Medidores',
    serial: 'Serial',
    attention: 'Atenção',
    noInformation: 'Sem informação',
    notAvailable: 'Não disponível',
    noDataFound: 'Nenhum dado encontrado',
    itemsFound: 'itens encontrados',
    actionsFile: 'Ações por arquivo',
    consumerUnit: 'Unidade Consumidora',
    yes: 'Sim',
    no: 'Não',
    exit: 'Sair',
    success: 'Sucesso',
    error: 'Erro',
    maximizeMap: 'Maximizar Mapa',
    minimizeMap: 'Minimizar Mapa',
    copiedToClipboard: 'Copiado para a área de transferência',
    greeting: 'Olá,',
    changingClient: 'Trocando de cliente...',
    myAccount: 'Minha conta',
    email: 'E-mail',
    description: 'Descrição',
    receiveEmails: 'Receber e-mails',
    edit: 'Editar',
    profileUpdated: 'Perfil atualizado com sucesso',
    errorUpdatingProfile: 'Erro ao atualizar perfil',
    veeSeverity: {
      info: 'Informativo',
      issue: 'Atenção',
      terminate: 'Crítico',
    },
    validation: {
      requiredFields: 'Verifique os campos obrigatórios antes de continuar.',
      meterSerialRequired: 'Serial do medidor é obrigatório.',
      manufacturerRequired: 'Fabricante é obrigatório.',
      phaseRequired: 'Fase é obrigatória.',
      meterModelRequired: 'Modelo é obrigatório.',
      meterTypeRequired: 'Tipo de medidor é obrigatório.',
      rateTypeRequired: 'Tipo de tarifa é obrigatório.',
      installationRequired: 'Código de instalação é obrigatório.',
      connectionPhaseRequired: 'Fase de conexão é obrigatória.',
      serialCannotContainSpaces: 'O serial não pode conter espaços no início, no meio ou no final.',
      meterSerialCannotContainSpaces:
        'O serial do medidor não pode conter espaços no início, no meio ou no final.',
      smcSerialCannotContainSpaces:
        'O serial do SMC não pode conter espaços no início, no meio ou no final.',
      meterRegistersRequired: 'Registradores são obrigatórios.',
    },
    comissionedType: {
      all: 'Todos',
      comissioned: 'Comissionado',
      notComissioned: 'Não Comissionado',
      notRegistered: 'Não Registrado',
    },
    meterTypes: {
      all: 'Todos',
      nepen: 'Integração MDX',
      integration: 'Integração',
      integrationDcu: 'Integração Wasion DCU',
    },
    meterActivated: {
      activated: 'Conectado',
      notActivated: 'Desconectado',
      deactivateConfirmation: 'Deseja desconectar este relé?',
      activateConfirmation: 'Deseja conectar este relé?',
      deactivateMessage: 'Comando de Desconexão de Relé Enviado',
      activateMessage: 'Comando de Conexão de Relé Enviado',
    },
    doorStatus: {
      authorized: 'Autorizado',
      unauthorized: 'Desautorizado',
    },
    communicationStatus: {
      noInformation: 'Não Informado',
      success: 'Sucesso',
      busy: 'Ocupado',
      communicationFailed: 'Falha de Comunicação',
      online: 'Online',
      waiting: 'Aguardando',
      offline: 'Offline',
      pending: 'Pendente',
    },
    signalQuality: {
      neverSeen: 'Nunca Visto',
      veryWeak: 'Muito Fraco (1 Barra)',
      weak: 'Fraco (2 Barras)',
      reasonable: 'Razoável (3 Barras)',
      strong: 'Forte (4 Barras)',
      excellent: 'Excelente (5 Barras)',
    },
    signalQualityBars: {
      fiveBars: '5 Barras',
      fourBars: '4 Barras',
      threeBars: '3 Barras',
      twoBars: '2 Barras',
      oneBar: '1 Barra',
    },
    signalQualityLabel: {
      neverSeen: 'Nunca Visto',
      veryWeak: 'Muito Fraco',
      weak: 'Fraco',
      reasonable: 'Razoável',
      strong: 'Forte',
      excellent: 'Excelente',
    },
    onlineStatus: {
      online: 'Online',
      offline: 'Offline',
      absent: 'Ausente',
    },
    datePickerExecutionFilter: 'Filtro por data de início de execução',
  },
  manufacturerFilter: {
    label: 'Fabricantes',
    placeholder: 'Todos os Fabricantes',
    loading: 'Carregando fabricantes...',
  },
  parametrization: {
    parametrization: 'Parametrização',
    manageParams: 'Gerenciar Parâmetros',
    searchBySerial: 'Pesquisar por Serial',
    unity: 'Unidade Consumidora',
    manufacturer: 'Fabricante',
    actions: 'Ações',
    commands: {
      timeParams: 'Parâmetros Relacionados ao Tempo',
      createDataTemplate: 'Criar template de Data',
      requestHolidays: 'Solicitar Feriados',
      createHolidayTemplate: 'Criar template de Feriado',
      deleteHolidayTemplate: 'Excluir template de Feriado',
      activateProfileActivityCalendar: 'Definir Status de Perfil',
      addActivateTime: 'Adicionar Tempo para Ativação',
      sendTarrifPassiveCalendar: 'Enviar Calendário Passivo de Tarifas',
      requestActivateTimeProfilePassiveActivityCalendar:
        'Requisitar Tempo de Ativação Calendário Passivo',
      dmrcParams: 'Parâmetros Relacionados à Eletricidade',
      setDmrcActiveStatus: 'Definir Status de Perfil DMRC',
      setDmrcActivateTime: 'Adicionar Tempo para Ativação DMRC',
      requestDmrcDayProfilePassive: 'Requisitar Tempo de Ativação Calendário Passivo DMRC',
      addDmrcDayPassiveCalendar: 'Adicionar Dia Calendário Passivo DMRC',
      setDmrcSwitch: 'Setar switch DMRC e UFER',
      requestDmrcSwitch: 'Requisitar switch DMRC e UFER',
      readings: 'Parâmetros Relacionados a Demandas',
      recoverRegisters: 'Recuperar Registradores',
      getGeneralReadings: 'Recuperar Leituras',
    },
    daylightSavingTable: 'Horários cadastrados',
    finalDate: 'Data inicial',
    endDate: 'Data final',
    deviation: 'Desvio (minutos)',
    isEnable: 'Ativo',
    confirmDelete: 'Confirmar exclusão',
    deleteConfirmationMessage: 'Deseja realmente excluir este horário?',
    deleteTarrifConfirmationMessage: 'Deseja realmente excluir esta tarifa?',
    cancel: 'Cancelar',
    delete: 'Excluir',
    tarrifsTable: 'Tarifas Diárias',
    createDailyTariff: 'Criar tarifa diária',
    day: 'Dia',
    name: 'Nome',
    description: 'Descrição',
    meterProfile: 'Perfil do Medidor',
    numberOfSchedules: 'Qtd. Horários',
    activateProfileActivityCalendar: 'Definir Status de Perfil',
    serial: 'Serial',
    meter: 'Medidor',
    value: 'Valor',
    addTimeForActivation: 'Adicionar Tempo para Ativação',
    activationDateTime: 'Data e Hora de Ativação',
    save: 'Salvar',
    createDmrcCalendar: 'Criar Calendário DMCR',
    dayId: 'ID do Dia',
    annualHoliday: 'Feriado anual',
    time: 'Horário',
    dmcrType: 'Tipo DMCR',
    createHolidayTemplate: 'Criar Template de Feriado',
    deleteHolidayTemplate: 'Excluir Template de Feriado',
    index: 'Indice',
    holidayDate: 'Data do Feriado',
    addHoliday: 'Adicionar feriado',
    addIndex: 'Adicionar indice',
    createDailyTariffTemplate: 'Criar Template de Tarifa Diária',
    hourlyTariffs: 'Tarifas por horário',
    add: 'Adicionar',
    tariffType: 'Tipo de Tarifa',
    createTimePeriodTemplate: 'Criar Template de Período de Tempo',
    deviationMinutes: 'Desvio (minutos)',
    active: 'Ativo',
    dmcrSwitchConfiguration: 'Configuração do Switch DMCR',
    saturday: 'Sábado',
    sunday: 'Domingo',
    holiday: 'Feriado',
    workday: 'Dia Útil',
    capacitive: 'Capacitivo',
    inductive: 'Indutivo',
    send: 'Enviar',
    demandReading: 'Leitura de Demanda',
    demandTypes: 'Tipos de Demanda',
    selectDemands: 'Selecione as demandas',
    generalReadings: 'Leituras Gerais',
    readings: 'Leituras',
    selectReadings: 'Selecione as leituras',
    sendTariffPassiveCalendar: 'Enviar Calendário Passivo de Tarifas',
    dailyTariffs: 'Tarifas Diárias',
    confirm: 'Confirmar',
    startDate: 'Data de Início',
    addDmrcActivateTime: 'Adicionar Tempo para Ativação DMRC',
    setDmrcActiveStatus: 'Definir status de perfil DMRC',
    editDailyTariff: 'Editar Tarifa Diária',
    editTimePeriodTemplate: 'Editar Template de Data',
    createTimePeriod: {
      title: 'Substituir registro existente',
      message:
        'Este medidor já possui um período de tempo configurado. Deseja substituir o registro atual pelas novas informações?',
    },
  },
  errors: {
    unauthorized: 'Você não tem permissão para executar esta ação.',
    notImplemented: 'Ação indisponível no momento. Este método ainda não foi integrado ao sistema.',
    deviceNotIdentified:
      'Dispositivo não identificado. Verifique se o serial está cadastrado e tente novamente.',
    generic: 'Ocorreu um erro ao processar sua solicitação.',
  },
  demands: {
    0: 'Energia ativa importada total acumulada',
    1: 'Energia ativa importada acumulada na tarifa 1',
    2: 'Energia ativa importada acumulada na tarifa 2',
    3: 'Energia ativa importada acumulada na tarifa 3',
    4: 'Energia ativa importada acumulada na tarifa 4',
    5: 'Energia ativa exportada total acumulada',
    6: 'Energia ativa exportada acumulada na tarifa 1',
    7: 'Energia ativa exportada acumulada na tarifa 2',
    8: 'Energia ativa exportada acumulada na tarifa 3',
    9: 'Energia ativa exportada acumulada na tarifa 4',
    10: 'Demanda atual de energia ativa importada total',
    11: 'Demanda atual de energia ativa importada na tarifa 1',
    12: 'Demanda atual de energia ativa importada na tarifa 2',
    13: 'Demanda atual de energia ativa importada na tarifa 3',
    14: 'Demanda atual de energia ativa importada na tarifa 4',
    15: 'Demanda atual de energia ativa exportada total',
    16: 'Demanda atual de energia ativa exportada na tarifa 1',
    17: 'Demanda atual de energia ativa exportada na tarifa 2',
    18: 'Demanda atual de energia ativa exportada na tarifa 3',
    19: 'Demanda atual de energia ativa exportada na tarifa 4',
    20: 'Demanda máxima de energia ativa importada total',
    21: 'Demanda máxima de energia ativa importada na tarifa 1',
    22: 'Demanda máxima de energia ativa importada na tarifa 2',
    23: 'Demanda máxima de energia ativa importada na tarifa 3',
    24: 'Demanda máxima de energia ativa importada na tarifa 4',
    25: 'Demanda máxima de energia ativa exportada total',
    26: 'Demanda máxima de energia ativa exportada na tarifa 1',
    27: 'Demanda máxima de energia ativa exportada na tarifa 2',
    28: 'Demanda máxima de energia ativa exportada na tarifa 3',
    29: 'Demanda máxima de energia ativa exportada na tarifa 4',
  },
  generalReadings: {
    0: 'Estado da Bateria',
    1: 'Contador de faturamento fechado',
    2: 'Totalizador Direto Geral',
    3: 'Totalizador Direto Ponta',
    4: 'Totalizador Direto Fora-Ponta',
    5: 'Totalizador Direto Reservado',
    6: 'Totalizador Direto Direto 4o Posto',
    7: 'Totalizador Reverso Geral',
    8: 'Totalizador Reverso Ponta',
    9: 'Totalizador Reverso Fora-Ponta',
    10: 'Totalizador Reverso Reservado',
    11: 'Totalizador Reverso Reservado',
    12: 'Reativo Indutivo Direto Geral',
    13: 'Reativo Indutivo Direto Ponta',
    14: 'Reativo Indutivo Direto Fora-Ponta',
    15: 'Reativo Indutivo Direto Reservado',
    16: 'Reativo Indutivo Direto 4o Posto',
    17: 'Reativo Capacitivo Direto Geral',
    18: 'Reativo Capacitivo Direto Ponta',
    19: 'Reativo Capacitivo Direto Fora-Ponta',
    20: 'Reativo Capacitivo Direto Reservado',
    21: 'Reativo Capacitivo Direto 4o Posto',
    22: 'Reativo Indutivo Reverso Geral',
    23: 'Reativo Indutivo Reverso Ponta',
    24: 'Reativo Indutivo Reverso Fora-Ponta',
    25: 'Reativo Indutivo Reverso Reservado',
    26: 'Reativo Indutivo Reverso 4o Posto',
    27: 'Reativo Capacitivo Reverso Geral',
    28: 'Reativo Capacitivo Reverso Ponta',
    29: 'Reativo Capacitivo Reverso Fora-Ponta',
    30: 'Reativo Capacitivo Reverso Reservado',
    31: 'Reativo Capacitivo Reverso 4o Posto',
    32: 'Demanda Máxima Direto Total',
    33: 'Demanda Máxima Direto Ponta',
    34: 'Demanda Máxima Direto Fora-Ponta',
    35: 'Demanda Máxima Direto Reservado',
    36: 'Demanda Máxima Direto Tipo D',
    37: 'Demanda Acumulado Direto Total',
    38: 'Demanda Acumulado Direto Ponta',
    39: 'Demanda Acumulado Direto Fora-Ponta',
    40: 'Demanda Acumulado Direto Reservado',
    41: 'Demanda Acumulado Direto Tipo D',
    42: 'Demanda Máxima Reverso Ponta Total',
    43: 'Demanda Máxima Reverso Ponta',
    44: 'Demanda Máxima Reverso Fora-Ponta',
    45: 'Demanda Máxima Reverso Reservado',
    46: 'Demanda Máxima Reverso Tipo D',
    47: 'Demanda Acumulado Reverso Total',
    48: 'Demanda Acumulado Reverso Ponta',
    49: 'Demanda Acumulado Reverso Fora-Ponta',
    50: 'Demanda Acumulado Reverso Reservado',
    51: 'Demanda Acumulado Reverso Tipo D',
    52: 'Total',
    53: 'Ponta',
    54: 'Fora-Ponta',
    55: 'Reservado',
    56: 'Ponta',
    57: 'Fora-Ponta',
    58: 'Reservado',
    59: 'Ponta',
    60: 'Fora-Ponta',
    61: 'Reservado',
  },
  qualityParameters: {
    drpViolationsChartTitle: 'Medidores por Violação DRP',
    serial: 'Serial',
    installation: 'Instalação',
    selectPeriod: 'Selecionar Período',
    serialPlaceholder: 'Digite o serial do medidor',
    installationPlaceholder: 'Buscar por instalação',
    searching: 'Buscando...',
    noResults: 'Nenhum resultado encontrado',
    filters: 'Filtros',
    pendencies: 'Pendências',
    loading: 'Carregando',
    installationsAboveDicLimit: 'Instalações acima do limite de DIC',
    installationsAboveFicLimit: 'Instalações acima do limite de FIC',
    averageBaseDic: 'DIC Médio Base',
    averageBaseFic: 'FIC Médio Base',
    meterWithoutReadings: 'Medidores sem leituras',
    noData: 'Sem dados para ser exibidos',
    badInstalations: 'Instalações com Piores Indicadores',
    dic: 'DIC',
    fic: 'FIC',
    dicLimit: 'Limite de DIC',
    ficLimit: 'Limite de FIC',
    ficRegion: 'Região(FIC)',
    status: 'Status',
    drcViolation: 'Medidores por Violação DRC',
    categories: 'Categorias',
    tensionVariation: 'Variação Tensão Média Mensal',
    readingsByMonth: 'Leituras por Mês',
    drpDrcAverage: 'Média Mensal DRP/DRC',
    drpDrcViolations: 'Violação Média DRP/DRC',
    monthlyDicFic: 'Valor Mensal DIC/FIC',
    interruptions: 'Interrupção de Energia',
    installationsAboveDrpLimit: 'Instalações acima do limite de DRP',
    installationsAboveDrcLimit: 'Instalações acima do limite de DRC',
    averageBaseDrp: 'DRP Médio Base',
    averageBaseDrc: 'DRC Médio Base',
    drp: 'DRP Mensal(%)',
    drc: 'DRC Mensal(%)',
    drpLimit: 'Limite de DRP',
    drcLimit: 'Limite de DRC',
    drpViolation: 'Violação DRP Mensal(%)',
    drcViolationT: 'Violação DRC Mensal(%)',
    statusGood: 'Bom',
    statusAdequate: 'Adequada',
    statusPrecarious: 'Precária',
    statusCritical: 'Crítica',
    drpUpTo20: 'DRP até 20%',
    drpUpTo40: 'DRP até 40%',
    drpUpTo60: 'DRP até 60%',
    drpUpTo80: 'DRP até 80%',
    drpUpTo100: 'DRP 100%',
    drcUpTo20: 'DRC até 20%',
    drcUpTo40: 'DRC até 40%',
    drcUpTo60: 'DRC até 60%',
    drcUpTo80: 'DRC até 80%',
    drcUpTo100: 'DRC 100%',
    noInformation: 'Sem Informação',
    selectCategories: 'Selecionar categorias',
    state: 'Estado',
    city: 'Cidade',
    selectState: 'Selecione o estado',
    selectCity: 'Selecione a cidade',
    clear: 'Limpar',
    apply: 'Aplicar',
    averageVoltage: 'Tensão Média',
    readings: 'Leituras',
    voltage: 'Tensão',
    viewChart: 'Ver Gráfico',
    viewTable: 'Ver Tabela',
    exportMonthlySummary: 'Exportar Sumário Mensal',
    byMonth: 'Por Mês',
    byWeek: 'Por Semana',
    meters: 'Medidores',
    day: 'Dia',
    week: 'Semana',
    drpPercent: 'DRP %',
    drcPercent: 'DRC %',
    drcViolationPercent: 'VIOLAÇÃO DRC %',
    drpViolationPercent: 'VIOLAÇÃO DRP %',
    dicHours: 'DIC (Horas)',
    dmicHours: 'DMIC (Horas)',
    drpBand20: 'DRP até 20%',
    drpBand40: 'DRP até 40%',
    drpBand60: 'DRP até 60%',
    drpBand80: 'DRP até 80%',
    drpBand100: 'DRP 100%',
    drcBand20: 'DRC até 20%',
    drcBand40: 'DRC até 40%',
    drcBand60: 'DRC até 60%',
    drcBand80: 'DRC até 80%',
    drcBand100: 'DRC 100%',
    averageV: 'Média (V)',
    phaseA: 'Fase A (V)',
    phaseB: 'Fase B (V)',
    phaseC: 'Fase C (V)',
    violationDrc: 'Violação DRC',
    violationDrp: 'Violação DRP',
    totalFicEvents: 'Total FIC (Eventos)',
    meterQuantity: 'Qtd. Medidores',
    dicHoursCompact: 'DIC (Horas)',
    dmicHoursCompact: 'DMIC (Horas)',
    detailedIndicators: 'Indicadores Detalhados',
    detailedDrpDrcViolations: 'Violações DRP/DRC Detalhadas',
    detailedDicFic: 'Detalhamento DIC/FIC',
    detailedTensionLevels: 'Níveis de Tensão Detalhados',
    averageDrp: 'DRP Médio',
    averageDrc: 'DRC Médio',
    createdAt: 'Data de Criação',
    manufacturer: 'Fabricante',
    model: 'Modelo',
    dateTime: 'Data/Hora',
    voltageReading: 'Leitura de Tensão',
    generalV: 'Geral (V)',
  },
}
